import _ from "lodash";
import { OTP_ERROR } from "../actions/error_types";
import moment from "moment";
import { THREAT_SEVERITY_ARRAY, WAN_ARRAY,DEFAULT_REPORT_TYPES } from "../constants/Constants";
import {
  SET_SIDE_MENU,
  FETCH_DP_WISE_SIDEMENU,
  FETCH_DP_WISE_SIDEMENU_LOADING,
  SET_USER_OU,
  SET_SELECTED_OU,
  SET_IS_USER_OU_HAS_SUB_OUS,
  SET_PARENT_AND_SUBDP_LIST,
  SET_SELECTED_VESSELS,
  SET_FILTERED_VESSELS,
  SET_HUB_FILTERED_VESSELS,
  SET_SELECTED_VESSEL,
  SET_SELECTED_AGENT,
  SET_PERMISSION_OBSERVER,
  LOGIN_USER,
  LOGOUT_USER,
  FETCH_VESSEL,

  SET_FETCH_USERS_LOADING,
  IS_PRIVATE_LOADING,
  IS_PRIVATE_ENABLED,
  FETCH_USERS,

  SET_LOADING,

  INVITE_USER_LOADING,
  INVITE_USER,

  RESEND_INVITE_LOADING,
  RESEND_INVITE,

  GET_ORGANISATIONS,

  SET_VESSEL_PLANS_LOADING,
  GET_VESSEL_PLANS,
  SET_VESSEL_LISTING_LOADING,

  GET_USER_POLICY,

  SET_SEARCH_ALERTS_LOADING,
  SEARCH_ALERTS,

  OU_DERIVED,
  GET_VESSEL_EDGE_INFO,

  SET_FETCH_OU_RESOURCES_LOADING,
  FETCH_OU_RESOURCES,

  OU_POLICY,

  USER_DETACH_LOADING,
  USER_DETACH,

  USER_DELETE_LOADING,
  USER_DELETE,

  SET_TICKETS_LOADING,
  GET_TICKETS,

  DISPLAY_APPLICABLE_USER_POLICIES,
  POLICIES_DETAILS,

  UPDATE_USER_LOADING,
  UPDATE_USER,

  UPDATE_USER_ORGANIZATION_LOADING,
  UPDATE_USER_ORGANIZATION,

  ACCOUNT_CREATE_SUB_DP,
  SET_SUB_DP_CREATE_LOADING,
  SET_DELETE_ORG_LOADING,
  GET_DELETE_ORG,
  SET_MODIFY_ORG_LOADING,
  GET_MODIFY_ORG,
  SET_DP_INFO_LOADING,
  GET_DP_INFO,
  
  GET_TICKET_DETAILS,
  GET_HOT_VESSELS,
  SEND_TICKET_EMAIL,
  GET_TICKET_COMMENTS,
  GET_TICKET_ATTACHMENTS,
  SET_TICKET_ATTACHMENTS_LOADING,
  SET_TICKET_COMMENTS_LOADING,
  GET_SINGLE_TICKET_ATTACHMENTS,
  GET_TICKET_DETAILS_FIELD,
  SET_TICKET_DETAILS_FIELD_LOADING,
  UPDATE_TICKET,
  CREATE_NEW_TICKET,
  ADD_ATTACHMENTS_TO_TICKET,
  SEND_TICKET_COMMENT,
  GET_TICKET_HISTORY,
  SET_TICKET_HISTORY_LOADING,
  SET_TICKET_DETAILS_LOADING,
  GET_TICKET_AGENTS_BY_NAME,
  GET_TICKET_ALL_AGENTS,
  GET_DP_DATA,

  ENABLE_USER_ACCOUNT_LOADING,
  ENABLE_USER_ACCOUNT,

  DISABLE_USER_ACCOUNT_LOADING,
  DISABLE_USER_ACCOUNT,

  SET_VESSEL_ALERTS_LOADING,
  GET_VESSEL_ALERTS,

  SET_VESSEL_DASHBOARD_LOADING,
  GET_VESSEL_SUMMARY_DASHBOARD,

  SET_VESSEL_SUMMARY_LOADING,
  SET_VESSEL_TABLE_COUNT_LOADING,
  GET_VESSEL_SUMMARY_TABLE,

  GET_VESSEL_LOC_WITH_ALERTS_LOADING,
  GET_VESSEL_LOC_WITH_ALERTS,

  DELETE_ALERT,
  DELETE_ALERT_LOADING,

  GET_DP_ALERTS,
  UPDATE_DP_ALERT,
  UPDATE_DP_ALERT_NOTIFICATION,
  UPDATE_DP_ALERT_STATUS,
  DELETE_DP_ALERT_LINK_AVAILABILITY,
  GET_DP_ALERT_AUDIT_LOGS,
  GET_DP_ALERTS_LOADING,
  UPDATE_DP_ALERT_LOADING,
  UPDATE_DP_ALERT_NOTIFICATION_LOADING,
  UPDATE_DP_ALERT_STATUS_LOADING,
  DELETE_DP_ALERT_LINK_AVAILABILITY_LOADING,
  GET_DP_ALERT_AUDIT_LOGS_LOADING,

  GET_SITE_ALERTS,
  GET_SITE_ALERTS_LOADING,
  UPDATE_SITE_ALERT,
  UPDATE_SITE_ALERT_LOADING,
  UPDATE_SITE_ALERT_NOTIFICATION,
  UPDATE_SITE_ALERT_NOTIFICATION_LOADING,
  DELETE_SITE_ALERT_LINK_AVAILABILITY,
  DELETE_SITE_ALERT_LINK_AVAILABILITY_LOADING,
  GET_SITE_ALERT_AUDIT_LOGS,
  GET_SITE_ALERT_AUDIT_LOGS_LOADING,
  UPDATE_SITE_ALERT_STATUS,
  UPDATE_SITE_ALERT_STATUS_LOADING,

  MARK_AS_FIXED_ALERT,
  ALERTS_NAME,
  ALERTS_HISTORY,
  GET_SYSTEM_INVENTORY,
  GET_EDGE_SERVER_STATUS,
  RECOVERY_PASSWORD_USER,
  CHANGE_PASSWORD,

  SET_PASSWORD_User_LOADING,
  SET_PASSWORD_User,

  GET_USER_DETAILS,
  UPDATE_USER_PROFILE,
  USER_PREFERENCES_LOADING,
  UPDATE_USER_PREFERENCES,
  GET_USER_PREFERENCES,
  USER_TIMEZONE,
  RESET_STATE,
  DETACH_RESOURCE_OU,
  NOT_ATTACH_RESOURCE_OU,
  ATTACH_RESOURCE_OU,
  GET_VESSEL_EDGE_TOPOLOGY_PRODUCTS,
  GET_PRODUCT_EDGE_TOPOLOGY_DEVICES,
  GET_PARENT_DEVICE_OF_A_SITE,
  UPDATE_PARENT_DEVICE_OF_A_SITE,
  GET_ORGANISATIONS_UNITS,
  SOFTWARE_PRODUCT,
  SET_SOFTWARE_LISTING_LOADING,
  SOFTWARE_LISTING,
  ALL_TEMPLATE,
  GET_VESSELS_LISTING,
  GET_CONFIGURED_ALERTS_FOR_DEVICE,
  UPDATE_CREATE_DEVICE_ALERT_CONFIGURATION,
  UPDATE_DELETE_DEVICE_ALERT_CONFIGURATION,
  UPDATE_DEVICE_ALERT_CONFIGURATION_SETTINGS,
  GET_VESSEL_SUMMARY_TOPOLOGY,
  SET_LINK_STATUS_PER_DEVICE_LOADING,
  GET_LINK_STATUS_PER_DEVICE,
  GET_SEARCH_DP_LIST,

  GET_SOFTWARE_VERSIONS_DEVICE_COUNT,
  GET_SOFTWARE_VERSION_DEVICE_DETAILS,
  GET_SOFT_VERSION_DEVICE_DETAILS,
  GET_KONNECT_APP_DOWNLOAD_LINKS,
  GET_VX_BUILD_DETAILS,
  GET_DP_DOCUMENTS_LIST,
  
  GET_USER_LOGIN_HISTORY,

  GET_SIM_BOX,
  GET_SIM_BOXES,
  GET_SIM_BOXES_COUNT,
  GET_LTE_PROVIDERS,
  GET_DATA_USAGE,
  GET_DATA_USAGE_COUNT,
  GET_DAILY_DATA_USAGE,
  SET_CELLULAR_DATA_USAGE_LOADING,
  GET_GRAPHICAL_DATA_USAGE,
  GET_CELLULAR_DATA_USAGE,
  GRAPHICAL_DATA_USAGE_LOADING,
  EXPORT_DATA_USAGE_REPORT,
  GET_USAGE_VESSEL_LIST,

  SET_EDGE_EVENTS_LOADING,
  SET_EDGE_EVENTS_FILTER_LOADING,
  SET_EDGE_EVENTS_TABLE_LOADING,
  SET_EDGE_EVENTS_TABLE_COUNT_LOADING,
  GET_EDGE_EVENTS,
  GET_EDGE_EVENTS_FILTER,
  GET_EDGE_EVENTS_FILTER_TEMP,
  GET_EDGE_SERVER_STATUS_LOADING,
  GET_EDGE_EVENTS_TABLE,
  GET_EDGE_EVENTS_TABLE_COUNT,
  DOWNLOAD_EDGE_EVENTS_TABLE,
  CLEAR_EDGE_EVENTS,

  SET_SITE_CHARTS_RSSI_LOADING,
  SET_SITE_CHARTS_SINR_LOADING,
  SET_SITE_CHARTS_LINK_STATUS_LOADING,
  SET_SITE_CHARTS_LATENCY_JITTER_LOADING,
  SET_SITE_CHARTS_THROUGHPUT_LOADING,
  SET_SITE_CHARTS_VSAT_SNR_LOADING,
  SET_SITE_CHARTS_VSAT_TXPOWER_LOADING,
  SET_SITE_CHARTS_VSAT_POWER_LOADING,
  SET_SITE_CHARTS_VSAT_SYMBOL_RATE_LOADING,
  SET_SITE_CHARTS_SITE_INTERFACES_LOADING,
  SET_SITE_CHARTS_SITE_DATA_RATE_LOADING,
  GET_SITE_RSSI,
  GET_SITE_SINR,
  GET_SITE_DATA_RATE,
  GET_SITE_LINK_STATUS,
  GET_SITE_LATENCY_JITTER,
  GET_SITE_VSAT_SNR,
  GET_SITE_VSAT_TXPOWER,
  GET_SITE_VSAT_POWER,
  GET_SITE_VSAT_SYMBOL_RATE,
  GET_SITE_THROUGHPUT,
  GET_SITE_INTERFACES,
  CLEAR_SITE_CHARTS,
  GET_SITE_CLIENTS,
  GET_SITE_USAGE,
  GET_SITE_SYSTEM_UPTIME,
  SET_SITE_CLIENTS_LOADING,
  SET_SITE_USAGE_LOADING,
  SET_SITE_SYSTEM_UPTIME_LOADING,
  SET_SITE_LAN_STATUS_LOADING,
  GET_SITE_LAN_STATUS,

  SET_INVENTORY_LISTING_LOADING,
  SET_DEPLOYED_LISTING_LOADING,
  SET_DEPLOYED_LISTING_COUNT_LOADING,
  SET_T0_AND_OPEN_EDGE_LOADING,
  GET_TRAFFIC_POLICY_LISTING_LOADING,
  GET_POLICY_ROUTE_LIST_LOADING,
  GET_WAN_PROFILE_LISTING_LOADING,
  GET_POP_IPS_LISTING_LOADING,
  APPLY_TRAFFIC_POLICY_LOADING,
  APPLY_POLICY_ROUTE_LOADING,
  GET_TRAFFIC_POLICY_LOG_LIST_LOADING,
  APPLY_FIREWALL_RULE_LOADING,
  APPLY_WAN_PROFILE_LOADING,
  APPLY_HUB_IP_CONFIG_LOADING,
  COPY_QUOTA_CONFIG_LOADING,
  GET_INVENTORY_DEPLOYED_DATA,
  GET_T0_AND_OPEN_EDGE_DATA,
  DOWNLOAD_INVENTORY_DEPLOYED_DATA,
  GET_INVENTORY_WAREHOUSE_TABLE_DATA,
  INVENTORY_WAREHOUSE_CHANGE_GROUP,
  GET_INVENTORY_WAREHOUSE_VESSEL_LIST,
  SET_ASSIGN_INVENTORY_TO_VESSEL,
  ASSIGN_INVENTORY_TO_VESSEL,
  GET_LICENSE_TYPES,
  SET_LICENSE_TYPES,
  GET_DPS_DEFAULT_ACTIVE_CONFIG,
  CREATE_AND_ASSIGN_INVENTORY,
  SET_INVENTORY_ASSIGN_DEVICE_TO_WAREHOUSE,
  INVENTORY_ASSIGN_DEVICE_TO_WAREHOUSE,
  INVENTORY_DELETE_SITE,
  INVENTORY_TOP_WIDGETS_REGISTERED_COUNT,
  INVENTORY_TOP_WIDGET_KAAS_COUNT,
  INVENTORY_TOP_WIDGETS_WAREHOUSE_COUNT,
  INVENTORY_DOWNLOAD_CONFIG,
  INVENTORY_CHANGE_GROUP,
  GET_CONFIG_PRODUCTS,
  APPLY_GOLDEN_CONFIG,
  APPLY_TRAFFIC_POLICY,
  APPLY_POLICY_ROUTE,
  APPLY_FIREWALL_RULE,
  APPLY_WAN_PROFILE,
  APPLY_HUB_IP_CONFIG,
  GET_TRAFFIC_POLICY_LOG_LIST,
  GET_WAN_PROFILE_LIST,
  GET_POP_IPS_LIST,
  BACKUP_CONFIG_NOW,
  DEVICE_LATEST_EOS_VERSION,
  GET_DEVICE_LIST,
  GET_DP_DEVICES,
  CREATE_INVENTORY_GROUP,
  UPDATE_INVENTORY_GROUP,
  DELETE_INVENTORY_GROUP,
  GET_TRAFFIC_POLICY_LIST,
  GET_POLICY_ROUTE_LIST,
  GET_TRAFFIC_POLICY_LIST_V3,
  GET_TRAFFIC_POLICY_LIST_V4,
  GET_TRAFFIC_POLICY_LIST_V5,
  GET_INVENTORY_GROUP_LIST,
  GET_INVENTORY_GROUP_LIST_COUNT,
  GET_SITE_INFO_LIST,
  GET_SITE_INFO_LIST_COUNT,
  GET_BACKUP_CONFIG_DATA,
  SET_BACKUP_CONFIG_DATA_LOADING,
  COPY_CONFIG_TO_MANUAL_BACKUP,
  DELETE_MANUAL_BACKUP_CONFIG,
  GET_DEFAULT_CONFIG_LISTING,
  EDIT_DEFAULT_CONFIG,
  CREATE_DEFAULT_CONFIG,
  DELETE_DEFAULT_CONFIG,
  GET_DEFAULT_PRODUCTS,
  GET_CONFIG_SOFTWARE_VERSIONS,
  GET_CONFIG_STATUS,
  GET_GROUP_TRANSCATION_CONFIG_STATUS,
  SET_CONFIG_STATUS_DOWNLOAD_LOADING,
  SET_DEVICE_STATUS_DOWNLOAD_LOADING,
  GET_DP_LIST,
  GET_WIDGEY_SUMMARY_DASHBOARD,
  GET_TOP_WIDGET_WANLINK_STATUS_NEW_SUMM,
  GET_WIDGET_LINK_STATUS_SUMMARY_DASHBOARD,
  GET_NEW_SUMMARY_USAGE_TABLE,
  GET_VESSEL_SUMMARY_TABLE_COUNT,
  GET_INVENTORY_DEPLOYED_DATA_COUNT,
  DELETE_SITE_CHART_SERIES,
  CLEAR_SITE_CHART_EVENTS,
  UPDATE_NAME,
  VESSEL_ADDRESS_MMSI,
  GET_VESSEL_INFO,
  UPDATE_MMSI_AND_STREETADDRESS,
  SET_DEVICE_HISTORY_LOADING,
  GET_DEVICE_HISTORY,
  SET_DEVICE_CONFIG_ACTION_LOGS_LOADING,
  GET_DEVICE_CONFIG_ACTION_LOGS,
  SET_DEVICE_EOS_HISTORY_EVENTS_LOADING,
  GET_DEVICE_EOS_HISTORY_EVENTS,
  SET_UPGRADE_INVENTORY_LICENSE_LOADING,
  GET_UPGRADE_INVENTORY_LICENSE,
  SET_DEVICE_LICENSE_HISTORY_LOADING,
  GET_DEVICE_LICENSE_HISTORY,
  IS_INVENTORY_PREVIOUS_PAGE,
  SET_UPGRADE_WAREHOUSE_DEVICE_TO_LATEST_EOS_VERSION_LOADING,
  UPGRADE_WAREHOUSE_DEVICE_TO_LATEST_EOS_VERSION,
  GET_WIFI_INTERFACES,
  SET_WIFI_INTERFACES_LOADING,
  GET_ALL_INTERFACES,
  SET_ALL_INTERFACES_LOADING,
  GET_ALL_NETWORKS,
  SET_ALL_NETWORKS_LOADING,
  DELETE_INTERFACE,
  DELETE_INTERFACE_LOADING,
  DELETE_LAN,
  DELETE_LAN_LOADING,
  DELETE_WIFI,
  DELETE_WIFI_LOADING,
  GET_PHYSICAL_INTERFACES,
  GET_PHYSICAL_INTERFACES_LOADING,
  ADD_WAN_INTERFACE,
  ADD_WAN_INTERFACE_LOADING,
  UPDATE_WAN_INTERFACE,
  UPDATE_WAN_INTERFACE_LOADING,
  GET_WAN_PROFILES,
  SET_WAN_PROFILES_LOADING,
  GET_WAN_PROFILE_DETAILS,
  SET_WAN_PROFILE_DETAILS_LOADING,
  ENABLE_DISABLE_INTERFACE,
  ENABLE_DISABLE_INTERFACE_LOADING,
  ENABLE_DISABLE_DHCP,
  ENABLE_DISABLE_DHCP_LOADING,
  GET_FILTERED_NETWORKS,
  GET_FILTERED_NETWORKS_LOADING,
  GET_FREE_LAN_ACCESS_INTERFACES,
  GET_FREE_LAN_ACCESS_INTERFACES_LOADING,
  GET_ROUTER_DIDS,
  GET_ROUTER_DIDS_LOADING,
  GET_REGISTER_DEVICE,
  GET_REGISTER_DEVICE_LOADING,
  GET_DEREGISTER_DEVICE,
  GET_DEREGISTER_DEVICE_LOADING,
  GET_DEVICE_DETAILS,
  GET_DEVICE_DETAILS_LOADING,
  GET_SEARCH_DIDS,
  GET_SEARCH_DIDS_LOADING,
  GET_SWAP_MODE,
  GET_SWAP_MODE_LOADING,
  GET_DEVICE_TRANSFER,
  GET_DEVICE_TRANSFER_LOADING,
  GET_DEVICE_LINK_STATUS,
  GET_DEVICE_LINK_STATUS_LOADING,
  GET_LAN_TRUNK_FILTERED_NETWORKS_LOADING,
  GET_LAN_TRUNK_FILTERED_NETWORKS,
  GET_SAVED_WAN_PROFILE_DATA,
  UPDATE_SYNC_CHECK_STATUS,
  SET_CANCEL_DE_REGISTER,
  GET_CANCEL_DE_REGISTER,
  GET_STATIC_ROUTES_LOADING,
  GET_STATIC_ROUTES,
  DELETE_STATIC_ROUTE_LOADING,
  DELETE_STATIC_ROUTE,
  GET_ALL_WAN_INTERFACES_FOR_ADV_SETTINGS_LOADING,
  GET_ALL_WAN_INTERFACES_FOR_ADV_SETTINGS,
  GET_ENABLE_DISABLE_NO_NAT_LOADING,
  GET_ENABLE_DISABLE_NO_NAT,
  GET_LAN_IP_RANGES_LOADING,
  GET_LAN_IP_RANGES,
  GET_ALL_PORT_CONFIGS_LOADING,
  GET_ALL_PORT_CONFIGS,
  GET_ADD_EDIT_PORT_CONFIG_LOADING,
  GET_ADD_EDIT_PORT_CONFIG,
  GET_DELETE_PORT_CONFIG_LOADING,
  GET_DELETE_PORT_CONFIG,
  GET_DHCP_RESERVATIONS_LOADING,
  GET_DHCP_RESERVATIONS,
  GET_DELETE_DHCP_RESERVATION_LOADING,
  GET_DELETE_DHCP_RESERVATION,
  GET_ALL_FIREWALL_RULES_LOADING,
  GET_ALL_FIREWALL_RULES,
  GET_INTERFACES_FIREWALL_RULES_LOADING,
  GET_INTERFACES_FIREWALL_RULES,
  GET_ADD_EDIT_FIREWALL_RULE_LOADING,
  GET_ADD_EDIT_FIREWALL_RULE,
  GET_ENABLE_DISABLE_FIREWALL_RULE_LOADING,
  GET_ENABLE_DISABLE_FIREWALL_RULE,
  GET_ENABLE_DISABLE_PORT_FORWARD_LOADING,
  GET_ENABLE_DISABLE_PORT_FORWARD,
  GET_DELETE_FIREWALL_RULE_LOADING,
  GET_DELETE_FIREWALL_RULE,
  GET_ENABLE_DISABLE_DNS_CASHE_LOADING,
  GET_ENABLE_DISABLE_DNS_CASHE,
  GET_LAN_MULTICAST_LOADING,
  GET_LAN_MULTICAST,
  GET_SET_LAN_MULTICAST_LOADING,
  GET_SET_LAN_MULTICAST,
  GET_DNS_PROXY_CONFIG_LOADING,
  GET_DNS_PROXY_CONFIG,
  GET_DELETE_DNS_PROXY_CONFIG_LOADING,
  GET_DELETE_DNS_PROXY_CONFIG,
  GET_IP_CONFIG_UPDATE_LOADING,
  GET_IP_CONFIG_UPDATE,
  SET_FIREWALL_RULE_PRIORITY_LOADING,
  SET_PAUSE_LICENSE,
  GET_PAUSE_LICENSE,
  SET_RESUME_LICENSE,
  GET_RESUME_LICENSE,
  SET_WH_ProdGP_DEVICE_LIST,
  GET_WH_ProdGP_DEVICE_LIST,
  SET_TRANSFER_LICENSE_LOADING,
  GET_TRANSFER_LICENSE,
  SET_CANCEL_PAUSE_LICENSE_LOADING,
  GET_CANCEL_PAUSE_LICENSE,
  SET_INVENTORY_SYNC_DATA,
  GET_INVENTORY_SYNC_DATA,
  TRACK_INVENTORY_SYNC_DATA,
  SET_ATTACH_DEVICE_TO_SITE_LOADING,
  GET_ATTACH_DEVICE_TO_SITE,
  SET_CREATE_SHARE_CONFIG_LOADING,
  CREATE_SHARE_CONFIG,
  SET_SHARED_CONFIG_PER_CONFIG_LOADING,
  GET_SHARED_CONFIG_PER_CONFIG,
  SET_UPDATE_SHARED_CONFIG_LOADING,
  UPDATE_SHARED_CONFIG,
  SET_DELETE_SHARED_CONFIG_LOADING,
  DELETE_SHARED_CONFIG,

  HIGH_AVAILABILITY,
  GET_HIGH_AVAILABILITY_DEVICE,
  GETTING_HA,
  CREATE_HA,
  CREATING_HA,
  SYNC_DEVICE,
  SYNCING_DEVICE,
  UPDATE_DEVICE,
  UPDATING_DEVICE,

  SET_ACTIVITY_REPORTS_LOADING,
  SET_ACTIVITY_REPORTS_APPS_LOADING,
  SET_ACTIVITY_REPORTS_VLANS_LOADING,
  SET_ACTIVITY_REPORTS_WIDGET_LOADING,
  SET_ACTIVITY_REPORTS_CATEGORY_PIE_LOADING,
  SET_ACTIVITY_REPORTS_APPLICATION_PIE_LOADING,
  SET_ACTIVITY_REPORTS_USAGE_LINE_CHART_LOADING,
  SET_ACTIVITY_REPORTS_TOP_APP_LINE_CHART_LOADING,
  SET_ACTIVITY_REPORTS_TOP_USERS_LOADING,
  SET_ACTIVITY_REPORTS_TOP_SITES_LOADING,
  GET_ALL_USERNAMES,
  GET_USAGE_WIDGETS,
  GET_USAGE_TABLE_DATA,
  GET_LINE_CHART_USAGE,
  GET_CATEGORY_PIE_CHART_USAGE,
  GET_TOP_APPLICATION_LINE_CHART,
  GET_TOP_SITES_TABLE_DATA,
  GET_TOP_APP_TOP_BLOCKED_PIE_CHART,
  GET_TOP_DOWNLOAD_UPLOAD_BLOCKED_APPLICATION,
  GET_TOP_DOWNLOAD_UPLOAD_BLOCKED_DOMAIN,
  GET_TOP_DOWNLOAD_UPLOAD_BLOCKED_IP,
  SET_ACTIVITY_REPORTS_BOTTOM_TABLE_LOADING,
  SET_ACTIVITY_REPORTS_BOTTOM_TABLE_DOMAIN_LOADING,
  SET_ACTIVITY_REPORTS_BOTTOM_TABLE_IP_LOADING,
  GET_ACTIVITY_REPORTS_CONTENT_FILTERS_TABLE,
  GET_TOP_BLOCKED_APP_BOTTOM_TABLE,
  SET_REPORTS__TOP_BLOCKED_APP_BOTTOM_TABLE_LOADING,
  GET_ALL_APPLICATIONS,
  GET_ALL_VLANS,
  GET_DPI_REPORTS_USER_MAX_RISK_TYPES,
  SET_DPI_REPORTS_TOP_WIDGET_ALLSITE_RISK,
  GET_DPI_REPORTS_TOP_WIDGET_ALLSITE_RISK,
  GET_DPI_REPORTS_TOP_WIDGET_SINGLESITE_RISK,
  SET_DPI_REPORTS_PIE_CHART_ALLSITE_RISK,
  GET_DPI_REPORTS_PIE_CHART_ALLSITE_RISK,
  GET_DPI_REPORTS_PIE_CHART_SINGLESITE_RISK,

  CREATE_DOWNLOAD_SERVICE,
  SET_GENERATED_REPORTS_TABLE_LOADING,
  SET_GENERATED_REPORTS_TABLE_COUNT_LOADING,
  GET_GENERATED_REPORTS_TABLE,
  GET_GENERATED_REPORTS_TABLE_COUNT,
  CREATE_DOWNLOAD_SERVICE_FIREWALL,

  AUDIT_LOGS,
  DELETE_HIGH_AVAILABILITY,
  DELETING_HA,
  GET_SIM_BOXES_LOADING,
  DOMAIN_NAME,
  DOMAIN_CONFIG,
  GET_FIREALL_WIDGETS,
  GET_FIREWALL_ACTIONS_TODAY_GRAPH,
  GET_FIREWALL_RULE_NAME_GRAPH,
  GET_FIREWALL_TABLE_DATA,
  GET_FIREWALL_RULE_NAME_FILTER,
  GET_FIREWALL_TABLE_DATA_COUNT,
  GET_FIREWALL_LINE_CHART,
  CLEAR_SITE_DASHBOARD,
  SET_LOADING_FIREWALL_COUNTS,
  SET_LOADING_FIREWALL_LINECHART,
  SET_LOADING_FIREWALL_PIE_RULENAME,
  SET_LOADING_FIREWALL_RISTRICT_PIECHART,
  SET_LOADING_FIREWALL_RULE_FILTER,
  SET_LOADING_FIREWALL_TABLE_DATA,
  SET_LOADING_FIREWALL_WIDGETS,
  OTP_GENERATION_STATUS,
  GET_TOP_WIDGET_AVAILABILITY,
  GET_TOP_WIDGET_DATA_NEW_SUMM,

  SET_IAM_LOGIN_HISTORY_TABLE,
  SET_IAM_LOGIN_HISTORY_TABLE_COUNT,
  SET_IAM_LOGIN_HISTORY_TOP_WIDGET,
  SET_IAM_LOGIN_HISTORY_TIMESERIES_CHART,
  SET_IAM_LOGIN_HISTORY_FILTER_USER,
  SET_IAM_LOGIN_HISTORY_FILTER_APP,
  SET_IAM_LOGIN_HISTORY_FILTER_DESC_LIST,
  GET_IAM_LOGIN_HISTORY_TABLE,
  GET_IAM_LOGIN_HISTORY_TABLE_COUNT,
  GET_IAM_LOGIN_HISTORY_TOP_WIDGET,
  GET_IAM_LOGIN_HISTORY_TIMESERIES_CHART,
  GET_IAM_LOGIN_HISTORY_FILTER_USER,
  GET_IAM_LOGIN_HISTORY_FILTER_APP,
  GET_IAM_LOGIN_HISTORY_FILTER_DESC_LIST,
  GET_MAINTENANCE_INFO,
  VERIFY_USER,
  RESET_PASSWORD,
  GET_GROUP_SETTINGS_DATA,
  UPDATE_GROUP_SETTINGS_DATA,
  GET_SENDGRID_TABLE_DATA,
  CREATE_SMTP_EMAIL_DATA,
  GET_SMTP_EMAIL_DATA,
  GET_MICROSOFT_GRAPH_EMAIL_DATA,
  CREATE_MICROSOFT_GRAPH_EMAIL_DATA,
  SET_SENDGRID_DATA_LOADING,
  CREATE_DNS_DATA,
  VERIFY_DNS_DATA,
  SEND_TEST_EMAIL,
  SMTP_TEST_EMAIL,
  MS_GRAPH_TEST_EMAIL,
  SMTP_DATA_DELETE,
  MSGRAPH_DATA_DELETE,
  SENDGRID_DATA_DELETE,
  ACTIVATE_SENDGRID,
  ACTIVATE_SMTP,
  ACTIVATE_MSGRAPH,

  SAVE_SSO_CONFIG,
  UPDATE_SSO_CONFIG,
  DELETE_SSO_CONFIG,
  VERIFY_SSO_CONNECTION,
  FETCH_SSO_ORGANIZATIONS,
  SET_SSO_ORGANIZATIONS_LOADING,
  SET_DOMAIN_SSO_CHECK,
  SET_SSO_CODE,

  SET_CF_TOP_USERS_TABLE_LOADING,
  SET_CF_TOP_USERS_TABLE_COUNT_LOADING,
  SET_CF_TOP_SITES_TABLE_LOADING,
  SET_CF_TOP_SITES_TABLE_COUNT_LOADING,
  SET_CF_CATEGORY_PIE_LOADING,
  SET_CF_APPLICATION_PIE_LOADING,
  SET_CF_SUBCAT_PIE_LOADING,
  SET_CF_LINECHART_LOADING,
  SET_CF_TW_TOP_SITE_LOADING,
  SET_CF_TW_TOP_USER_LOADING,
  SET_CF_TW_TOP_CATEGORY_LOADING,
  SET_CF_TW_TOP_DOMAIN_LOADING,
  SET_CF_CATEGORY_LIST_LOADING,
  SET_CF_APP_LIST_LOADING,
  SET_CF_USER_LIST_LOADING,
  SET_CF_VLAN_LIST_LOADING,
  SET_CF_DEVICE_LIST_LOADING,
  SET_CF_SUb_CATEGORY_LIST_LOADING,
  GET_CF_TOP_USERS_TABLE,
  GET_CF_TOP_USERS_TABLE_COUNT,
  GET_CF_TOP_SITES_TABLE,
  GET_CF_TOP_SITES_TABLE_COUNT,
  GET_CF_CATEGORY_PIE,
  GET_CF_APPLICATION_PIE,
  GET_CF_SUBCAT_PIE,
  GET_CF_LINECHART,
  GET_CF_TW_TOP_SITE,
  GET_CF_TW_TOP_USER,
  GET_CF_TW_TOP_CATEGORY,
  GET_CF_TW_TOP_DOMAIN,
  GET_CF_CATEGORY_LIST,
  GET_CF_APP_LIST,
  GET_CF_USER_LIST,
  GET_CF_VLAN_LIST,
  GET_CF_DEVICE_LIST,
  GET_CF_SUB_CATEGORY_LIST,
  UPDATE_NEW_SUMMARY_START_DATE,
  UPDATE_NEW_SUMMARY_END_DATE,
  UPDATE_NEW_SUMMARY_WAN_TYPE,
  GET_DRAWER_OPEN,
       
  SET_DASHBOARD_PIE_USAGEPER_WANTYPE_LOADING,
  SET_DASHBOARD_HISTORGRAM_USAGEPER_WANTYPE_LOADING,
  SET_DASHBOARD_HISTORGRAM_USAGEPER_SITE_LOADING,
  SET_DASHBOARD_USAGE_PIE_TOP10_APPS_LOADING,
  SET_DASHBOARD_PIE_WAN_USAGE_BYSITE_LOADING,
  SET_DASHBOARD_USAGE_HISOGRAM_UPLINK_DLK_LOADING,
  SET_DASHBOARD_USAGE_HISTOGRAM_BYSITE_LOADING,
  GET_DASHBOARD_PIE_USAGEPER_WANTYPE,
  GET_DASHBOARD_HISTORGRAM_USAGEPER_WANTYPE,
  GET_DASHBOARD_HISTORGRAM_USAGEPER_SITE_COUNT,
  GET_DASHBOARD_USAGE_PIE_TOP10_APPS,
  GET_DASHBOARD_PIE_WAN_USAGE_BYSITE,
  GET_DASHBOARD_USAGE_HISOGRAM_UPLINK_DLK,
  GET_NEW_SUMMARY_UPTIME_ALL_LINK_AVAILABLITY,
  GET_DASHBOARD_USAGE_HISTOGRAM_BYSITE,
  SET_DASHBOARD_UPTIME_SITESTATISTICS_TABLE_LOADING,
  SET_DASHBOARD_UPTIME_LINECHART_BYWAN_LOADING,
  SET_DASHBOARD_UPTIME_PIECHART_BYSITE_LOADING,
  SET_DASHBOARD_UPTIME_LINECHART_BYSITE_LOADING,
  SET_DASHBOARD_UPTIME_PIECHART_BYWAN_LOADING,
  GET_DASHBOARD_UPTIME_SITESTATISTICS_TABLE,
  GET_DASHBOARD_UPTIME_LINECHART_BYWAN,
  GET_DASHBOARD_UPTIME_PIECHART_BYSITE,
  GET_DASHBOARD_UPTIME_LINECHART_BYSITE,
  GET_DASHBOARD_UPTIME_PIECHART_BYWAN,
  GET_CSV_DATA_TO_DOWNLOAD,
  SET_DASHBOARD_ALERT_PIECHART_BYNAME_LOADING,
  SET_DASHBOARD_ALERT_PIECHART_BYSITE_LOADING,
  SET_DASHBOARD_ALERT_LINECHART_BYNAME_LOADING,
  SET_DASHBOARD_ALERT_LINECHART_BYSITE_LOADING,
  GET_DASHBOARD_ALERT_PIECHART_BYNAME,
  GET_DASHBOARD_ALERT_PIECHART_BYSITE,
  GET_DASHBOARD_ALERT_LINECHART_BYNAME,
  GET_DASHBOARD_ALERT_LINECHART_BYSITE,
  SET_DASHBOARD_ALERT_TOPWIDGET_LOADING,
  GET_DASHBOARD_ALERT_TOPWIDGET,
  SET_READONLY_USER,
  CREATE_DOWNLOAD_SERVICE_CONTENT_FILTER,
  SET_VESSEL_WAN_LINK_STATUS_LOADING,
  SPORTS_SITE_SUMMARY_COUNT_LOADING,
  SET_PRIVATE_VESSEL_LIST,
  SET_PRIVATE_VESSEL_LIST_LOADING,
  GET_NEW_SUMMARY_USAGE_TABLE_LOADING,
  GET_NEW_SUMMARY_UPTIME_ALL_LINK_AVAILABLITY_LOADING,
  SET_DASHBOARD_PER_DEVICE_WAN_PROFILES,
  GET_DASHBOARD_PER_DEVICE_WAN_PROFILES,
  SET_DASHBOARD_ADVANCED_BONDING_LOADING,
  GET_DASHBOARD_ADVANCED_BONDING,
  SET_DASHBOARD_LAN_STATUS_LOADING,
  GET_DASHBOARD_LAN_STATUS,
  SET_DASHBOARD_CONNECTED_HUB_LOADING,
  GET_DASHBOARD_CONNECTED_HUB,
  SET_HUB_INTERNET_DROPOFF_LIST_LOADING,
  GET_HUB_INTERNET_DROPOFF_LIST,
  GET_TRENDS_LAN_USAGE_TOPWIDGET_USAGE,
  SET_TRENDS_LAN_USAGE_TOPWIDGET_USAGE_LOADING,
  SET_TRENDS_LAN_USAGE_WIFI_TOPWIDGET_USAGE_LOADING,
  GET_TRENDS_LAN_USAGE_WIFI_TOPWIDGET_USAGE,
  SET_LAN_TABLE_DATA,
  SET_TRENDS_LAN_NETWORK_TABLE_LOADING,
  SET_SYSTEM_HEALTH_DEVICES_LOADING,
  GET_SYSTEM_HEALTH_DEVICES,
  SET_SYSTEM_HEALTH_METRICS_LINE_CHART_CPU_LOADING,
  GET_SYSTEM_HEALTH_METRICS_LINE_CHART_CPU,
  SET_SYSTEM_HEALTH_METRICS_LINE_CHART_MEMORY_LOADING, 
  GET_SYSTEM_HEALTH_METRICS_LINE_CHART_MEMORY,
  SET_SYSTEM_HEALTH_METRICS_LINE_CHART_CONTRACK_LOADING,
  GET_SYSTEM_HEALTH_METRICS_LINE_CHART_CONTRACK,
  SET_SYSTEM_HEALTH_METRICS_LINE_CHART_LO_RX_DROPS_LOADING,
  GET_SYSTEM_HEALTH_METRICS_LINE_CHART_LO_RX_DROPS,
  SET_SYSTEM_HEALTH_METRICS_LINE_CHART_SWAP_LOADING,
  GET_SYSTEM_HEALTH_METRICS_LINE_CHART_SWAP,
  SET_SYSTEM_HEALTH_METRICS_LINE_CHART_TEMPERATURE_LOADING,
  GET_SYSTEM_HEALTH_METRICS_LINE_CHART_TEMPERATURE,
  SET_SYSTEM_HEALTH_DISK_STORAGE_LINE_CHART_LOADING,
  GET_SYSTEM_HEALTH_DISK_STORAGE_LINE_CHART,
  SET_SYSTEM_HEALTH_FLOW_COUNT_TABLE_LOADING,
  GET_SYSTEM_HEALTH_FLOW_COUNT_TABLE_LOADING,
  FETCH_SERVICE_LINES,
  FETCH_SERVICE_LINES_FOR_SUBSCRIPTION,
  SET_FLIGHT_SCHEDULE_DATA_LOADING,
  GET_FLIGHT_SCHEDULE_DATA,
  SET_FLIGHT_TAILID_UPDATE_TABLE_LOADING,
  GET_FLIGHT_TAILID_UPDATE_TABLE,
  SET_FLIGHT_TAILID_UPDATE_TABLE_COUNT_LOADING,
  GET_FLIGHT_TAILID_UPDATE_TABLE_COUNT,
  SET_FLIGHT_SCHEDULE_TABLE_LOADING, 
  GET_FLIGHT_SCHEDULE_TABLE,
  SET_FLIGHT_SCHEDULE_TABLE_COUNT_LOADING,
  GET_FLIGHT_SCHEDULE_TABLE_COUNT,

  SET_HUB_DASHBOARD_HUB_DATA_LOADING,
  GET_HUB_DASHBOARD_HUB_DATA,
  SET_HUB_DASHBOARD_HUB_DATA_COUNT_LOADING,
  GET_HUB_DASHBOARD_HUB_DATA_COUNT,
  SET_HUB_DASHBOARD_CLIENT_TABLE_LOADING,
  GET_HUB_DASHBOARD_CLIENT_TABLE,
  SET_HUB_CLIENT_SDWAN_FLOWS_LOADING,
  GET_HUB_CLIENT_SDWAN_FLOWS,
  SET_HUB_CLIENT_SDWAN_SPEED_LOADING,
  GET_HUB_CLIENT_SDWAN_SPEED,
  SET_HUB_CLIENT_SDWAN_LATENCY_LOADING,
  GET_HUB_CLIENT_SDWAN_LATENCY,
  SET_HUB_CLIENT_SDWAN_STATUS_LOADING,
  GET_HUB_CLIENT_SDWAN_STATUS,
 UPDATE_NEW_SUMMARY_SERVICE_LINE,
 NEW_SUMMARY_SERVICE_ACCOUNTS,
 UPDATE_NEW_SUMMARY_SERVICE_LINE_SELECTED,
 SET_HAS_USER_CHANGED_SERVICE_LINE,
 UPDATE_NEW_SUMMARY_SERVICE_ACCOUNTS,
 UPDATE_NEW_SUMMARY_SERVICE_LINE_QUERY_PARAM,
 SET_SDWAN_SPEEDTEST_LOADING,
 GET_SDWAN_SPEEDTEST,
 SET_SITE_LINK_PROBE_NATIVE_LOADING,
 GET_SITE_LINK_PROBE_NATIVE,
 SET_SITE_LINK_PROBE_VTP_LOADING,
 GET_SITE_LINK_PROBE_VTP,
 SET_SDWAN_QOE_LOADING,
 GET_SDWAN_QOE,
 SET_SDWAN_QOE_HMAP_LOADING,
 GET_SDWAN_QOE_HMAP,
 SET_HUB_DASHBOARD_SITES_DROPDOWN_LOADING,
 GET_HUB_DASHBOARD_SITES_DROPDOWN,
 SET_HUB_DASHBOARD_CLIENT_WISE_LOADING,
 GET_HUB_DASHBOARD_CLIENT_WISE,
 SET_HUB_DASHBOARD_CLIENT_WISE_COUNT_LOADING,
 GET_HUB_DASHBOARD_CLIENT_WISE_COUNT,
 SET_TOPOLOGY_HUB_TABLE,
 GET_TOPOLOGY_HUB_TABLE,
 SET_HUB_DASHBOARD_CARRIER_CLIENT_TABLE,
 GET_HUB_DASHBOARD_CARRIER_CLIENT_TABLE,
 GET_HUB_DASHBOARD_CARRIER_SERVICE_VRF_TABLE, 
 SET_HUB_DASHBOARD_CARRIER_SERVICE_VRF_TABLE,
 SET_CARRIER_HUB_SDWAN_STATUS,
 GET_CARRIER_HUB_SDWAN_STATUS,
 SET_CARRIER_HUB_SDWAN_LATENCY,
 GET_CARRIER_HUB_SDWAN_LATENCY,
 SET_CARRIER_HUB_SDWAN_DATA_RATES,
 GET_CARRIER_HUB_SDWAN_DATA_RATES,
 SET_CARRIER_HUB_SDWAN_USAGE,
 GET_CARRIER_HUB_SDWAN_USAGE,
 SET_CARRIER_HUB_SDWAN_HUBS,
 GET_CARRIER_HUB_SDWAN_BASE_RTT,
 SET_CARRIER_HUB_SDWAN_BASE_RTT,
 GET_CARRIER_HUB_SDWAN_CURRENT_RTT,
 SET_CARRIER_HUB_SDWAN_CURRENT_RTT,
 SET_CARRIER_HUB_SDWAN_PACKET_DROP,
 GET_CARRIER_HUB_SDWAN_PACKET_DROP,
 SET_CARRIER_HUB_SDWAN_TUNNEL_MIGRATION,
 GET_CARRIER_HUB_SDWAN_TUNNEL_MIGRATION,
 SET_CARRIER_HUB_SDWAN_PACING_RATE,
 GET_CARRIER_HUB_SDWAN_PACING_RATE,
 SET_CARRIER_HUB_SDWAN_BTLBW,
 GET_CARRIER_HUB_SDWAN_BTLBW,
 SET_CARRIER_HUB_SDWAN_BYTES_IN_FLIGHT,
 GET_CARRIER_HUB_SDWAN_BYTES_IN_FLIGHT,
 SET_CARRIER_HUB_SDWAN_CONGESTION_WINDOW,
 GET_CARRIER_HUB_SDWAN_CONGESTION_WINDOW,
 SET_CARRIER_HUB_SDWAN_DROPPED_DATAGRAMS,
 GET_CARRIER_HUB_SDWAN_DROPPED_DATAGRAMS,
 SET_CARRIER_HUB_SDWAN_ONE_WAY_DELAY_OWD,
 GET_CARRIER_HUB_SDWAN_ONE_WAY_DELAY_OWD,
 SET_CARRIER_HUB_SDWAN_ACK_COUNT,
 GET_CARRIER_HUB_SDWAN_ACK_COUNT,
 SET_CARRIER_HUB_SDWAN_PACING_LIMITED,
 GET_CARRIER_HUB_SDWAN_PACING_LIMITED,
 SET_CARRIER_HUB_SDWAN_SENT_DATAGRAMS,
 GET_CARRIER_HUB_SDWAN_SENT_DATAGRAMS,
 SET_CARRIER_HUB_SDWAN_BLOCK_COUNT,
 GET_CARRIER_HUB_SDWAN_BLOCK_COUNT,
 SET_CARRIER_HUB_SDWAN_AGENTS_LIST,
 GET_CARRIER_HUB_SDWAN_AGENTS_LIST,
 GET_CARRIER_HUB_SDWAN_HUBS,
 SET_CARRIER_HUB_AGENT_DROPDOWN,
 GET_CARRIER_HUB_AGENT_DROPDOWN,
 SET_CARRIER_HUB_WAN_DROPDOWN,
 GET_CARRIER_HUB_WAN_DROPDOWN,
 SET_CARRIER_HUB_SDWAN_HUB_DROPDOWN,
 GET_CARRIER_HUB_SDWAN_HUB_DROPDOWN,
 CREATE_AGENT_WAN_LOADING,
 CREATE_AGENT_WAN,
 UPDATE_AGENT_WAN_LOADING,
 UPDATE_AGENT_WAN,
 DELETE_AGENT_WAN_LOADING,
 DELETE_AGENT_WAN,
 GET_AGENT_WANS_LOADING,
 GET_AGENT_WANS,
 CREATE_AGENT_WAN_PROFILE_LOADING,
 CREATE_AGENT_WAN_PROFILE,
 UPDATE_AGENT_WAN_PROFILE_LOADING,
 UPDATE_AGENT_WAN_PROFILE,
 DELETE_AGENT_WAN_PROFILE_LOADING,
 DELETE_AGENT_WAN_PROFILE,
 GET_AGENT_WAN_PROFILES_LOADING,
 GET_AGENT_WAN_PROFILES,
 CREATE_AGENT_HUB_LOADING,
 CREATE_AGENT_HUB,
 GET_AGENT_HUBS_LOADING,
 GET_AGENT_HUBS,
 GET_AGENT_HUBS_PER_SERVICE_LOADING,
 GET_AGENT_HUBS_PER_SERVICE,
 CREATE_AGENT_SERVICE_VLAN_LOADING,
 CREATE_AGENT_SERVICE_VLAN,
 GET_AGENT_SERVICE_VLANS_LOADING,
 GET_AGENT_SERVICE_VLANS,
 CREATE_AGENT_PROFILE_LOADING,
 CREATE_AGENT_PROFILE,
 GET_AGENT_PROFILES_LOADING,
 GET_AGENT_PROFILES,
 CREATE_AGENT_ROUTE_LOADING,
 CREATE_AGENT_ROUTE,
 GET_AGENT_ROUTES_LOADING,
 GET_AGENT_ROUTES,
 CREATE_AGENT_SERVICE_LOADING,
 CREATE_AGENT_SERVICE,
 UPDATE_AGENT_SERVICE_LOADING,
 UPDATE_AGENT_SERVICE,
 GET_AGENT_SERVICES_LOADING,
 GET_AGENT_SERVICES,
 CREATE_AGENT_CONFIG_LOADING,
 CREATE_AGENT_CONFIG,
 GET_AGENT_CONFIGS_LOADING,
 GET_AGENT_CONFIGS,
 CREATE_AGENT_LOADING,
 CREATE_AGENT,
 GET_AGENTS_LOADING,
 GET_AGENTS,
 CREATE_AGENT_ACCESS_NETWORK_LOADING,
 CREATE_AGENT_ACCESS_NETWORK,
 UPDATE_AGENT_ACCESS_NETWORK_LOADING,
 UPDATE_AGENT_ACCESS_NETWORK,
 VERIFY_AGENT_CONFIG,
 VERIFY_AGENT_CONFIG_LOADING,
 UPLOAD_AGENT_CONFIG_LOADING,
 UPLOAD_AGENT_CONFIG,
 UPDATE_UPLOAD_AGENT_CONFIG_LOADING,
 UPDATE_UPLOAD_AGENT_CONFIG,
 GET_AGENT_CONFIG_SUMMARY_LOADING,
 GET_AGENT_CONFIG_SUMMARY,
 GET_AGENT_HUB_EVENTS_LOADING,
 GET_AGENT_HUB_EVENTS,
 GET_AGENT_HUB_EVENT_FILTERS_LOADING,
 GET_AGENT_HUB_EVENT_FILTERS,
 GET_HUB4_AGENT_CONFIG_SUMMARY, 
 GET_HUB4_AGENT_CONFIG_SUMMARY_LOADING,
 DELETE_AGENT_CONFIG, 
 DELETE_AGENT_CONFIG_LAODING,
 COPY_AGENT_CONFIG,
 COPY_AGENT_CONFIG_LAODING,
 SAVE_AGENT_CONFIG,
 SAVE_AGENT_CONFIG_LAODING,
 AGENT_CONFIG_ROW_DOWNLOAD_LOADING,
 AGENT_CONFIG_ROW_DOWNLOAD,
 AGENT_CONFIG_SUMMARY,
 AGENT_CONFIG_SUMMARY_LOADING,

 GET_THREAT_DASHBOARD_TOPWIDGET,
 SET_THREAT_DASHBOARD_TOPWIDGET_LOADING,
 GET_TOP_10_THREAT_BY_NAME,
 SET_TOP_10_THREAT_BY_NAME_LOADING,
 GET_TOP_10_THREAT_BY_SEVERITY,
 SET_TOP_10_THREAT_BY_SERVERITY_LOADING,
 GET_THREAT_DASHBORAD_BAR_CHART_ON_SEVERITY,
 GET_THREAT_DASHBORAD_BAR_CHART_ON_SEVERITY_LOADING,
 GET_TOP_10_THREAT_TABLE_DATA,
 SET_THREAT_DASHBOARD_TOP_10_THREAT_TABLE_LOADING,
 GET_ALL_THREAT_TABLE_DATA,
 SET_THREAT_DASHBOARD_ALL_THREAT_TABLE_LOADING,
 UPDATE_NEW_SEVERITY_TYPE,
 GET_THREAT_DASHBOARD_TOPWIDGET_TOTAL,
 SET_THREAT_DASHBOARD_TOPWIDGET_TOTAL_LOADING,
 GET_THREAT_DEVICE_LIST,
 GET_THREAT_DEVICE_LIST_LOADING,
 GET_THREAT_SITE_LIST,
 GET_THREAT_SITE_LIST_LOADING,
 GET_USER_THREAT_TABLE_DATA,
 SET_THREAT_DASHBOARD_USER_THREAT_TABLE_LOADING,
 SET_THREAT_FILTERS,
 GET_THREAT_UNIQUE_DEVICE_LIST_LOADING,
 GET_THREAT_UNIQUE_DEVICE_LIST,
 GET_THREAT_UNIQUE_IP_LIST,
 GET_THREAT_UNIQUE_CLASS_LIST,
 GET_THREAT_UNIQUE_THREATNAME_LIST_LOADING,
 GET_THREAT_UNIQUE_THREATNAME_LIST,
 GET_THREAT_UNIQUE_IP_LIST_LOADING,
 GET_THREAT_UNIQUE_CLASS_LIST_LOADING,
 GET_THREAT_UNIQUE_ACTION_LIST,
 GET_THREAT_UNIQUE_ACTION_LIST_LOADING,
 GET_THREAT_ACTION_PIE_DATA,
 SET_THREAT_ACTION_PIE_DATA_LOADING,
 SET_THREAT_SEVERITY_CLASS_LIST_LOADING,
 GET_THREAT_SEVERITY_CLASS_LIST,
 SET_THREAT_KONTROL_LOADING,
 CREATE_THREAT_KONTROL, 
 UPDATE_THREAT_KONTROL, 
 DELETE_THREAT_KONTROL,
 SET_THREATS_LOADING,
 GET_THREATS,
 SET_THREATNAMES_LIST_LOADING,
 GET_THREATNAMES_LIST,
 SET_SNORT_RULES_DETAILS,
 GET_SNORT_RULES_DETAILS,
 
 SET_CAPTIVE_USAGE_PIE_DATA_LOADING,
 GET_CAPTIVE_USGAE_PIE_DATA,
 GET_CAPTIVE_SUBS_PIE_DATA,
 SET_CAPTIVE_SUBS_PIE_DATA_LOADING,

 SET_CAPTIVE_DASHBOARD_SITES_SUBSCRIBERS_SESSIONS_TOP_WIDGET,
 GET_CAPTIVE_DASHBOARD_SITES_SUBSCRIBERS_SESSIONS_TOP_WIDGET,
 SET_CAPTIVE_DASHBOARD_PLANS_TOP_WIDGET,
 GET_CAPTIVE_DASHBOARD_PLANS_TOP_WIDGET,
 SET_CAPTIVE_DASHBOARD_USAGE_TOP_WIDGET,
 GET_CAPTIVE_DASHBOARD_USAGE_TOP_WIDGET,
 SET_CAPTIVE_DASHBOARD_TOP_SITES_USAGE_BAR,
 GET_CAPTIVE_DASHBOARD_TOP_SITES_USAGE_BAR,
 SET_CAPTIVE_DASHBOARD_TOP_SITES_OVERAGE_USAGE_BAR,
 GET_CAPTIVE_DASHBOARD_TOP_SITES_OVERAGE_USAGE_BAR,
 SET_CAPTIVE_DASHBOARD_SUBSCRIBERS_LINE_CHART,
 GET_CAPTIVE_DASHBOARD_SUBSCRIBERS_LINE_CHART,
 SET_CAPTIVE_DASHBOARD_SESSIONS_LINE_CHART,
 GET_CAPTIVE_DASHBOARD_SESSIONS_LINE_CHART,
 SET_CAPTIVE_DASHBOARD_OVERAGE_USAGE_LINE_CHART,
 GET_CAPTIVE_DASHBOARD_OVERAGE_USAGE_LINE_CHART,
 SET_CAPTIVE_DASHBOARD_USAGE_LINE_CHART,
 GET_CAPTIVE_DASHBOARD_USAGE_LINE_CHART,
 SET_CAPTIVE_DASHBOARD_SITES_TABLE,
 GET_CAPTIVE_DASHBOARD_SITES_TABLE,
 SET_CAPTIVE_DASHBOARD_TOP_SITES_SUBSCRIBERS_BAR,
 GET_CAPTIVE_DASHBOARD_TOP_SITES_SUBSCRIBERS_BAR,
 SET_CAPTIVE_DASHBOARD_TOP_SITES_SESSIONS_BAR,
 GET_CAPTIVE_DASHBOARD_TOP_SITES_SESSIONS_BAR,

 SET_OPERATIONAL_USAGE_DATA_DUMP_TABLE_COUNT_LOADING,
 GET_OPERATIONAL_USAGE_DATA_DUMP_TABLE_COUNT,
 SET_OPERATIONAL_USAGE_DATA_DUMP_TABLE_LOADING,
 GET_OPERATIONAL_USAGE_DATA_DUMP_TABLE,
 SET_OPERATIONAL_USAGE_TIMESERIES_TABLE_LOADING,
 GET_OPERATIONAL_USAGE_TIMESERIES_TABLE,
 SET_OPERATIONAL_USAGE_TIMESERIES_TABLE_COUNT_LOADING,
 GET_OPERATIONAL_USAGE_TIMESERIES_TABLE_COUNT,
 SET_OPERATIONAL_USAGE_DATA_SINGLE_SITE_PER_WAN_WISE_LOADING,
 GET_OPERATIONAL_USAGE_DATA_SINGLE_SITE_PER_WAN_WISE,
 SET_OPERATIONAL_USAGE_FILTER_DEVICE_LIST_LOADING,
 GET_OPERATIONAL_USAGE_FILTER_DEVICE_LIST,
 SET_OPERATIONAL_USAGE_FILTER_SW_LIST_LOADING,
 GET_OPERATIONAL_USAGE_FILTER_SW_LIST,
 SET_OPERATIONAL_USAGE_DATA_DUMP_DOWNLOAD_TABLE_LOADING,
 GET_OPERATIONAL_USAGE_DATA_DUMP_DOWNLOAD_TABLE,

 SET_CAPTIVE_DASHBOARD_SUBSCRIBERS_SESSIONS_TABLE,
 GET_CAPTIVE_DASHBOARD_SUBSCRIBERS_SESSIONS_TABLE,
 SET_CAPTIVE_DASHBOARD_TOP_PLANS_USERS_BAR,
 GET_CAPTIVE_DASHBOARD_TOP_PLANS_USERS_BAR,
 SET_CAPTIVE_DASHBOARD_TOP_PLANS_USAGE_BAR,
 GET_CAPTIVE_DASHBOARD_TOP_PLANS_USAGE_BAR,
 SET_CAPTIVE_DASHBOARD_TOP_PLANS_OVERAGE_USAGE_BAR,
 GET_CAPTIVE_DASHBOARD_TOP_PLANS_OVERAGE_USAGE_BAR,
 SET_CAPTIVE_DASHBOARD_EVENTS_SUBSCRIBERS_PLAN_USAGE,
 GET_CAPTIVE_DASHBOARD_EVENTS_SUBSCRIBERS_PLAN_USAGE,
 SET_CAPTIVE_DASHBOARD_TOP_SUBSCRIBERS_USAGE_BAR,
 GET_CAPTIVE_DASHBOARD_TOP_SUBSCRIBERS_USAGE_BAR,
 SET_CAPTIVE_DASHBOARD_TOP_SUBSCRIBERS_OVERAGE_USAGE_BAR,
 GET_CAPTIVE_DASHBOARD_TOP_SUBSCRIBERS_OVERAGE_USAGE_BAR,
 SET_CAPTIVE_DASHBOARD_TOP_SUBSCRIBERS_SESSIONS_BAR,
 GET_CAPTIVE_DASHBOARD_TOP_SUBSCRIBERS_SESSIONS_BAR,
 SET_CAPTIVE_DASHBOARD_PLANS_SUBSCRIBERS_HISTOGRAM,
 GET_CAPTIVE_DASHBOARD_PLANS_SUBSCRIBERS_HISTOGRAM,
 SET_CAPTIVE_DASHBOARD_PLANS_SUBSCRIBERS_OVERAGE_HISTOGRAM,
 GET_CAPTIVE_DASHBOARD_PLANS_SUBSCRIBERS_OVERAGE_HISTOGRAM,
 SET_CAPTIVE_DASHBOARD_PLANS_USAGE_LINE_CHART,
 GET_CAPTIVE_DASHBOARD_PLANS_USAGE_LINE_CHART,
 SET_CAPTIVE_DASHBOARD_PLANS_OVERAGE_USAGE_LINE_CHART,
 GET_CAPTIVE_DASHBOARD_PLANS_OVERAGE_USAGE_LINE_CHART,
 SET_CAPTIVE_DASHBOARD_SUBSCRIBERS_LIST,
 GET_CAPTIVE_DASHBOARD_SUBSCRIBERS_LIST,
 SET_CAPTIVE_DASHBOARD_PLANS_LIST,
 GET_CAPTIVE_DASHBOARD_PLANS_LIST,
 SET_CAPTIVE_DASHBOARD_SUBSCRIBER_SESSIONS_TABLE,
 GET_CAPTIVE_DASHBOARD_SUBSCRIBER_SESSIONS_TABLE,
 SET_CAPTIVE_DASHBOARD_EVENTS_TABLE,
 GET_CAPTIVE_DASHBOARD_EVENTS_TABLE,
 SET_CAPTIVE_DASHBOARD_EVENTS_IP_MAC_LIST,
 GET_CAPTIVE_DASHBOARD_EVENTS_IP_MAC_LIST,
 SET_CAPTIVE_DASHBOARD_PLANS_SUBSCRIBERS_LINE_CHART,
 GET_CAPTIVE_DASHBOARD_PLANS_SUBSCRIBERS_LINE_CHART,
 SET_CAPTIVE_DASHBOARD_SITES_HISTOGRAM,
 GET_CAPTIVE_DASHBOARD_SITES_HISTOGRAM,
 SET_CAPTIVE_DASHBOARD_SITES_OVERAGE_HISTOGRAM,
 GET_CAPTIVE_DASHBOARD_SITES_OVERAGE_HISTOGRAM,

 SET_WAN_USAGE_REPORT_SINGLE_SITE_NETWORK_USAGE_LOADING,
 GET_WAN_USAGE_REPORT_SINGLE_SITE_NETWORK_USAGE,
 SET_WAN_USAGE_REPORT_SINGLE_SITE_ALL_INTERFACE_USAGE_LOADING,
 GET_WAN_USAGE_REPORT_SINGLE_SITE_ALL_INTERFACE_USAGE,
 SET_WAN_USAGE_REPORT_SINGLE_SITE_WAN_SELECTION_NETWORK_USAGE_LOADING,
 GET_WAN_USAGE_REPORT_SINGLE_SITE_WAN_SELECTION_NETWORK_USAGE,
 SET_WAN_USAGE_REPORT_SINGLE_SITE_VSAT_SELECTION_NETWORK_USAGE_LOADING,
 GET_WAN_USAGE_REPORT_SINGLE_SITE_VSAT_SELECTION_NETWORK_USAGE,
 SET_WAN_USAGE_REPORT_SINGLE_SITE_INTERFACE_USAGE_LOADING,
 GET_WAN_USAGE_REPORT_SINGLE_SITE_INTERFACE_USAGE,
 GET_ORG_HIRARCHY,
 GET_NETWORK_TOPOLOGY_SITE_DETAILS,
 GET_NETWORK_TOPOLOGY_SITE_DETAILS_LOADING,
 GET_NETWORK_TOPOLOGY_DEVICE_INFO,
 SET_NETWORK_TOPOLOGY_DEVICE_INFO_LOADING,
 RESET_NETWORK_TOPOLOGY_DEVICE_INFO,
 NETWORK_TOPOLOGY_DEVICE_DETAILS,
 GET_HUB_EVENTS,
 GET_HUB_EVENTS_LOADING,
 GET_HUB_EVENT_FILTERS,
 GET_HUB_EVENT_FILTERS_LOADING,
 SET_TOPOLOGY_TREE_TOP_WIDGET_LOADING,
 GET_TOPOLOGY_TREE_TOP_WIDGET,

 SET_REPORTS_SUBSCRIPTION_TABLE_LOADING,
 SET_REPORTS_SUBSCRIPTION_TABLE_COUNT_LOADING,
 GET_REPORTS_SUBSCRIPTION_TABLE,
 GET_REPORTS_SUBSCRIPTION_TABLE_COUNT,
 SET_SCHEDULED_REPORTS_TABLE_LOADING,
 SET_SCHEDULED_REPORTS_TABLE_COUNT_LOADING,
 GET_SCHEDULED_REPORTS_TABLE,
 GET_SCHEDULED_REPORTS_TABLE_COUNT,
 LIMITED_REPORT_ACCESS,
 SITE_ADMIN_ACCESS,
 SL_ADMIN_ACCESS,
 CALL_SCHEDULED_REPORT,
 FETCH_SITE_LIST,
 FETCH_SERVICE_LINE_LIST,
SET_LAN_NETWORK_TABLE_COUNT,
SET_LAN_CLIENT_TABLE_COUNT,
SET_LAN_WIFI_CLIENT_TABLE_COUNT,
SET_TRENDS_LAN_CLIENT_TABLE_LOADING,
SET_TRENDS_LAN_WIFI_CLIENT_TABLE_LOADING,
SET_TRENDS_LAN_WIFI_CLIENT_AP_TABLE_LOADING,
GET_TRENDS_LAN_WIFI_AP_CLIENT_TABLE_COUNT,

 SET_ANALYTICS_TOP_CARDS_LOADING,
 GET_ANALYTICS_TOP_CARDS,
 SET_ANALYTICS_BAR_CHART_LOADING,
 GET_ANALYTICS_BAR_CHART,
 SET_ANALYTICS_LINE_CHART_LOADING,
 GET_ANALYTICS_LINE_CHART,
 SET_ANALYTICS_TABLE_LOADING,
 GET_ANALYTICS_TABLE,

 SET_OPEN_EDGE_SOFTWARE_UPDATE_LOADING,
 GET_OPEN_EDGE_SOFTWARE_UPDATE,
 SET_OPEN_EDGE_SOFTWARE_UPDATE_STATUS_LOADING,
 GET_OPEN_EDGE_SOFTWARE_UPDATE_STATUS,
 UPGRADE_DEVICE_TO_LATEST_EOS_VERSION,
 UPGRADE_DEVICE_TO_LATEST_EOS_VERSION_LOADING,
 UPDATE_AM_CONTROLLER_ACTION_STATUS,
  GET_IS_AM_AVAILABLE, 
  GET_MODEM_DETAILS,
  SET_FECTH_MODEM_DETAILS_LOADING, 
  GET_SIM_DETAILS, 
  TRIGGER_TOWER_SCAN, 
  GET_TOWER_SCAN_RESULTS, 
  GET_SIM_PRIORITY_DETAILS, 
  UPDATE_SIM_PRIORITY_DETAILS, 
  RELOAD_SIM_DETAILS, 
  RESET_MODEM, 
  UPDATE_SIM_SETTINGS,
  GET_IDENTITY_RULES,
  GET_IDENTITY_RULES_LOADING,
  GET_IDENTITY_RULES_BY_ID_LOADING,
  GET_IDENTITY_RULE_BY_ID,
  CREATE_UPDATE_IDENTITY_RULE,
  CREATE_UPDATE_IDENTITY_RULE_LOADING,
  DELETE_IDENTITY_RULE,
  DELETE_IDENTITY_RULE_LOADING,
  FETCH_FIREWALL_PROTOCOLS_LOADING,
  FETCH_FIREWALL_PROTOCOLS,
  GET_ALL_HUB_CLIENTS_LOADING,
  GET_ALL_HUB_CLIENTS,
  SELECT_HUB_CLIENT_LOADING,
  SELECT_HUB_CLIENT,
  GET_HUB_MTD_USAGE_LOADING,
  GET_HUB_MTD_USAGE,
  GET_HUB_SERVER_STATUS_LOADING,
  GET_HUB_SERVER_STATUS,
  GET_ACTIVE_HUB_CLIENT_LOADING,
  GET_ACTIVE_HUB_CLIENT,
  CREATE_PRIVATE_HUB_SERVER_LOADING,
  CREATE_PRIVATE_HUB_SERVER,
  GET_PRIVATE_HUB_SERVERS_LOADING,
  GET_PRIVATE_HUB_SERVERS,
  DELETE_PRIVATE_HUB_SERVER_LOADING,
  DELETE_PRIVATE_HUB_SERVER,
  UPDATE_PRIVATE_HUB_SERVER_LOADING,
  UPDATE_PRIVATE_HUB_SERVER,
} from "../actions/types";
import { CHARTS_METRICS } from "../constants/Constants";

const initialState = {
  sideMenu: { menuItem: "dashboard" },
  dpWiseSideMenu: [],
  dpWiseSideMenuLoading: false,
  userOu: null,
  selectedOu: null,
  isUserOuHasSubOus : false,
  parentDpAndSubDpList: {},
  selectedVessels: { isAll: false, vessels: [] },
  filteredVessels: [],
  hubFilteredVessels: [],
  selectedVessel: { vessel: null },
  permissionObserver: {
    isMultiVessel: false,
    isSingleVessel: false,
    permission: null
  },
  loginUser: {},
  logoutUser: {},
  fetchVessel: {},

  usersListLoading: false,
  usersList: null,

  vesselPlansLoading: false,
  vesselPlans: {},

  loading: false,
  topologyPopupLoading: false,

  inviteUserLoading: false,
  inviteUser: {},

  resendInviteLoading: false,
  resendInvite: {},

  getOrganisationList: {},
  userPolicy: {},

  searchAlertsLoading: false,
  searchAlerts: {},

  vesselEdgeInfo: {},

  fetchResourcesLoading: false,
  fetchResources: {},
  fetchSiteList: {},
  fetchServiceLines: {},
  fetchServiceLinesForSubscription:{},
  fetchServiceLineList:{},

  organizationpolicy: {},

  userDetachLoading: false,
  userdetch: {},

  userDeleteLoading: false,
  userdelete: {},

  accountCreateSubDP: {},
  setSubDPCreateLoading: false,
  setDeleteOrgLoading: false,
  setModifyOrgLoading: false,
  setDpInfoLoading: false,
  accountDeleteOrg: {},
  accountModifyOrg: {},
  getDpInfo: {},
  
  getTicketsLoading: false,
  getTickets: {},

  displayApplicableUserPolicies: {},
  policiesDetails: {},

  updateUserLoading: false,
  UpdateUser: {},

  updateUserOrganizationLoading: false,
  updateUserOrganization: {},

  fetchOu: {},
  getTicketDetails: {},
  getTicketComments: {},
  getSingleTicketAttachments: {},
  updateTicket: {},
  createNewTicket: {},
  addAttachmentsToTicket: {},
  sendTicketEmail: {},
  sendTicketComment: {},
  getTicketHistory: {},
  getHotVessels: {},
  getTicketAgentsByName: {},
  getTicketAllAgents: {},
  getDpAddressData:{},

  enableUserAccountLoading: false,
  enableUserAccount: {},

  disableUserAccountLoading: false,
  disableUserAccount: {},

  vesselAlertsLoading: false,
  vesselAlerts: {},

  deleteAlert: {},
  deleteAlertLoading: false,

  dpAlerts: {},
  updateDpAlert: {},
  updateDpAlertNotification: {},
  updateDpAlertStatus: {},
  deleteDpAlertLinkAvailability: {},
  dpAlertAuditLogs: {},
  dpAlertsLoading: false,
  updateDpAlertLoading: false,
  updateDpAlertNotificationLoading: false,
  updateDpAlertStatusLoading: false,
  deleteDpAlertLALoading: false,
  dpAlertLogsLoading: false,

  siteAlerts: {},
  updateSiteAlert: {},
  updateSiteAlertNotification: {},
  deleteSiteAlertLinkAvailability: {},
  siteAlertAuditLogs: {},
  siteAlertsLoading: false,
  updateSiteAlertLoading: false,
  updateSiteAlertNotificationLoading: false,
  deleteSiteAlertLALoading: false,
  siteAlertLogsLoading: false,
  updateSiteAlertStatus: {},
  updateSiteAlertStatusLoading: false,

  vesselDashboardLoading: false,
  vesselWanLinkStatusLoading: false,
  vesselDashboardSummary: {},
  widgetDashboardSummary: {},
  topWidgetLinkStatus:{},
  widgetLinkStatusDashboardSummary: {},

  vesselSummaryLoading: false,
  vesselSummaryTableData: {},
  vesselSummaryTableDataCount: null,

  vesselLocWithAlertsLoading: false,
  vesselLocWithAlerts: {},

  markAsFixedAlert: {},
  alertnames: {},
  alertHistory: {},
  inventory: {},

  edgeServerStatus: {},
  edgeServerStatusLoading: false,

  recoveryPasswordUser: {},
  changePassword: {},

  setPasswordUserLoading: false,
  setPasswordUser: {},

  userDetails: {},
  verifyUser: {},
  resetPassword: {},

  updateUserProfile: {},
  userPreferencesLoading: false,
  updateUserPreferences: {},
  getUserPreferences : {},
  detachResource: {},
  notAttachedOuResources: {},
  attachResource: {},
  vesselEdgeTopologyProducts: {},
  productEdgeTopologyDevices: {},
  parentDeviceOfSite: {},
  updateParentDeviceOfSite: {},
  softwareProduct: {},

  softwareListingLoading: false,
  softwareListing: {},
  konnectAppDownloadLinks : {},
  vxBuildDetails : {},
  dpDocumentsList : {},

  allTemplate: {},
  getConfiguredAlertsForDevice: {},
  createDeviceAlertConfiguration: {},
  deleteDeviceAlertConfiguration: {},
  updateDeviceAlertConfiguration: {},
  getOrganisationUnitList: {},
  getVesselsListing: {},
  setVesselListingLoading: false,
  vesselSummaryTopology: {},
  softwareVersionsDeviceCount : {},
  getSoftwareVersionDeviceDetails : {},
  getSoftVersionDeviceDetails: {},
  getSearchDpList: {},

  getEdgeEventsLoading: false,
  getEdgeEventsFilterLoading: false,
  getEdgeEventsTableLoading: false,
  getEdgeEventsTableCountLoading: false,
  getEdgeEvents: {},
  getEdgeEventsFilter: {},
  getEdgeEventsTable: {},
  getEdgeEventsTableCount: {},
  downloadEdgeEventsTable: {},

  siteChartsRSSILoading: false,
  siteChartsSINRLoading: false,
  siteChartsLinkStatusLoading: false,
  siteChartsLatencyJitterLoading: false,
  siteChartsThroughputLoading: false,
  siteChartsVSATSnrLoading: false,
  siteChartsVSATyTXPowerLoading: false,
  siteChartsVSATPowerLoading: false,
  siteChartsVSATSymbolRateLoading: false,
  siteChartsSiteInterfacesLoading: false,
  siteChartsSiteDataRateLoading: false,
  siteChartsSiteClientsLoading: false,
  siteChartsSiteUsageLoading: false,
  siteChartsSiteSystemUptimeLoading: false,
  siteChartsSiteLanStatusLoading: false,
  siteChartsSiteFlowsLoading: false,
  siteChartsSiteSpeedLoading: false,
  siteChartsSiteLatencyLoading: false,
  siteChartsSiteStatusLoading: false,
  siteChartsSiteSpeedtestLoading: false,

  getSiteRSSI: {data: {rssiAvg: {series: {}}}},
  getSiteSINR: {data: {sinrAvg: {series: {}}}},
  getSiteDataRate: {data: {rateAvg: {series: {}}}},
  getSiteLinkStatus: {data: {probeSuccess: {series: {}}}},
  getSiteLatencyJitter: {data: {latency: {series: {}}, jitter: {series: {}}}},
  getSiteThroughput: {data: {avgDownSpeed: {series: {}}, avgUpSpeed: {series: {}}}},
  getSiteVSATSnr: {data: {avg: {series: {}}}},
  getSiteVSATTxpower: {data: {avg: {series: {}}}},
  getSiteVSATPower: {data: {avg: {series: {}}}},
  getSiteVSATSymbolRate: {data: {avg: {series: {}}}},
  getSiteClients: {data: {clients: {series: {}}}},
  getSiteUsage: {data: {totalUsage: {series: {}}, downUsage: {series: {}}, upUsage: {series: {}}}},
  getSiteSystemUptime: {data: {status: {series: {}}}},
  getSiteLanStatus: {data: {LAN_status: {series: {}}}},
  getSiteFlows: {data: {flows: {series: {}}}},
  getSiteSpeed: {data: {avgDownSpeed: {series: {}}, avgUpSpeed: {series: {}}}},
  getSiteLatency: {data: {latency: {series: {}}}},
  getSiteStatus: {data: {status: {series: {}}}},
  getSiteSpeedtest: {},
  getSiteLinkProbeNative: {data: {probeSuccess: {series: {}}}},
  getSiteLinkProbeVtp: {data: {probeSuccess: {series: {}}}},
  getSiteQoe: {data: {QoEStreamingPoints: {series: {}}, QoEGamingPoints: {series: {}}}},
  getSiteInterfaces: {},

  getUserLoginHistory: {},
  getDataUsage:{},
  getDataUsageCount: {},
  getDailyDataUsage: {},
  getGraphicalDataUsage:{},
  setCellularDataUsageLoading: false,
  getCellularDataUsage: {},
  graphicalDataUsageLoading: false,
  getUsageVesselList:{},
  exportDataUsageReport:{},

  inventoryListingLoading :false,
  configStatusDownloadLoading: false,
  deviceStatusDownloadLoading: false,
  trafficPolicyListingLoading: false,
  policyRouteListingLoading: false,
  wanProfileListingLoading: false,
  applyTrafficPolicyLoading: false,
  applyPolicyRouteLoading: false,
  applyPolicyRouteData: {},
  applyFirewallRuleLoading: false,
  applyHubIPConfigLoading: false,
  copyQuotaConfigLoading: false,
  trafficPolicyLogListLoading: false,
  getInventoryDeployedData: {},
  downloadnventoryDeployedData: {},
  getInventoryWarehouseTableData: {},
  inventoryWarehouseChangeGroupData: {},
  getInventoryWarehouseVesselList: {},
  assignInventoryToVessel: {},
  getLicenseTypes : {},
  getDpsDefaultActiveConfig : {},
  createVessel: {},
  getDPList: {},
  getInventoryDeployedDataCount: {},
  inventoryAssignDeviceToWarehouse : {},
  inventoryDeleteSite :{},
  inventoryTopWidgetsRegisteredCount : {},
  inventoryTopWidgetsKaasCount: {},
  inventoryTopWidgetsWarehouseCount : {},
  inventoryDownloadConfig: {},
  inventoryChangeGroup: {},
  getConfigProducts: {},
  applyGoldenConfig: {},
  backupConfigNow:{},
  deviceLatestEosVersion :{},
  getDeviceList:{},
  getDpDevices:{},
  createInventoryGroup:{},
  updateInventoryGroup:{},
  deleteInventoryGroup:{},
  getInventoryGroupList:{},
  getInventoryGroupListCount:{},
  getSiteInfoList: {},
  getSiteInfoListCount : {},
  getTrafficPolicy: {},
  getPolicyRoute: {},
  getTrafficPolicyV3: {},
  backupConfigData: {},
  copyConfigToManualBackup: {},
  deleteManualBackupConfig: {},
  getDefaultConfigListing: {},
  editDefaultConfig: {},
  createDefaultConfig: {},
  deleteDefaultConfig: {},
  getDefaultProducts: {},
  getConfigSoftwareVersions: {},
  getConfigStatus: [],
  getConfigStatusTotalCount: 0,
  getGroupTranscationConfigStatus: [],
  getGroupTranscationConfigStatusTotalCount: 0,
  linkStatusPerDeviceLoading: false,
  linkStatusPerDevice: {},
  vesselAddressMMSI: {},
  getVesselInfo: {},
  updateMMSIAndStreetAddress: {},
  setDeviceHistoryLoading: false,
  deviceHistory: {},
  deviceConfigActionLogsLoading: false,
  deviceConfigActionLogs: {},
  deviceEosHistoryEventsLoading: false,
  deviceEosHistoryEvents: {},
  deviceLicenseHistoryLoading: false,
  deviceLicenseHistory: {},
  setUpgradeInventoryLicenseLoading: false,
  inventoryUpgradeLicense: {},
  isInventoryPreviousPage: false,
  upgradeWarehouseDeviceToLatestEosVersionLoading : false,
  upgradeWarehouseDeviceToLatestEosVersion: {},

  highAvailability: {},
  gettingHa: false,
  getHighAvailabilityDevice: {},
  createHighAvailability: {},
  creatingHighAvailability: false,
  syncDevice: {},
  syncingDevice: false,
  updateDevice: {},
  updatingDevice: false,

  activityReportsLoading: false,
  activityReportsAppsLoading: false,
  activityReportsVlansLoading: false,
  activityReportsWidgetLoading: false,
  activityReportsCategoryPieLoading: false,
  activityReportsApplicationPieLoading: false,
  activityReportsUsageLineChartLoading: false,
  activityReportsTopAppLineChartUsage: false,
  activityReportsTopUsersLoading: false,
  activityReportsTopSitesLoading: false,
  getAllUsernames: {},
  UsageWidgetsData: {},
  UsageTableData: {},
  getLineChartUsage: {},
  CategoryPieChartUsageData: {},
  getTopApplicationLineChart: {},
  TopSitesTableData: {},
  TopAppTopBlockedPieChartData: {},
  getTopDownloadUploadBlockedApplication: {},
  getTopDownloadUploadBlockedDomain: {},
  getTopDownloadUploadBlockedIp: {},
  getContentFiltersTable: {},
  setActivityReportsBottomTableLoading: false,
  setActivityReportsBottomTableDomainLoading: false,
  setActivityReportsBottomTableIPLoading: false,
  setActivityReportsTopBlockedAppBottomTableLoading: false,
  getAllApplications: {},
  getAllVlans: {},
  riskList: {},
  setTopWidgetRiskScore: false,
  topWidgetAllSiteRiskScore: {},
  topWidgetSingleSiteRiskScore: {},
  setPieChartAllSiteRisk: false,
  getPieChartAllSiteRisk: {},
  getPieChartSingleSiteRisk: {},

  setOperationalUsageDataTableLoading: false,
  getOperationalUsageDataTable: {},
  setOperationalUsageDataTableCountLoading : false,
  getOperationalUsageDataTableCount: {},

  setOperationalUsageTimeseriesTableLoading: false,
  getOperationalUsageTimeseriesTable: {},
  setOperationalUsageTimeseriesTableCountLoading: false,
  getOperationalUsageTimeseriesTableCount: {},
  setOperationalUsageDataSingleSitePerWanWiseLoading: false,
  getOperationalUsageDataSingleSitePerWanWise: {},
  setOperationalUsageFilterDeviceListLoading: false,
  getOperationalUsageFilterDeviceList: {},
  setOperationalUsageFilterSWListLoading: false,
  getOperationalUsageFilterSWList: {},
  setOperationalUsageReportsDownloadLoading: false,
  getOperationalUsageReportsDownload: {}, 

  createDownloadService: {},
  setGeneratedReportsTableLoading: false,
  setGeneratedReportsTableCountLoading: false,
  getGeneratedReportsTable: {},
  getGeneratedReportsTableCount: 0,
  createDownloadServiceFirewall: {},
  createDownloadServiceContentFilter: {},

  setSubscriptionReportsTableLoading: false,
  setSubscriptionReportsTableCountLoading: false,
  getSubscriptionReportsTable: {},
  getSubscriptionReportsTableCount: 0,
  setScheduledReportsTableLoading: false,
  setScheduledReportsTableCountLoading: false,
  getScheduledReportsTable: {},
  getScheduledReportsTableCount: 0,

  auditLogs: {},
  deleteHighAvailability: {},
  deletingHA: false,
  getSimBoxes: {},
  getSimBoxesCount: {},
  getSimBoxesLoading: false,
  hostName: null,
  domainConfig : {},

  getFirewallWidgets: {},
  getFirewallActiveToday: {},
  getFirewallRuleName: {},
  getFirewallRuleNameFilter: {},
  getFirewallTableDataCount: {},
  getFirewallTableData: {},
  getFirewallLineChart: {},
  setFirewallWidgetsLoading: false,
  setFirewallActiveTodayLoading: false,
  setFirewallRuleNameLoading: false,
  setFirewallRuleNameFilterLoading: false,
  setFirewallTableDataCountLoading: false,
  setFirewallTableDataLoading: false,
  setFirewallLineChartLoading: false,

  otpGenerationStatus: false,
  otpErrorStatus: false,

  setTopWidgetAvailability: {},
  setTopWidgetData:{},

  setIamLoginHistoryTable: false,
  setIamLoginHistoryCountLoading: false,
  setIamLoginHistoryTopWidget: false,
  setIamLoginHistoryTimeseriesChart: false,
  setIamLoginHistoryFilterUser: false,
  setIamLoginHistoryFilterApp: false,
  setIamLoginHistoryFilterDescList: false,
  getIamLoginHistoryTable: {},
  getIamLoginHistoryCountLoading: {},
  getIamLoginHistoryTopWidget: {},
  getIamLoginHistoryTimeseriesChart: {},
  getIamLoginHistoryFilterUser: {},
  getIamLoginHistoryFilterApp: {},
  getIamLoginHistoryFilterDescList: {},

  getMaintenanceInfo: {},
  getGroupSettingsData: {},
  getSendGridData: {},
  sendGridDataLoading: false,
  createSmtpData: {},
  getSmtpData: {},
  getMicrosoftEmailData: {},
  createMicrosoftGraphData: {},
  createDNS:  {},
  verifyDNS: {},
  sendTestemail: {},
  smtpTestemail: {},
  msGraphTestemail: {},
  deletesmtpData: {},
  deleteMsgraphData: {},
  deleteSendgridData: {},
  activateSendGrid: {},
  activateSmtp: {},
  activateMsgraph: {},

  saveSSOConfig: {},
  updateSSOConfig: {},
  deleteSSOConfig: {},
  setSSOCode: {},
  ssoOrganizations: [],
  ssoOrganizationsLoading: false,
  domainSSOCheck: null,

  setContentFilterTopUsersTableLoading: false,
  setContentFilterTopUsersTableCountLoading: false,
  setContentFilterTopSitesTableLoading: false,
  setContentFilterTopSitesTableCountLoading: false,
  setContentFilterTableCountLoading: false,
  setContentFilterCategoryPieLoading: false,
  setContentFilterApplicationPieLoading: false,
  setContentFilterSubCategoryPieLoading: false,
  setContentFilterLinechartLoading: false,
  setContentFilterTopWidgetTopSiteLoading: false,
  setContentFilterTopWidgetTopUserLoading: false,
  setContentFilterTopWidgetTopCategoryLoading: false,
  setContentFilterTopWidgetTopDomainLoading: false,
  setContentFilterCategoryListLoading: false,
  setContentFilterAppListLoading: false,
  setContentFilterUserListLoading: false,
  setContentFilterVlanListLoading: false,
  setContentFilterDeviceListLoading: false,
  steContentFilterSubCategoryListLoading: false,
  getContentFilterTopUsersTable: {},
  getContentFilterTopUsersTableCount: {},
  getContentFilterTopSitesTable: {},
  getContentFilterTopSitesTableCount: {},
  getContentFilterTableCount: {},
  getContentFilterCategoryPie: {},
  getContentFilterApplicationPie: {},
  getContentFilterSubCategoryPie: {},
  getContentFilterLinechart: {},
  getContentFilterTopWidgetTopSite: {},
  getContentFilterTopWidgetTopUser: {},
  getContentFilterTopWidgetTopCategory: {},
  getContentFilterTopWidgetTopDomain: {},
  getContentFilterCategoryList: {},
  getContentFilterAppList: {},
  getContentFilterUserList: {},
  getContentFilterVlanList: {},
  getContentFilterDeviceList: {},
  getContentFilterSubCategoryList: {},
  newSummaryStartDate: moment().subtract(60, 'minutes').utc(),
  newSummaryEndDate: moment().utc(),
  newSummaryWanType:WAN_ARRAY && WAN_ARRAY[0],
  newReportType: DEFAULT_REPORT_TYPES && DEFAULT_REPORT_TYPES[0],
  newSummaryMonth: moment().utc().format('MMM'),
  newSummaryYear: moment().utc().format('YYYY'),
  newSummaryServiceLine: ["All"],
  newSummaryServiceAccount: ["All"],
   newSummaryServiceLineTotal : ["All"],
  hasUserChangedServiceLine: false,
  selectedServiceAccount: ["All"],
  getDrawerOpen: true,
  setDashboardPieUsageperWantypeLoading: false,
  setDashboardHistogramUsagePerWantypeLoading: false,
  setDashboardHistogramUsagePerSiteLoading:false,
  setDashboardUsagePieTop10AppsLoading: false,
  setDashboardPieWanUsageBySiteLoading: false,
  setDashboardUsageHistogramUpDownLinkLoading: false,
  setDashboardUsageHistogramBySiteLoading: false,
  setDashboardUptimeSiteStatisticsTableLoading: false,
  setDashboardUptimeLinechartByWanLoading: false,
  setDashboardUptimeLinechartBySiteLoading: false,
  setDashboardUptimePiechartBySiteLoading: false,
  setDashboardUptimePiechartByWanLoading: false,
  newUsageperWantype: {},
  newHistogramUsageperWantype: {},
  newHistogramBySiteCount:{},
  newUsagePieTop10Apps: {},
  wanUsageBySites: {},
  newSummaryUsageTable: {},
  newSummaryUsageTableLoading: false,
  newSummaryUploadDownload: {},
  newSummaryUptimeAllLinks:{},
  newSummaryUptimeAllLinksLoading: false,
  newSummaryHistogramBySite: {},
  newSummaryUptimeTable: {},
  newSummaryUptimeLinechart: {},
  newSummaryUptimePiechart: {},
  newSummaryUptimeLineChartBySite: {},
  newSummaryUptimePiechartByWan: {},
  csvDataDownloded: [],
  csvDownloadId: '',
  csvDownloadLoading: false,
  newSummaryAlertPieChartByNameLoading: false,
  newSummaryAlertPieChartBySiteLoading: false,
  newSummaryAlertLineChartByNameLoading: false,
  newSummaryAlertLineChartBySiteLoading: false,
  newSummaryAlertTopWidgetLoading: false,
  alertPieChartByName: {},
  alertPieChartBySite: {},
  alertLineChartByName: {},
  alertLineChartBySite: {},
  alertTopWidget: {},
  isReadOnlyUser: false,
  privateVesselList: {},
  privateVesselListLoading: false,
  isPrivateLoading: false,
  isPrivateEnabled: false,
  setWanProfilePerDeviceLoading: false,
  wanProfilesPerDevice: {},
  setAdvancedBondingLoading: false,
  getAdvancedBonding: {},
  setLANStatusLoading: false,
  getLANStatus: {},
  setConnectedHubLoading: false,
  getConnectedHub: {},

  setSystemHealthDevicesLoading: false,
  setSystemHealthCpuChartLoading: false,
  setSystemHealthMemoryChartLoading: false,
  setSystemHealthContrackChartLoading: false,
  setSystemHealthRxDropsChartLoading: false,
  setSystemHealthSwapChartLoading: false,
  setSystemHealthTemperatureChartLoading: false,
  setSystemHealthDiskStorageChartLoading: false,
  setSystemHealthFlowCountChartLoading: false,
  systemHealthDevices: {},
  systemHealthCpuChart: {},
  systemHealthMemoryChart: {},
  systemHealthContrackChart: {},
  systemHealthRxDropsChart: {},
  systemHealthSwapChart: {},
  systemHealthTemperatureChart: {},
  systemHealthDiskStorageChart: {},
  systemHealthFlowCountTable: {},

  setHubDataLoading: false,
  hubDataTableRow: {},
  setHubDataCountLoading: false,
  hubDataTableRowCount: {},
  setHubDataClientTableLoading: false,
  hubDataClientTable: {},
  hubDataSitesDropdownLoading: false,
  getHubVesselListing: {},

  createAgentWan: {},
  createAgentWanLoading: false,
  updateAgentWan: {},
  updateAgentWanLoading: false,
  deleteAgentWan: {},
  deleteAgentWanLoading: false,
  getAgentWans: [],
  getAgentWansLoading: false,

  createAgentWanProfile: {},
  createAgentWanProfileLoading: false,
  updateAgentWanProfile: {},
  updateAgentWanProfileLoading: false,
  deleteAgentWanProfile: {},
  deleteAgentWanProfileLoading: false,
  getAgentWanProfiles: [],
  getAgentWanProfilesLoading: false,

  createAgentHub: {},
  createAgentHubLoading: false,
  getAgentHubs: [],
  getAgentHubsLoading: false,
  getAgentHubsPerService: [],
  getAgentHubsPerServiceLoading: false,

  createAgentServiceVlan: {},
  createAgentServiceVlanLoading: false,
  getAgentServiceVlans: [],
  getAgentServiceVlansLoading: false,

  createAgentService: {},
  createAgentServiceLoading: false,
  updateAgentService: {},
  updateAgentServiceLoading: false,
  getAgentServices: [],
  getAgentServicesLoading: false,

  createAgentProfile: {},
  createAgentProfileLoading: false,
  getAgentProfiles: [],
  getAgentProfilesLoading: false,

  createAgentRoute: {},
  createAgentRouteLoading: false,
  getAgentRoutes: [],
  getAgentRoutesLoading: false,

  createAgentConfig: {},
  createAgentConfigLoading: false,
  getAgentConfigs: [],
  getAgentConfigsLoading: false,

  createAgent: {},
  createAgentLoading: false,
  getAgents: [],
  getAgentsLoading: false,

  getAgentConfigSummary: {},
  getAgentConfigSummaryLoading: false,
  getHub4AgentConfigSummary: {},
  getHub4AgentConfigSummaryLoading: false,

  createAgentAccessNetwork: {},
  createAgentAccessNetworkLoading: false,
  updateAgentAccessNetwork: {},
  updateAgentAccessNetworkLoading: false,
  verifyAgentConfig: {},
  verifyAgentConfigLoading: false,
  uploadAgentConfig: {},
  uploadAgentConfigLoading: false,
  updateUploadAgentConfig: {},
  updateUploadAgentConfigLoading: false,
  deleteAgentConfig: {},
  deleteAgentConfigLoading: false,
  agentConfigRowDownload: {},
  agentConfigRowDownloadLoading: false,
  agentConfigSummary: {},
  agentConfigSummaryDownload: false,

  getAgentHubEvents: [],
  getAgentHubEventsLoading: false,
  getAgentHubEventFilters: [],
  getAgentHubEventFiltersLoading: false,
  hubEventDetails: {},
  hubEventFilters: {},
  hubEventsFiltersLoading: false,

  threatTopWidgetData: {},
  threatTopCrossBarData: {},
  threatTopCrossBarDataLoading: false,
  threatTopWidgetLoading: false,
  topThreatServerityData: {},
  topThreatServerityDataLoading: false,
  threatBySeverityBarChart: {},
  theatBySeverityBarChartLoading: false,
  top10ThreatTableData: {},
  top10ThreatTableDataLoading: false ,
  allThreatTableData: {},
  allThreatTableDataLoading: false ,
  newSummarySeverityType: THREAT_SEVERITY_ARRAY && THREAT_SEVERITY_ARRAY[0],
  topwidgetTotalLoading: false,
  topwidgetTotal: {},
  allThreatSiteList: {},
  allThreatSiteListLoading: false,
  allThreatDeviceList: {},
  allTheratDeviceListLoading: false,
  userThreatTableData: {},
  userThreatTableDataLoading: false ,
  threatFilters: {},
  threatUniqueDeviceList: {},
  threatUniqueDeviceListLoading: false,
  threatUniqueIpList: {},
  threatUniqueIpListLoading: false,
  threatUniqueClassList: {},
  threatUniqueClassListLoading: false,
  threatUniqueThreatNameList: {},
  threatUniqueThreatNameListLoading: false,
  threatUniqueActionList: {},
  threatUniqueActionListLoading: false,
  threatActionPieData: {},
  threatAcyionPieDataLoading: false,
  threatSeverityClassList: {},
  threatSeverityClassListLoading: false,
  threatKontrolLoading: false,
  createThreatKontrol: {},
  updateThreatKontrol: {},
  deleteThreatkontrol: {},
  threatList: {},
  threatListLoading: false,
  threatNamesList: {},
  threatNamesListLoading: false,

  captiveUsagePieData: {},
  captiveUsagePieDataLoading: false,
  captiveSubsPieData: {},
  captiveSubsPieDataLoading: false,

  captiveSitesOverageUsagebar: {},
  captiveSitesOverageUsagebarLoading: false,
  captiveSitesOverageUsagelinechart: {},
  captiveSitesOverageUsagelinechartLoading: false,
  captiveSubscribersOverageUsagebar: {},
  captiveSubscribersOverageUsagebarLoading: false,
  captiveTopPlansOverageUsagebar: {},
  captiveTopPlansOverageUsagebarLoading: false,
  captiveTopPlanOverageUsagelinechart: {},
  captiveTopPlanOverageUsagelinechartLoading: false,
  captiveSitesOverageHistogram: {},
  captiveSitesOverageHistogramLoading: false,
  captivePlanSubscribersOverageHistogram: {},
  captivePlanSubscribersOverageHistogramLoading: false,

  flightSchedulingDataLoading: false,
  flightSchedulingdata: {},
  flightTailIdUpdateTableLoading: false,
  flightTailIdUpdateTable: {},
  flightTailIdUpdateTableCountLoading: false,
  flightTailIdUpdateTableCount: {},
  flightScheduleTableLoading: false,
  flightScheduleTable: {},
  flightScheduleTableCountLoading: false,
  flightScheduleTableCount: {},

  wanUsageReportSingleSiteNetworkUsageLoading: false,
  wanUsageReportSingleSiteNetworkUsage: {},
  wanUsageReportSingleSiteAllInterfaceUsageLoading: false,
  wanUsageReportSingleSiteAllInterfaceUsage: {},
  WanUsageSingleSiteWanSelectionNetworkUsageLoading: false,
  WanUsageSingleSiteWanSelectionNetworkUsage: {},
  WanUsageSingleSiteVsatSelectionNetworkUsageLoading: false,
  WanUsageSingleSiteVsatSelectionNetworkUsage: {},
  WanUsageSingleSiteInterfaceUsageLoading: false,
  WanUsageSingleSiteInterfaceUsage: {},
  orgHirarchy: {},
  networkTopologySiteSetails: {},
  networkTopologySiteSetailsLoading: false,
  networkTopologyDeviceInfo: {},
  networkTopologyDeviceInfoLoading: false,
  hubInternetDropoffListLoading: false,
  hubInternetDropoffList: {},
  networkTopologyPerDeviceDetails: {},
  netoworkTopologyTopcards: {},
  networkTopologyTopcardsLoading: false,
  trendsLanTableData: {
    network: null,
    client: null,
  },
  getAnalyticsTopCards: {},

};

export default function authReducer(state: any = initialState, action: any): any {

  switch (action.type) {
    case SET_SIDE_MENU:
      return {
        ...state,
        sideMenu: action.payload,
      };
    case FETCH_DP_WISE_SIDEMENU:
      return {
        ...state,
        dpWiseSideMenu: action.payload,
      };
    case FETCH_DP_WISE_SIDEMENU_LOADING:
      return {
        ...state,
        dpWiseSideMenuLoading: action.payload,
      };
    case SET_USER_OU:
      return {
        ...state,
        userOu: action.payload,
      };
    case SET_READONLY_USER:
      return {
        ...state,
        isReadOnlyUser: action.payload,
      };
    case SET_SELECTED_OU:
      return {
        ...state,
        selectedOu: action.payload,
        getVesselsListing: {},
        // getInventoryWarehouseVesselList: {}
      };
    case SET_PRIVATE_VESSEL_LIST: 
      return {
        ...state,
        privateVesselList: action.payload,
        privateVesselListLoading: false
      }
    case SET_PRIVATE_VESSEL_LIST_LOADING:
      return {
        ...state,
        privateVesselListLoading: action.payload
      }
    case SET_IS_USER_OU_HAS_SUB_OUS:
      return {
        ...state,
        isUserOuHasSubOus: action.payload,
      };
    case SET_PARENT_AND_SUBDP_LIST: 
      return {
        ...state,
        parentDpAndSubDpList: action.payload
      };
    case SET_SELECTED_VESSELS:
      return {
        ...state,
        selectedVessels: action.payload,
      };
    case SET_FILTERED_VESSELS:
      // when same filter or the vessel is in use, to avoid api call
      if (_.isEqual(state.filteredVessels, action.payload)) return state;
      return {
        ...state,
        filteredVessels: action.payload,
      };
    case SET_HUB_FILTERED_VESSELS:
      if (_.isEqual(state.hubFilteredVessels, action.payload)) return state;
      return {
        ...state,
        hubFilteredVessels: action.payload,
      };
    case SET_SELECTED_VESSEL:
      return {
        ...state,
        selectedVessel: action.payload,
      };
    case SET_SELECTED_AGENT:
      return {
        ...state,
        selectedAgent: action.payload,
      };
    case SET_PERMISSION_OBSERVER:
      return {
        ...state,
        permissionObserver: action.payload
      };
    case SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
      case LIMITED_REPORT_ACCESS:
      return {
        ...state,
        limited_report_access: action.payload,
      };
      case SITE_ADMIN_ACCESS:
      return {
        ...state,
        site_admin_access: action.payload,
      };
        case SL_ADMIN_ACCESS:
      return {
        ...state,
        sl_admin_access: action.payload,
      };
       case CALL_SCHEDULED_REPORT:
      return {
        ...state,
        call_scheduled_report: action.payload,
      };
    case LOGIN_USER:
      initialState.hostName = state?.hostName
      initialState.domainConfig = state?.domainConfig
      initialState.domainSSOCheck = state?.domainSSOCheck
      return {
        ...initialState,
        loginUser: action.payload,
      };
    case OTP_GENERATION_STATUS: {
        initialState.hostName = state?.hostName
        initialState.domainConfig = state?.domainConfig
        initialState.domainSSOCheck = state?.domainSSOCheck
        return {
            ...initialState,
            otpGenerationStatus: action.payload
        }
    }
    case OTP_ERROR: {
      return {
        ...initialState,
        otpErrorStatus: action.payload,
      }
    }
    case LOGOUT_USER:
      return {
        ...state,
        logoutUser: action.payload,
      };
    case FETCH_VESSEL:
      return {
        ...state,
        fetchVessel: action.payload,
      };
    case SET_FETCH_USERS_LOADING:
      return {
        ...state,
        usersListLoading: action.payload,
      };
    case IS_PRIVATE_LOADING:
      return {
        ...state,
        isPrivateLoading: action.payload
      }
    case IS_PRIVATE_ENABLED:
      return {
      ...state,
      isPrivateEnabled: action.payload
    }
    case FETCH_USERS:
      return {
        ...state,
        usersList: action.payload,
        usersListLoading: false
      };
    case SET_VESSEL_PLANS_LOADING:
      return {
        ...state,
        vesselPlansLoading: action.payload,
      };
    case GET_VESSEL_PLANS:
      return {
        ...state,
        vesselPlans: action.payload,
        vesselPlansLoading: false
      };
    case GET_USER_POLICY:
      return {
        ...state,
        userPolicy: action.payload,
      };
    case INVITE_USER_LOADING:
      return {
        ...state,
        inviteUserLoading: action.payload
      };
    case INVITE_USER:
      return {
        ...state,
        inviteUser: action.payload,
        inviteUserLoading: false
      };
    case RESEND_INVITE_LOADING:
      return {
        ...state,
        resendInviteLoading: action.payload
      };
    case RESEND_INVITE:
      return {
        ...state,
        resendInvite: action.payload,
        resendInviteLoading: false
      };
    case GET_ORGANISATIONS:
      return {
        ...state,
        getOrganisationList: action.payload,
      };
    case SET_SEARCH_ALERTS_LOADING:
      return {
        ...state,
        searchAlertsLoading: action.payload,
      };
    case SEARCH_ALERTS:
      return {
        ...state,
        searchAlerts: action.payload,
        searchAlertsLoading: false
      };
    case OU_DERIVED:
      return {
        ...state,
        ouDerived: action.payload
      }
    case GET_VESSEL_EDGE_INFO:
      return {
        ...state,
        vesselEdgeInfo: action.payload
      }
    case SET_FETCH_OU_RESOURCES_LOADING:
      return {
        ...state,
        fetchResourcesLoading: action.payload
      }
    case FETCH_OU_RESOURCES:
      return {
        ...state,
        fetchResources: action.payload,
        fetchResourcesLoading: false
      }
      case FETCH_SITE_LIST:
      return {
        ...state,
        fetchSiteList: action.payload,
        fetchResourcesLoading: false
      }
      case FETCH_SERVICE_LINE_LIST:{
        return {
          ...state,
          fetchServiceLineList:action.payload,
          fetchResourcesLoading: false
        }
      }
    case FETCH_SERVICE_LINES:
        return {
          ...state,
          fetchServiceLines: action.payload,
          fetchResourcesLoading: false
        }
      case FETCH_SERVICE_LINES_FOR_SUBSCRIPTION:
        return {
          ...state,
          fetchServiceLinesForSubscription: action.payload,
          fetchResourcesLoading: false
        }
    case OU_POLICY:
      return {
        ...state,
        organizationpolicy: action.payload
      }
    case USER_DETACH_LOADING:
      return {
        ...state,
        userDetachLoading: action.payload
      }
    case USER_DETACH:
      return {
        ...state,
        userdetch: action.payload,
        userDetachLoading: false
      }
    case SET_TICKETS_LOADING:
      return {
        ...state,
        getTicketsLoading: action.payload
      }
    case GET_TICKETS:
      return {
        ...state,
        getTickets: action.payload,
        getTicketsLoading: false
      }
    case DISPLAY_APPLICABLE_USER_POLICIES:
      return {
        ...state,
        displayApplicableUserPolicies: action.payload
      }
    case POLICIES_DETAILS:
      return {
        ...state,
        policiesDetails: action.payload
      }
    case UPDATE_USER_LOADING:
      return {
        ...state,
        updateUserLoading: action.payload,
      }
    case UPDATE_USER:
      return {
        ...state,
        UpdateUser: action.payload,
        updateUserLoading: false,
      }
    case UPDATE_USER_ORGANIZATION_LOADING:
      return {
        ...state,
        updateUserOrganizationLoading: action.payload,
      }
    case UPDATE_USER_ORGANIZATION:
      return {
        ...state,
        updateUserOrganization: action.payload,
        updateUserOrganizationLoading: false,
      }
    case SET_TICKET_DETAILS_LOADING: {
      return {
        ...state,
        setTicketDetailsLoading: action.payload
      }
    }
    case GET_TICKET_DETAILS:
      return {
        ...state,
        getTicketDetails: action.payload,
        setTicketDetailsLoading: false
      }
    case GET_HOT_VESSELS:
      return {
        ...state,
        getHotVessels: action.payload
      }
    case SET_TICKET_COMMENTS_LOADING: {
      return {
        ...state,
        setTicketCommentsLoading: action.payload
      }
    }
    case GET_TICKET_COMMENTS:
      return {
        ...state,
        getTicketComments: action.payload,
        setTicketCommentsLoading: false
      }
    case SET_TICKET_ATTACHMENTS_LOADING: {
      return {
        ...state,
        setTicketAttachmentsLoading: action.payload
      }
    }
    case GET_TICKET_ATTACHMENTS:
      return {
        ...state,
        getTicketAttachments: action.payload,
        setTicketAttachmentsLoading: false
      }
    case GET_SINGLE_TICKET_ATTACHMENTS:
      return {
        ...state,
        getSingleTicketAttachments: action.payload
      }
    case SET_TICKET_DETAILS_FIELD_LOADING: {
      return {
        ...state,
        setTicketFieldsLoading: action.payload
      }
    }
    case GET_TICKET_DETAILS_FIELD:
      return {
        ...state,
        getTicketFields: action.payload,
        setTicketFieldsLoading: false
      }
    case UPDATE_TICKET:
      return {
        ...state,
        updateTicket: action.payload
      }
    case CREATE_NEW_TICKET:
      return {
        ...state,
        createNewTicket: action.payload
      }
    case ADD_ATTACHMENTS_TO_TICKET:
      return {
        ...state,
        addAttachmentsToTicket: action.payload
      }
    case SEND_TICKET_EMAIL:
      return {
        ...state,
        sendTicketEmail: action.payload
      }
    case SEND_TICKET_COMMENT:
      return {
        ...state,
        sendTicketComment: action.payload
      }
    case SET_TICKET_HISTORY_LOADING: {
      return {
        ...state,
        setTicketHistoryLoading: action.payload
      }
    }
    case GET_TICKET_HISTORY:
      return {
        ...state,
        getTicketHistory: action.payload,
        setTicketHistoryLoading: false
      }
    case GET_TICKET_AGENTS_BY_NAME:
      return {
        ...state,
        getTicketAgentsByName: action.payload
      }
    case GET_TICKET_ALL_AGENTS:
      return {
        ...state,
        getTicketAllAgents: action.payload
      }
      case GET_DP_DATA:
      return {
        ...state,
        getDpAddressData: action.payload
      }
    case ENABLE_USER_ACCOUNT_LOADING:
      return {
        ...state,
        enableUserAccountLoading: action.payload
      }
    case ENABLE_USER_ACCOUNT:
      return {
        ...state,
        enableUserAccount: action.payload,
        enableUserAccountLoading: false
      }
    case DISABLE_USER_ACCOUNT_LOADING:
      return {
        ...state,
        disableUserAccountLoading: action.payload
      }
    case DISABLE_USER_ACCOUNT:
      return {
        ...state,
        disableUserAccount: action.payload,
        disableUserAccountLoading: false
      }
    case DELETE_ALERT:{
      return {
        ...state,
        deleteAlert: action.payload,
        deleteAlertLoading: false
      }
    }
    case DELETE_ALERT_LOADING:{
      return {
        ...state,
        deleteAlertLoading: action.payload
      }
    }
    case GET_DP_ALERTS:{ 
      return{
        ...state,
        dpAlerts: action.payload,
        dpAlertsLoading: false
      }  
    }
    case GET_DP_ALERTS_LOADING:
      return {
        ...state,
        dpAlertsLoading: action.payload
      }
    case UPDATE_DP_ALERT:{
      return {
        ...state,
        updateDpAlert: action.payload,
        updateDpAlertLoading: false
      }
    }
    case UPDATE_DP_ALERT_LOADING:
      return {
        ...state,
        updateDpAlertLoading: action.payload
      }
    case UPDATE_DP_ALERT_NOTIFICATION:{
      return {
        ...state,
        updateDpAlertNotification: action.payload,
        updateDpAlertNotificationLoading: false
      }
    }
    case UPDATE_DP_ALERT_NOTIFICATION_LOADING:
      return {
        ...state,
        updateDpAlertNotificationLoading: action.payload
      }
    case UPDATE_DP_ALERT_STATUS:{
      return {
        ...state,
        updateDpAlertStatus: action.payload,
        updateDpAlertStatusLoading: false
      }
    }
    case UPDATE_DP_ALERT_STATUS_LOADING:
      return {
        ...state,
        updateDpAlertStatusLoading: action.payload
      }
    case UPDATE_SITE_ALERT_STATUS:{
      return {
        ...state,
        updateSiteAlertStatus: action.payload,
        updateSiteAlertStatusLoading: false
      }
    }
    case UPDATE_SITE_ALERT_STATUS_LOADING:
      return {
        ...state,
        updateSiteAlertStatusLoading: action.payload
      }
    case DELETE_DP_ALERT_LINK_AVAILABILITY:{
      return {
        ...state,
        deleteDpAlertLinkAvailability: action.payload,
        deleteDpAlertLALoading: false
      }
    }
    case DELETE_DP_ALERT_LINK_AVAILABILITY_LOADING:
      return {
        ...state,
        deleteDpAlertLALoading: action.payload
      }
    case GET_DP_ALERT_AUDIT_LOGS:{ 
      return{
        ...state,
        dpAlertAuditLogs: action.payload,
        dpAlertLogsLoading: false
      }  
    }
    case GET_DP_ALERT_AUDIT_LOGS_LOADING:
      return {
        ...state,
        dpAlertLogsLoading: action.payload
      }
    case GET_SITE_ALERTS:{ 
      return{
        ...state,
        siteAlerts: action.payload,
        siteAlertsLoading: false
      }  
    }
    case GET_SITE_ALERTS_LOADING:
      return {
        ...state,
        siteAlertsLoading: action.payload
      }
    case UPDATE_SITE_ALERT:{
      return {
        ...state,
        updateSiteAlert: action.payload,
        updateSiteAlertLoading: false
      }
    }
    case UPDATE_SITE_ALERT_LOADING:
      return {
        ...state,
        updateSiteAlertLoading: action.payload
      }
    case UPDATE_SITE_ALERT_NOTIFICATION:{
      return {
        ...state,
        updateSiteAlertNotification: action.payload,
        updateSiteAlertNotificationLoading: false
      }
    }
    case UPDATE_SITE_ALERT_NOTIFICATION_LOADING:
      return {
        ...state,
        updateSiteAlertNotificationLoading: action.payload
      }
    case DELETE_SITE_ALERT_LINK_AVAILABILITY:{
      return {
        ...state,
        deleteSiteAlertLinkAvailability: action.payload,
        deleteSiteAlertLALoading: false
      }
    }
    case DELETE_SITE_ALERT_LINK_AVAILABILITY_LOADING:
      return {
        ...state,
        deleteSiteAlertLALoading: action.payload
      }
    case GET_SITE_ALERT_AUDIT_LOGS:{ 
      return{
        ...state,
        siteAlertAuditLogs: action.payload,
        siteAlertLogsLoading: false
      }  
    }
    case GET_SITE_ALERT_AUDIT_LOGS_LOADING:
      return {
        ...state,
        siteAlertLogsLoading: action.payload
      }
    case SET_VESSEL_ALERTS_LOADING:
      return {
        ...state,
        vesselAlertsLoading: action.payload
      }
    case GET_VESSEL_ALERTS:
      return {
        ...state,
        vesselAlerts: action.payload,
        vesselAlertsLoading: false
      }
    case SET_VESSEL_DASHBOARD_LOADING:
      return {
        ...state,
        vesselDashboardLoading: action.payload
      }
    case SET_VESSEL_WAN_LINK_STATUS_LOADING:
      return {
        ...state,
        vesselWanLinkStatusLoading : action.payload
      }
    case SPORTS_SITE_SUMMARY_COUNT_LOADING:
      return {
        ...state,
        sportSiteSummaryCountLoading: action?.payload
      }
    case GET_VESSEL_SUMMARY_DASHBOARD:
      return {
        ...state,
        vesselDashboardSummary: action.payload,
        vesselDashboardLoading: false
      }
    case GET_WIDGEY_SUMMARY_DASHBOARD:
      return {
        ...state,
        widgetDashboardSummary: action.payload,
        vesselDashboardLoading: false
      }
    case GET_TOP_WIDGET_WANLINK_STATUS_NEW_SUMM:
      return {
        ...state,
        topWidgetLinkStatus: action.payload,
        vesselDashboardLoading: false
      }
    case GET_THREAT_DASHBOARD_TOPWIDGET:
      return {
        ...state,
        threatTopWidgetData: action.payload,
        threatTopWidgetLoading: false,
      }
    case SET_THREAT_DASHBOARD_TOPWIDGET_LOADING: 
      return {
        ...state,
        threatTopWidgetLoading: true
      }
    case GET_THREAT_DASHBOARD_TOPWIDGET_TOTAL:
      return {
        ...state,
        topwidgetTotal: action.payload,
        topwidgetTotalLoading: false,
      }
    case SET_THREAT_DASHBOARD_TOPWIDGET_TOTAL_LOADING: 
      return {
        ...state,
        topwidgetTotalLoading: true
      }
    case GET_TOP_10_THREAT_BY_NAME:
      return {
        ...state,
        threatTopCrossBarData: action.payload,
        threatTopCrossBarDataLoading: false,
      }
    case SET_TOP_10_THREAT_BY_NAME_LOADING:
      return {
        ...state,
        threatTopCrossBarDataLoading: true
      }
    case GET_TOP_10_THREAT_BY_SEVERITY:
      return {
        ...state,
        topThreatServerityData: action.payload,
        topThreatServerityDataLoading: false,
      }
    case SET_TOP_10_THREAT_BY_SERVERITY_LOADING:
      return {
        ...state,
        topThreatServerityDataLoading: true
      }
    case SET_THREAT_DASHBOARD_TOPWIDGET_LOADING: 
      return {
        ...state,
        threatTopWidgetLoading: true
      }
    case GET_THREAT_DASHBORAD_BAR_CHART_ON_SEVERITY:
      return {
        ...state,
        threatBySeverityBarChart: action.payload,
        theatBySeverityBarChartLoading: false
      }
    case GET_THREAT_DASHBORAD_BAR_CHART_ON_SEVERITY_LOADING:
      return {
        ...state,
        theatBySeverityBarChartLoading: true
      }
    case GET_TOP_10_THREAT_TABLE_DATA:
      return {
        ...state,
        top10ThreatTableData: action.payload,
        top10ThreatTableDataLoading: false
      }
    case SET_THREAT_DASHBOARD_TOP_10_THREAT_TABLE_LOADING:
      return {
        ...state,
        top10ThreatTableDataLoading: true ,
      }
    case GET_ALL_THREAT_TABLE_DATA:
      return {
        ...state,
        allThreatTableData: action.payload,
        allThreatTableDataLoading: false
      }
    case SET_THREAT_DASHBOARD_ALL_THREAT_TABLE_LOADING:
      return {
        ...state,
        allThreatTableDataLoading: true ,
      }
    case GET_USER_THREAT_TABLE_DATA:
    return {
      ...state,
      userThreatTableData: action.payload,
      userThreatTableDataLoading: false
    }
    case SET_THREAT_DASHBOARD_USER_THREAT_TABLE_LOADING:
      return {
        ...state,
        userThreatTableDataLoading: true ,
      }

    case GET_THREAT_SITE_LIST:
      return {
        ...state,
        allThreatSiteList: action.payload,
        allThreatSiteListLoading: false
      }
    case GET_THREAT_SITE_LIST_LOADING:
      return {
        ...state,
        allThreatSiteListLoading: true ,
      }
    case GET_THREAT_UNIQUE_ACTION_LIST:
      return {
        ...state,
        threatUniqueActionList: action.payload,
        threatUniqueActionListLoading: false
      }
    case GET_THREAT_UNIQUE_ACTION_LIST_LOADING:
      return {
        ...state,
        threatUniqueActionListLoading: true ,
      }
    case GET_THREAT_DEVICE_LIST:
      return {
        ...state,
        allThreatDeviceList: action.payload,
        allTheratDeviceListLoading: false
      }
    case GET_THREAT_DEVICE_LIST_LOADING:
      return {
        ...state,
        allTheratDeviceListLoading: true ,
      }
    case SET_THREAT_FILTERS:
      return {
        ...state,
        threatFilters: action.payload
      }
    case GET_THREAT_UNIQUE_DEVICE_LIST_LOADING:
      return {
        ...state,
        threatUniqueDeviceListLoading: true,
      }
    case GET_THREAT_UNIQUE_DEVICE_LIST:
      return {
        ...state,
        threatUniqueDeviceList: action.payload,
        threatUniqueDeviceListLoading : false
      }
    case GET_THREAT_UNIQUE_IP_LIST_LOADING:
      return {
        ...state,
        threatUniqueIpListLoading: true ,
      }
    case GET_THREAT_UNIQUE_IP_LIST:
      return {
        ...state,
        threatUniqueIpList: action.payload,
        threatUniqueIpListLoading : false
      }
    case GET_THREAT_UNIQUE_CLASS_LIST_LOADING:
      return {
        ...state,
        threatUniqueClassListLoading: true ,
      }
    case GET_THREAT_UNIQUE_CLASS_LIST:
      return {
        ...state,
        threatUniqueClassList: action.payload,
        threatUniqueClassListLoading : false
      }
    case GET_THREAT_UNIQUE_THREATNAME_LIST_LOADING:
      return {
        ...state,
        threatUniqueThreatNameListLoading: true,
      }
    case GET_THREAT_UNIQUE_THREATNAME_LIST:
      return {
        ...state,
        threatUniqueThreatNameList: action.payload,
        threatUniqueThreatNameListLoading: false
      }
    case GET_THREAT_ACTION_PIE_DATA:
    return {
      ...state,
      threatActionPieData: action.payload,
      threatAcyionPieDataLoading : false
    }
    case SET_THREAT_ACTION_PIE_DATA_LOADING:
      return {
        ...state,
        threatAcyionPieDataLoading: true,
      }
    case SET_THREAT_SEVERITY_CLASS_LIST_LOADING:
      return {
        ...state,
        threatSeverityClassListLoading: true
      } 
    case SET_THREATNAMES_LIST_LOADING:
      return {
        ...state,
        threatNamesListLoading: true
      }
    case GET_THREAT_SEVERITY_CLASS_LIST:
      return {
        ...state,
        threatSeverityClassList: action.payload,
        threatSeverityClassListLoading: false
      }
    case GET_THREATNAMES_LIST:
      return {
        ...state,
        threatNamesList: action.payload,
        threatNamesListLoading: false
      }
    case SET_THREATS_LOADING: 
      return {
        ...state,
        threatListLoading: true
      }
    case GET_THREATS:
      return {
        ...state,
        threatList: action.payload,
        threatListLoading: false
      }
    case SET_SNORT_RULES_DETAILS: {
      return {
        ...state,
        setSnortRulesDetailsLoading: action.payload
      }
    }
    case GET_SNORT_RULES_DETAILS: {
      return {
        ...state,
        getSnortRules: action.payload,
        setSnortRulesDetailsLoading: false
      }
    }
    case GET_CAPTIVE_USGAE_PIE_DATA:
      return {
        ...state,
        captiveUsagePieData: action.payload,
        captiveUsagePieDataLoading : false
      }
    case SET_CAPTIVE_SUBS_PIE_DATA_LOADING:
      return {
        ...state,
        captiveSubsPieDataLoading: true,
      }
      case GET_CAPTIVE_SUBS_PIE_DATA:
    return {
      ...state,
      captiveSubsPieData: action.payload,
      captiveSubsPieDataLoading : false
    }
    case SET_CAPTIVE_USAGE_PIE_DATA_LOADING:
      return {
        ...state,
        captiveSubsPieDataLoading: true,
      }
    case GET_WIDGET_LINK_STATUS_SUMMARY_DASHBOARD:
      return {
        ...state,
        widgetLinkStatusDashboardSummary: action.payload,
        vesselWanLinkStatusLoading: false
      }
    case GET_NEW_SUMMARY_USAGE_TABLE_LOADING: {
      return {
        ...state,
        newSummaryUsageTableLoading: action.payload
      }
    }
    case GET_NEW_SUMMARY_USAGE_TABLE:
      return {
        ...state,
        newSummaryUsageTable: action.payload,
        newSummaryUsageTableLoading: false
      }
    case GET_VESSEL_SUMMARY_TABLE_COUNT:
      return {
        ...state,
        vesselSummaryTableDataCount: action.payload,
        vesselTableCountLoading:false
      }
    case SET_VESSEL_SUMMARY_LOADING:
      return {
        ...state,
        vesselSummaryLoading: action.payload
      }
    case SET_VESSEL_TABLE_COUNT_LOADING:
      return {
        ...state,
        vesselTableCountLoading: action.payload
      }
    case GET_VESSEL_SUMMARY_TABLE:
      return {
        ...state,
        vesselSummaryTableData: action.payload,
        vesselSummaryLoading: false
      }
    case CLEAR_SITE_DASHBOARD:
      return {
        ...state,
        vesselSummaryTableData: {},
        vesselSummaryTableDataCount: null,
        widgetLinkStatusDashboardSummary: {},
        widgetDashboardSummary: {},
        vesselDashboardSummary: {}
      }
    case GET_VESSEL_LOC_WITH_ALERTS_LOADING:
      return {
        ...state,
        vesselLocWithAlertsLoading: action.payload
      }
    case GET_VESSEL_LOC_WITH_ALERTS:
      return {
        ...state,
        vesselLocWithAlerts: action.payload,
        vesselLocWithAlertsLoading: false
      }
    case MARK_AS_FIXED_ALERT:
      return {
        ...state,
        markAsFixedAlert: action.payload
      }
    case ALERTS_NAME:
      return {
        ...state,
        alertnames: action.payload
      }
    case ALERTS_HISTORY:
      return {
        ...state,
        alertHistory: action.payload
      }
    case GET_SYSTEM_INVENTORY:
      return {
        ...state,
        inventory: action.payload
      }
    case GET_EDGE_SERVER_STATUS_LOADING:
      return {
        ...state,
        edgeServerStatusLoading: action.payload
      }
    case GET_EDGE_SERVER_STATUS:
      return {
        ...state,
        edgeServerStatus: action.payload,
        edgeServerStatusLoading: false
      }
    case RECOVERY_PASSWORD_USER:
      return {
        ...state,
        recoveryPasswordUser: action.payload
      }

    case CHANGE_PASSWORD:
      return {
        ...state,
        changePassword: action.payload
      }
    case SET_PASSWORD_User_LOADING:
      return {
        ...state,
        setPasswordUserLoading: action.payload
      }
    case SET_PASSWORD_User:
      return {
        ...state,
        setPasswordUser: action.payload,
        setPasswordUserLoading: false,
      }
    case GET_USER_DETAILS:
      return {
        ...state,
        userDetails: action.payload
      }
    case VERIFY_USER:
      return {
        ...state,
        verifyUser: action.payload,
      }
    case RESET_PASSWORD:
      return {
        ...state,
        resetPassword: action.payload
      }
    case UPDATE_USER_PROFILE:
      return {
        ...state,
        updateUserProfile: action.payload
      }
    case USER_PREFERENCES_LOADING:
      return {
        ...state,
        userPreferencesLoading: action.payload,
      }
    case UPDATE_USER_PREFERENCES:
      return {
        ...state,
        updateUserPreferences: action.payload,
        userPreferencesLoading: false
      }
    case GET_USER_PREFERENCES:
      return {
        ...state,
        getUserPreferences: action.payload
      }
    case USER_TIMEZONE:
      return {
        ...state,
        userTimezone: action.payload
      }
    case DETACH_RESOURCE_OU:
      return {
        ...state,
        detachResource: action.payload
      }
    case NOT_ATTACH_RESOURCE_OU:
      return {
        ...state,
        notAttachedOuResources: action.payload
      }
    case ATTACH_RESOURCE_OU:
      return {
        ...state,
        attachResource: action.payload
      }
    case GET_VESSEL_EDGE_TOPOLOGY_PRODUCTS:
      return {
        ...state,
        vesselEdgeTopologyProducts: action.payload
      }
    case GET_PRODUCT_EDGE_TOPOLOGY_DEVICES:
      return {
        ...state,
        productEdgeTopologyDevices: action.payload,
        loadig: false
      }
    case GET_PARENT_DEVICE_OF_A_SITE:
      return {
        ...state,
        parentDeviceOfSite: action.payload
      }
    case UPDATE_PARENT_DEVICE_OF_A_SITE:
      return {
        ...state,
        updateParentDeviceOfSite: action.payload
      }
      case SET_LINK_STATUS_PER_DEVICE_LOADING: {
        return {
          ...state,
          linkStatusPerDeviceLoading: action.payload
        }
      }
    case GET_LINK_STATUS_PER_DEVICE:
      let passeddev = action.payload.passedDevice;
       let linkStatusPerDeviceNew = {...state.linkStatusPerDevice}
       linkStatusPerDeviceNew[passeddev] = action.payload
      return {
        ...state,
        linkStatusPerDevice: linkStatusPerDeviceNew,
        linkStatusPerDeviceLoading: false
      }
    case SOFTWARE_PRODUCT:
      return {
        ...state,
        softwareProduct: action.payload
      }
    case SET_SOFTWARE_LISTING_LOADING:
      return {
        ...state,
        softwareListingLoading: action.payload
      }
    case SOFTWARE_LISTING:
      return {
        ...state,
        softwareListing: action.payload,
        softwareListingLoading: false
      }
    case ALL_TEMPLATE:
      return {
        ...state,
        allTemplate: action.payload
      }
      case SET_SUB_DP_CREATE_LOADING: {
        return {
          ...state,
          setSubDPCreateLoading: action.payload
        }
      }
      case ACCOUNT_CREATE_SUB_DP: {
        return {
          ...state,
          accountCreateSubDP: action.payload,
          setSubDPCreateLoading: false
        }
      }
      case SET_DELETE_ORG_LOADING: {
        return {
          ...state,
          setDeleteOrgLoading: action.payload
        }
      }
      case GET_DELETE_ORG: {
        return {
          ...state,
          accountDeleteOrg: action.payload,
          setDeleteOrgLoading: false
        }
      }
      case SET_MODIFY_ORG_LOADING: {
        return {
          ...state,
          setModifyOrgLoading: action.payload
        }
      }
      case GET_MODIFY_ORG: {
        return {
          ...state,
          accountModifyOrg: action.payload,
          setModifyOrgLoading: false
        }
      }
      case SET_DP_INFO_LOADING: {
        return {
          ...state,
          setDpInfoLoading: action.payload
        }
      }
      case GET_DP_INFO: {
        return {
          ...state,
          getDpInfo: action.payload,
          setDpInfoLoading: false
        }
      }
    case GET_CONFIGURED_ALERTS_FOR_DEVICE:
      return {
        ...state,
        getConfiguredAlertsForDevice: action.payload
      }
    case UPDATE_CREATE_DEVICE_ALERT_CONFIGURATION:
      return {
        ...state,
        createDeviceAlertConfiguration: action.payload
      }

    case UPDATE_DELETE_DEVICE_ALERT_CONFIGURATION:
      return {
        ...state,
        deleteDeviceAlertConfiguration: action.payload
      }

    case UPDATE_DEVICE_ALERT_CONFIGURATION_SETTINGS:
      return {
        ...state,
        updateDeviceAlertConfiguration: action.payload
      }

    case GET_ORGANISATIONS_UNITS:
      return {
        ...state,
        getOrganisationUnitList: action.payload,
      }
    case GET_SEARCH_DP_LIST: {
      return {
        ...state,
        getSearchDpList: action.payload
      }
    }

    case SET_VESSEL_LISTING_LOADING:
      return {
        ...state,
        setVesselListingLoading: action.payload
      }
    case GET_VESSELS_LISTING:
      if (!_.isEqual(state.getVesselsListing, action.payload)) {
        return {
          ...state,
          getVesselsListing: action.payload,
          setVesselListingLoading: false
        }
      } else {
        return {
          ...state
        }
      }
    case GET_VESSEL_SUMMARY_TOPOLOGY:
      return {
        ...state,
        vesselSummaryTopology: action.payload
      }
    case UPDATE_NAME:
      return {
        ...state,
        updateNames: action.payload
      }
    case  VESSEL_ADDRESS_MMSI:
      return {
        ...state,
        vesselAddressMMSI: action.payload
      }
    case GET_VESSEL_INFO:
      return {
        ...state,
        getVesselInfo: action.payload
      }
    case UPDATE_MMSI_AND_STREETADDRESS:
      return {
        ...state,
        updateMMSIAndStreetAddress: action.payload
      }
    case GET_SOFTWARE_VERSIONS_DEVICE_COUNT:
      return {
        ...state,
        softwareVersionsDeviceCount: action.payload,
        softwareListingLoading: false
      }
    case GET_SOFTWARE_VERSION_DEVICE_DETAILS:
        return {
          ...state,
          getSoftwareVersionDeviceDetails: action.payload,
          softwareListingLoading: false
        }
    case GET_SOFT_VERSION_DEVICE_DETAILS:
      return {
        ...state,
        getSoftVersionDeviceDetails: action.payload,
        softwareListingLoading: false
      }
      case GET_KONNECT_APP_DOWNLOAD_LINKS:
        return {
          ...state,
          konnectAppDownloadLinks: action.payload,
          softwareListingLoading: false
        }
      case GET_VX_BUILD_DETAILS:
        return {
          ...state,
          vxBuildDetails: action.payload,
          softwareListingLoading: false
        }
      case GET_DP_DOCUMENTS_LIST:
        return {
          ...state,
          dpDocumentsList: action.payload,
          softwareListingLoading: false
        }
    case RESET_STATE:
      return initialState;
    case USER_DELETE:{
      return {
        ...state,
        userdelete: action.payload,
        userDeleteLoading: false
      }
    }
    case USER_DELETE_LOADING:{
      return{
        ...state,
        userDeleteLoading: action.payload
      }
    }

    case GET_SIM_BOX:
      return {
        ...state,
        getSimBox: action.payload
      }

    case GET_SIM_BOXES:
      return {
        ...state,
        getSimBoxes: action.payload,
        getSimBoxesLoading: false
      }
    case GET_SIM_BOXES_LOADING:
      return {
        ...state,
        getSimBoxesLoading: action.payload
      }
    case GET_SIM_BOXES_COUNT:
        return {
          ...state,
          getSimBoxesCount: action.payload,
        }

    case GET_LTE_PROVIDERS:
      return {
        ...state,
        getLteProviders: action.payload
      }

    case GET_DATA_USAGE:
      return {
        ...state,
        getDataUsage: action.payload
      }

    case GET_DATA_USAGE_COUNT:
      return {
        ...state,
        getDataUsageCount: action.payload
      }

    case GET_DAILY_DATA_USAGE:
      return {
        ...state,
        getDailyDataUsage: action.payload
      }

    case  EXPORT_DATA_USAGE_REPORT:
      return {
        ...state,
        exportDataUsageReport: action.payload
      }

    case GRAPHICAL_DATA_USAGE_LOADING:
      return {
        ...state,
        graphicalDataUsageLoading: action.payload,
      };
    case SET_CELLULAR_DATA_USAGE_LOADING : {
      return {
        ...state,
        setCellularDataUsageLoading: action.payload
      }
    }
    case GET_GRAPHICAL_DATA_USAGE:
      return {
        ...state,
        getGraphicalDataUsage: action.payload,
        graphicalDataUsageLoading: false
      }
    case GET_CELLULAR_DATA_USAGE:
      return {
        ...state,
        getCellularDataUsage: action.payload,
        setCellularDataUsageLoading: false
      }

    case GET_USAGE_VESSEL_LIST:
      return {
        ...state,
        getUsageVesselList: action.payload
      }
    case SET_WAN_USAGE_REPORT_SINGLE_SITE_NETWORK_USAGE_LOADING:
      return {
        ...state,
        wanUsageReportSingleSiteNetworkUsageLoading: action.payload
      }
    case GET_WAN_USAGE_REPORT_SINGLE_SITE_NETWORK_USAGE:
      return {
        ...state,
        wanUsageReportSingleSiteNetworkUsageLoading: false,
        wanUsageReportSingleSiteNetworkUsage: action.payload
      }
    case SET_WAN_USAGE_REPORT_SINGLE_SITE_ALL_INTERFACE_USAGE_LOADING:
      return {
        ...state,
        wanUsageReportSingleSiteAllInterfaceUsageLoading: action.payload
      }
    case GET_WAN_USAGE_REPORT_SINGLE_SITE_ALL_INTERFACE_USAGE: 
      return {
        ...state,
        wanUsageReportSingleSiteAllInterfaceUsageLoading: false,
        wanUsageReportSingleSiteAllInterfaceUsage: action.payload
      }
    case SET_WAN_USAGE_REPORT_SINGLE_SITE_WAN_SELECTION_NETWORK_USAGE_LOADING:
      return {
        ...state,
        WanUsageSingleSiteWanSelectionNetworkUsageLoading: action.payload
      }
    case GET_WAN_USAGE_REPORT_SINGLE_SITE_WAN_SELECTION_NETWORK_USAGE:
      return {
        ...state,
        WanUsageSingleSiteWanSelectionNetworkUsageLoading: false,
        WanUsageSingleSiteWanSelectionNetworkUsage: action.payload
      }
    case SET_WAN_USAGE_REPORT_SINGLE_SITE_VSAT_SELECTION_NETWORK_USAGE_LOADING:
      return {
        ...state,
        WanUsageSingleSiteVsatSelectionNetworkUsageLoading: action.payload
      }
    case GET_WAN_USAGE_REPORT_SINGLE_SITE_VSAT_SELECTION_NETWORK_USAGE:
      return {
        ...state,
        WanUsageSingleSiteVsatSelectionNetworkUsageLoading: false,
        WanUsageSingleSiteVsatSelectionNetworkUsage: action.payload
      }
    case SET_WAN_USAGE_REPORT_SINGLE_SITE_INTERFACE_USAGE_LOADING:
      return {
        ...state,
        WanUsageSingleSiteInterfaceUsageLoading: action.payload
      }
    case GET_WAN_USAGE_REPORT_SINGLE_SITE_INTERFACE_USAGE:
      return {
        ...state,
        WanUsageSingleSiteInterfaceUsageLoading: false,
        WanUsageSingleSiteInterfaceUsage: action.payload
      }
    case SET_EDGE_EVENTS_LOADING:{
      return {
        ...state,
        getEdgeEventsLoading: action.payload
      }
    }
    case SET_EDGE_EVENTS_FILTER_LOADING: {
      return {
        ...state,
        getEdgeEventsFilterLoading: action.payload
      }
    }
    case SET_EDGE_EVENTS_TABLE_LOADING: {
      return {
        ...state,
        getEdgeEventsTableLoading: action.payload
      }
    }
    case SET_EDGE_EVENTS_TABLE_COUNT_LOADING: {
      return {
        ...state,
        getEdgeEventsTableCountLoading: action.payload
      }
    }
    case GET_EDGE_EVENTS:{
      return {
        ...state,
        getEdgeEvents: action.payload,
        getEdgeEventsLoading: false
      }
    }
    case GET_HUB_EVENTS:{
      return {
        ...state,
        hubEventDetails: action.payload,
        getHubEventsLoading: false
      }
    }
    case GET_HUB_EVENTS_LOADING:{
      return {
        ...state,
        getHubEventsLoading: false
      }
    }
    case GET_HUB_EVENT_FILTERS_LOADING: {
      return {
        ...state,
        hubEventsFiltersLoading: false
      }
    }
    case GET_HUB_EVENT_FILTERS:{
      return {
        ...state,
        hubEventFilters: action.payload
      }
    }
    case GET_EDGE_EVENTS_TABLE:{
      return {
        ...state,
        getEdgeEventsTable: action.payload,
        getEdgeEventsTableLoading: false
      }
    }
    case DOWNLOAD_EDGE_EVENTS_TABLE:{
      return {
        ...state,
        downloadEdgeEventsTable: action.payload
      }
    }
    case GET_EDGE_EVENTS_FILTER:{
      return {
        ...state,
        getEdgeEventsFilter: action.payload,
        getEdgeEventsFilterLoading: false
      }
    }
    case GET_EDGE_EVENTS_FILTER_TEMP:{
      return {
        ...state,
        getEdgeEventsFilterTemp: action.payload,
      }
    }
    case GET_EDGE_EVENTS_TABLE_COUNT:{
      return {
        ...state,
        getEdgeEventsTableCount: action.payload,
        getEdgeEventsTableCountLoading: false
      }
    }
    case CLEAR_EDGE_EVENTS: {
      return {
        ...state,
        getEdgeEvents: {},
        getEdgeEventsFilter: {},
        getEdgeEventsTable: {},
        getEdgeEventsTableCount: {},
        downloadEdgeEventsTable: {},
      }
    }
    case SET_SITE_CHARTS_RSSI_LOADING: {
      return {
        ...state,
        siteChartsRSSILoading: action.payload
      }
    }
    case SET_SITE_CHARTS_SINR_LOADING: {
      return {
        ...state,
        siteChartsSINRLoading: action.payload
      }
    }
    case SET_SITE_CHARTS_LINK_STATUS_LOADING: {
      return {
        ...state,
        siteChartsLinkStatusLoading: action.payload
      }
    }
    case SET_SITE_CHARTS_LATENCY_JITTER_LOADING: {
      return {
        ...state,
        siteChartsLatencyJitterLoading: action.payload
      }
    }
    case SET_SITE_CHARTS_THROUGHPUT_LOADING: {
      return {
        ...state,
        siteChartsThroughputLoading: action.payload
      }
    }
    case SET_SITE_CHARTS_VSAT_SNR_LOADING: {
      return {
        ...state,
        siteChartsVSATSnrLoading: action.payload
      }
    }
    case SET_SITE_CHARTS_VSAT_TXPOWER_LOADING: {
      return {
        ...state,
        siteChartsVSATyTXPowerLoading: action.payload
      }
    }
    case SET_SITE_CHARTS_VSAT_POWER_LOADING: {
      return {
        ...state,
        siteChartsVSATPowerLoading: action.payload
      }
    }
    case SET_SITE_CHARTS_VSAT_SYMBOL_RATE_LOADING: {
      return {
        ...state,
        siteChartsVSATSymbolRateLoading: action.payload
      }
    }
    case SET_SITE_CHARTS_SITE_INTERFACES_LOADING: {
      return {
        ...state,
        siteChartsSiteInterfacesLoading: action.payload
      }
    }
    case SET_SITE_CHARTS_SITE_DATA_RATE_LOADING: {
      return {
        ...state,
        siteChartsSiteDataRateLoading: action.payload
      }
    }
    case SET_SITE_CLIENTS_LOADING: {
      return {
        ...state,
        siteChartsSiteClientsLoading: action.payload
      }
    }
    case SET_SITE_USAGE_LOADING: {
      return {
        ...state,
        siteChartsSiteUsageLoading: action.payload
      }
    }
    case SET_SITE_SYSTEM_UPTIME_LOADING: {
      return {
        ...state,
        siteChartsSiteSystemUptimeLoading: action.payload
      }
    }
    case SET_SITE_LAN_STATUS_LOADING: {
      return {
        ...state,
        siteChartsSiteLanStatusLoading: action.payload
      }
    }
    case SET_HUB_CLIENT_SDWAN_FLOWS_LOADING: {
      return {
        ...state,
        siteChartsSiteFlowsLoading: action.payload
      }
    }
    case SET_HUB_CLIENT_SDWAN_SPEED_LOADING: {
      return {
        ...state,
        siteChartsSiteSpeedLoading: action.payload
      }
    }
    case SET_HUB_CLIENT_SDWAN_LATENCY_LOADING: {
      return {
        ...state,
        siteChartsSiteLatencyLoading: action.payload
      }
    }
    case SET_HUB_CLIENT_SDWAN_STATUS_LOADING: {
      return {
        ...state,
        siteChartsSiteStatusLoading: action.payload
      }
    }
    case SET_SDWAN_SPEEDTEST_LOADING: {
      return {
        ...state,
        siteChartsSiteSpeedtestLoading: action.payload
      }
    }
    case SET_SITE_LINK_PROBE_NATIVE_LOADING: {
      return {
        ...state,
        siteChartsSiteLinkProbeNativeLoading: action.payload
      }
    }
    case SET_SITE_LINK_PROBE_VTP_LOADING: {
      return {
        ...state,
        siteChartsSiteLinkProbeVtpLoading: action.payload
      }
    }
    case SET_SDWAN_QOE_LOADING: {
      return {
        ...state,
        siteChartsSiteQoeLoading: action.payload
      }
    }
    case GET_SITE_RSSI:{
      return {
        ...state,
        getSiteRSSI: {data: {rssiAvg: {series: {...state.getSiteRSSI.data.rssiAvg.series, ...action.payload?.data?.rssiAvg?.series}}}},
        siteChartsRSSILoading: false
      }
    }
    case GET_SITE_SINR:{
      return {
        ...state,
        getSiteSINR: {data: {sinrAvg: {series: {...state.getSiteSINR.data.sinrAvg.series, ...action.payload?.data?.sinrAvg?.series}}}},
        siteChartsSINRLoading: false
      }
    }
    case GET_SITE_DATA_RATE:{
      return {
        ...state,
        getSiteDataRate: {data: {rateAvg: {series: {...state.getSiteDataRate.data.rateAvg.series, ...action.payload?.data?.rateAvg?.series}}}},
        siteChartsSiteDataRateLoading: false
      }
    }
    case GET_SITE_LINK_STATUS:{
      return {
        ...state,
        getSiteLinkStatus: {data: {probeSuccess: {series: {...state.getSiteLinkStatus.data.probeSuccess.series, ...action.payload?.data?.probeSuccess?.series}}}},
        siteChartsLinkStatusLoading: false
      }
    }
    case GET_SITE_LATENCY_JITTER:{
      return {
        ...state,
        getSiteLatencyJitter: {data: {
          latency: {series: {...state.getSiteLatencyJitter.data.latency.series, ...action.payload?.data?.latency?.series}},
          jitter: {series: {...state.getSiteLatencyJitter.data.jitter.series, ...action.payload?.data?.jitter?.series}}
        }},
        siteChartsLatencyJitterLoading: false
      }
    }
    case GET_SITE_THROUGHPUT:{
      return {
        ...state,
        getSiteThroughput: {data: {
          avgDownSpeed: {series: {...state.getSiteThroughput.data.avgDownSpeed.series, ...action.payload?.data?.avgDownSpeed?.series}},
          avgUpSpeed: {series: {...state.getSiteThroughput.data.avgUpSpeed.series, ...action.payload?.data?.avgUpSpeed?.series}}
        }},
        siteChartsThroughputLoading: false
      }
    }
    case GET_SITE_VSAT_SNR: {
      return {
        ...state,
        getSiteVSATSnr: {data: {avg: {series: {...state.getSiteVSATSnr.data.avg.series, ...action.payload?.data?.avg?.series}}}},
        siteChartsVSATSnrLoading: false
      }
    }
    case GET_SITE_VSAT_TXPOWER: {
      return {
        ...state,
        getSiteVSATTxpower: {data: {avg: {series: {...state.getSiteVSATTxpower.data.avg.series, ...action.payload?.data?.avg?.series}}}},
        siteChartsVSATyTXPowerLoading: false
      }
    }
    case GET_SITE_VSAT_POWER: {
      return {
        ...state,
        getSiteVSATPower: {data: {avg: {series: {...state.getSiteVSATPower.data.avg.series, ...action.payload?.data?.avg?.series}}}},
        siteChartsVSATPowerLoading: false
      }
    }
    case GET_SITE_VSAT_SYMBOL_RATE: {
      return {
        ...state,
        getSiteVSATSymbolRate: {data: {avg: {series: {...state.getSiteVSATSymbolRate.data.avg.series, ...action.payload?.data?.avg?.series}}}},
        siteChartsVSATSymbolRateLoading: false
      }
    }
    case GET_SITE_CLIENTS: {
      return {
        ...state,
        getSiteClients: {data: {clients: {series: {...state.getSiteClients.data.clients.series, ...action.payload?.data?.clients?.series}}}},
        siteChartsSiteClientsLoading: false
      }
    }
    case GET_SITE_USAGE: {
      return {
        ...state,
        getSiteUsage: {data: {
          totalUsage: {series: {...state.getSiteUsage.data.totalUsage.series, ...action.payload?.data?.totalUsage?.series}},
          downUsage: {series: {...state.getSiteUsage.data.downUsage.series, ...action.payload?.data?.downUsage?.series}},
          upUsage: {series: {...state.getSiteUsage.data.upUsage.series, ...action.payload?.data?.upUsage?.series}},
        }},
        siteChartsSiteUsageLoading: false
      }
    }
    case GET_SITE_SYSTEM_UPTIME: {
      return {
        ...state,
        getSiteSystemUptime: {data: {status: {series: {...state.getSiteSystemUptime.data.status.series, ...action.payload?.data?.status?.series}}}},
        siteChartsSiteSystemUptimeLoading: false
      }
    }
    case GET_SITE_LAN_STATUS: {
      return {
        ...state,
        getSiteLanStatus: { data: { LAN_status: { series: { ...state.getSiteLanStatus.data.LAN_status.series, ...action.payload?.data?.LAN_status?.series } } } },
        siteChartsSiteLanStatusLoading: false
      }
    }
    case GET_HUB_CLIENT_SDWAN_FLOWS: {
      return {
        ...state,
        getSiteFlows: { data: { flows: { series: { ...state.getSiteFlows.data.flows.series, ...action.payload?.data?.flows?.series } } } },
        siteChartsSiteFlowsLoading: false
      }
    }
    case GET_HUB_CLIENT_SDWAN_SPEED: {
      return {
        ...state,
        getSiteSpeed: {data: {
          avgDownSpeed: {series: {...state.getSiteSpeed.data.avgDownSpeed.series, ...action.payload?.data?.avgDownSpeed?.series}},
          avgUpSpeed: {series: {...state.getSiteSpeed.data.avgUpSpeed.series, ...action.payload?.data?.avgUpSpeed?.series}}
        }},
        siteChartsSiteSpeedLoading: false
      }
    }
    case GET_HUB_CLIENT_SDWAN_LATENCY: {
      return {
        ...state,
        getSiteLatency: { data: { latency: { series: { ...state.getSiteLatency.data.latency.series, ...action.payload?.data?.latency?.series } } } },
        siteChartsSiteLatencyLoading: false
      }
    }
    case GET_HUB_CLIENT_SDWAN_STATUS: {
      return {
        ...state,
        getSiteStatus: { data: { status: { series: { ...state.getSiteStatus.data.status.series, ...action.payload?.data?.status?.series } } } },
        siteChartsSiteStatusLoading: false
      }
    }
    case GET_SDWAN_SPEEDTEST: {
      return {
        ...state,
        getSiteSpeedtest: action.payload,
        siteChartsSiteSpeedtestLoading: false
      }
    }
    case GET_SITE_LINK_PROBE_NATIVE: {
      return {
        ...state,
        getSiteLinkProbeNative: {data: {probeSuccess: {series: {...state.getSiteLinkProbeNative.data.probeSuccess.series, ...action.payload?.data?.probeSuccess?.series}}}},
        siteChartsSiteLinkProbeNativeLoading: false
      }
    }
    case GET_SITE_LINK_PROBE_VTP: {
      return {
        ...state,
        getSiteLinkProbeVtp: {data: {probeSuccess: {series: {...state.getSiteLinkProbeVtp.data.probeSuccess.series, ...action.payload?.data?.probeSuccess?.series}}}},
        siteChartsSiteLinkProbeVtpLoading: false
      }
    }
    case GET_SDWAN_QOE: {
      return {
        ...state,
        getSiteQoe: {data: {
          QoEStreamingPoints: {series: {...state.getSiteQoe.data.QoEStreamingPoints.series, ...action.payload?.data?.QoEStreamingPoints?.series}},
          QoEGamingPoints: {series: {...state.getSiteQoe.data.QoEGamingPoints.series, ...action.payload?.data?.QoEGamingPoints?.series}}
        }},
        siteChartsSiteQoeLoading: false
      }
    }
    case SET_SDWAN_QOE_HMAP_LOADING: {
      return {
        ...state,
        setSiteQoeHmapLoading: action.payload
      }
    }
    case GET_SDWAN_QOE_HMAP: {
      return {
        ...state,
        getSiteQoeHmap: action.payload,
        setSiteQoeHmapLoading: false
      }
    }
    case GET_SITE_INTERFACES:{
      return {
        ...state,
        getSiteInterfaces: action.payload,
        siteChartsSiteInterfacesLoading: false
      }
    }
    case CLEAR_SITE_CHARTS:{
      return {
        ...state,
        getSiteRSSI: action.payload.includes(CHARTS_METRICS.RSSI) ? {data: {rssiAvg: {series: {}}}} : state.getSiteRSSI,
        getSiteSINR: action.payload.includes(CHARTS_METRICS.SINR) ? {data: {sinrAvg: {series: {}}}} : state.getSiteSINR,
        getSiteDataRate: action.payload.includes(CHARTS_METRICS.PRE) ? {data: {rateAvg: {series: {}}}} : state.getSiteDataRate,
        getSiteVSATSnr: action.payload.includes(CHARTS_METRICS.VSAT_SNR) ? {data: {avg: {series: {}}}} : state.getSiteVSATSnr,
        getSiteVSATTxpower: action.payload.includes(CHARTS_METRICS.VSAT_TXPOWER) ? {data: {avg: {series: {}}}} : state.getSiteVSATTxpower,
        getSiteVSATPower: action.payload.includes(CHARTS_METRICS.VSAT_POWER) ? {data: {avg: {series: {}}}} : state.getSiteVSATPower,
        getSiteVSATSymbolRate: action.payload.includes(CHARTS_METRICS.VSAT_SYMBOL_RATE) ? {data: {avg: {series: {}}}} : state.getSiteVSATSymbolRate,
        getSiteLinkStatus: action.payload.includes(CHARTS_METRICS.LINK_STATUS) ? {data: {probeSuccess: {series: {}}}} : state.getSiteLinkStatus,
        getSiteLatencyJitter: action.payload.includes(CHARTS_METRICS.RTT) ? {data: {latency: {series: {}}, jitter: {series: {}}}} : state.getSiteLatencyJitter,
        getSiteThroughput: action.payload.includes(CHARTS_METRICS.THROUGHPUT) ? {data: {avgDownSpeed: {series: {}}, avgUpSpeed: {series: {}}}} : state.getSiteThroughput,
        getSiteClients: action.payload.includes(CHARTS_METRICS.CLIENTS) ? {data: {clients: {series: {}}}} : state.getSiteClients,
        getSiteUsage: action.payload.includes(CHARTS_METRICS.USAGE) ? {data: {totalUsage: {series: {}}, downUsage: {series: {}}, upUsage: {series: {}}}} : state.getSiteUsage,
        getSiteSystemUptime: action.payload.includes(CHARTS_METRICS.SYSTEM_UPTIME) ? {data: {status: {series: {}}}} : state.getSiteSystemUptime,
        getSiteLanStatus: action.payload.includes(CHARTS_METRICS.LAN_STATUS) ? {data: {LAN_status: {series: {}}}} : state.getSiteLanStatus,
        getSiteFlows: action.payload.includes(CHARTS_METRICS.FLOWS) ? {data: {flows: {series: {}}}} : state.getSiteFlows,
        getSiteSpeed: action.payload.includes(CHARTS_METRICS.SPEED) ? {data: {avgDownSpeed: {series: {}}, avgUpSpeed: {series: {}}}} : state.getSiteSpeed,
        getSiteLatency: action.payload.includes(CHARTS_METRICS.LATENCY) ? {data: {latency: {series: {}}}} : state.getSiteLatency,
        getSiteStatus: action.payload.includes(CHARTS_METRICS.STATUS) ? {data: {status: {series: {}}}} : state.getSiteStatus,
        getSiteSpeedtest: action.payload.includes(CHARTS_METRICS.SPEEDTEST) ? {} : state.getSiteSpeedtest,
        getSiteLinkProbeNative: action.payload.includes(CHARTS_METRICS.LINK_PROBE_NATIVE) ? {data: {probeSuccess: {series: {}}}} : state.getSiteLinkProbeNative,
        getSiteLinkProbeVtp: action.payload.includes(CHARTS_METRICS.LINK_PROBE_VTP) ? {data: {probeSuccess: {series: {}}}} : state.getSiteLinkProbeVtp,
        getSiteQoe: action.payload.includes(CHARTS_METRICS.QOE) ? {data: {QoEStreamingPoints: {series: {}}, QoEGamingPoints: {series: {}}}} : state.getSiteQoe,
      }
    }
    case DELETE_SITE_CHART_SERIES:{
      delete state.getSiteDataRate?.data?.rateAvg?.series[action.payload];
      delete state.getSiteLatencyJitter?.data?.latency?.series[action.payload];
      delete state.getSiteLatencyJitter?.data?.jitter?.series[action.payload];
      delete state.getSiteThroughput?.data?.avgDownSpeed?.series[action.payload];
      delete state.getSiteThroughput?.data?.avgUpSpeed?.series[action.payload];
      delete state.getSiteLatencyJitter?.data?.jitter?.series[action.payload];
      delete state.getSiteLinkStatus?.data?.probeSuccess?.series[action.payload];
      delete state.getSiteRSSI?.data?.rssiAvg?.series[action.payload];
      delete state.getSiteSINR?.data?.sinrAvg?.series[action.payload];
      delete state.getSiteVSATSnr?.data?.avg?.series[action.payload];
      delete state.getSiteVSATTxpower?.data?.avg?.series[action.payload];
      delete state.getSiteVSATPower?.data?.avg?.series[action.payload];
      delete state.getSiteVSATSymbolRate?.data?.avg?.series[action.payload];
      delete state.getSiteClients?.data?.clients?.series[action.payload];
      delete state.getSiteUsage?.data?.totalUsage?.series[action.payload];
      delete state.getSiteSystemUptime?.data?.status?.series[action.payload];
      delete state.getSiteLanStatus?.data?.LAN_status?.series[action.payload];
      delete state.getSiteFlows?.data?.flows?.series[action.payload];
      delete state.getSiteSpeed?.data?.avgDownSpeed?.series[action.payload];
      delete state.getSiteSpeed?.data?.avgUpSpeed?.series[action.payload];
      delete state.getSiteLatency?.data?.latency?.series[action.payload];
      delete state.getSiteStatus?.data?.status?.series[action.payload];
      delete state.getSiteLinkProbeNative?.data?.probeSuccess?.series[action.payload];
      delete state.getSiteLinkProbeVtp?.data?.probeSuccess?.series[action.payload];
      delete state.getSiteQoe?.data?.QoEStreamingPoints?.series[action.payload];
      delete state.getSiteQoe?.data?.QoEGamingPoints?.series[action.payload];

      return {
        ...state,
        getSiteRSSI: {
          ...state.getSiteRSSI
        },
        getSiteSINR: {
          ...state.getSiteSINR
        },
        getSiteDataRate: {
          ...state.getSiteDataRate
        },
        getSiteLinkStatus: {
          ...state.getSiteLinkStatus
        },
        getSiteLatencyJitter: {
          ...state.getSiteLatencyJitter
        },
        getSiteThroughput: {
          ...state.getSiteThroughput
        },
        getSiteVSATSnr: {
          ...state.getSiteVSATSnr
        },
        getSiteVSATTxpower: {
          ...state.getSiteVSATTxpower
        },
        getSiteVSATPower: {
          ...state.getSiteVSATPower
        },
        getSiteVSATSymbolRate: {
          ...state.getSiteVSATSymbolRate
        },
        getSiteClients: {
          ...state.getSiteClients
        },
        getSiteUsage: {
          ...state.getSiteUsage
        },
        getSiteSystemUptime: {
          ...state.getSiteSystemUptime
        },
        getSiteLanStatus: {
          ...state.getSiteLanStatus
        },
        getSiteFlows: {
          ...state.getSiteFlows
        },
        getSiteSpeed: {
          ...state.getSiteSpeed
        },
        getSiteLatency: {
          ...state.getSiteLatency
        },
        getSiteStatus: {
          ...state.getSiteStatus
        },
        getSiteSpeedtest: {
          ...state.getSiteSpeedtest
        },
        getSiteLinkProbeNative: {
          ...state.getSiteLinkProbeNative
        },
        getSiteLinkProbeVtp: {
          ...state.getSiteLinkProbeVtp
        },
        getSiteQoe: {
          ...state.getSiteQoe
        }
      }
    }
    case CLEAR_SITE_CHART_EVENTS:{
      return {
        ...state,
        getEdgeEvents: {}
      }
    }
    case GET_USER_LOGIN_HISTORY:{
      return {
        ...state,
        getUserLoginHistory: action.payload
      }
    }
    case SET_INVENTORY_LISTING_LOADING:
      return {
        ...state,
        inventoryListingLoading: action.payload
      }
    case SET_DEPLOYED_LISTING_LOADING:
      return {
        ...state,
        deployedListingLoading: action.payload
      }
    case SET_DEPLOYED_LISTING_COUNT_LOADING:
      return {
        ...state,
        deployedListingCountLoading: action.payload
      }
    case SET_T0_AND_OPEN_EDGE_LOADING:
      return {
        ...state,
        t0AndOpenEdgeLoading: action.payload
      }
    case SET_THREAT_KONTROL_LOADING:
      return {
        ...state,
        threatKontrolLoading: action.payload
      }
    case GET_TRAFFIC_POLICY_LISTING_LOADING:
      return {
        ...state,
        trafficPolicyListingLoading: action.payload
      }
    case GET_POLICY_ROUTE_LIST_LOADING:
      return {
        ...state,
        policyRouteListingLoading: action.payload
      }
    case GET_WAN_PROFILE_LISTING_LOADING:
      return {
        ...state,
        wanProfileListingLoading: action.payload
      }
    case GET_POP_IPS_LISTING_LOADING:
      return {
        ...state,
        getPopIpsListingLoading: action.payload
      }
    case APPLY_TRAFFIC_POLICY_LOADING: 
      return {
        ...state, 
        applyTrafficPolicyLoading: action.payload
      }
    case APPLY_POLICY_ROUTE_LOADING:
      return {
        ...state,
        applyPolicyRouteLoading: action.payload
      }
    case APPLY_WAN_PROFILE_LOADING:
      return {
        ...state,
        applyWanProfileLoading: action.payload
      }
    case APPLY_FIREWALL_RULE_LOADING:
      return {
        ...state,
        applyFirewallRuleLoading: action.payload
      }
    case APPLY_HUB_IP_CONFIG_LOADING:
      return {
        ...state,
        applyHubIPConfigLoading: action.payload
      }
    case COPY_QUOTA_CONFIG_LOADING:
      return {
        ...state,
        copyQuotaConfigLoading: action.payload
      }
    case GET_TRAFFIC_POLICY_LOG_LIST_LOADING:
      return {
        ...state,
        trafficPolicyLogListLoading: action.payload
      }
    case GET_INVENTORY_DEPLOYED_DATA:{
      return {
        ...state,
        getInventoryDeployedData: action.payload,
        deployedListingLoading: false
      }
    }
    case GET_T0_AND_OPEN_EDGE_DATA:{
      return {
        ...state,
        getT0AndOpenEdgeData: action.payload,
        inventoryListingLoading: false
      }
    }
    case DOWNLOAD_INVENTORY_DEPLOYED_DATA: {
      return {
        ...state,
        downloadInventoryDeployedData: action.payload,
        inventoryListingLoading: false
      }
    }
    case GET_INVENTORY_WAREHOUSE_TABLE_DATA:{
      return {
        ...state,
        getInventoryWarehouseTableData: action.payload,
        inventoryListingLoading: false
      }
    }
    case INVENTORY_WAREHOUSE_CHANGE_GROUP:{
      return {
        ...state,
        inventoryWarehouseChangeGroupData: action.payload,
        inventoryListingLoading: false
      }
    }
    case GET_INVENTORY_WAREHOUSE_VESSEL_LIST:{
      return {
        ...state,
        getInventoryWarehouseVesselList: action.payload,
        inventoryListingLoading: false
      }
    }
    case SET_ASSIGN_INVENTORY_TO_VESSEL: {
      return {
        ...state,
        setAssignInventoryToVessel: action.payload
      }
    }
    case ASSIGN_INVENTORY_TO_VESSEL:{
      return {
        ...state,
        assignInventoryToVessel: action.payload,
        setAssignInventoryToVessel: false
      }
    }
    case GET_LICENSE_TYPES:{
      return {
        ...state,
        getLicenseTypes: action.payload,
        setLicenseTypesLoading: false
      }
    }
    case SET_LICENSE_TYPES:{
      return {
        ...state,
        setLicenseTypesLoading: action.payload
      }
    }
    case GET_DPS_DEFAULT_ACTIVE_CONFIG:{
      return {
        ...state,
        getDpsDefaultActiveConfig: action.payload,
      }
    }
    case CREATE_AND_ASSIGN_INVENTORY:{
      return {
        ...state,
        createVessel: action.payload,
        inventoryListingLoading: false
      }
    }
    case GET_DP_LIST:{
      return {
        ...state,
        getDPList: action.payload,
        inventoryListingLoading: false
      }
    }
    case GET_INVENTORY_DEPLOYED_DATA_COUNT:{
      return {
        ...state,
        getInventoryDeployedDataCount: action.payload,
        deployedListingCountLoading: false
      }
    }
    case SET_INVENTORY_ASSIGN_DEVICE_TO_WAREHOUSE: {
      return {
        ...state,
        setInventoryAssignDeviceToWarehouse: action.payload
      }
    }
    case INVENTORY_ASSIGN_DEVICE_TO_WAREHOUSE:{
      return {
        ...state,
        inventoryAssignDeviceToWarehouse: action.payload,
        setInventoryAssignDeviceToWarehouse: false
      }
    }
    case INVENTORY_DELETE_SITE:{
      return {
        ...state,
        inventoryDeleteSite: action.payload,
        inventoryListingLoading: false
      }
    }
    case INVENTORY_TOP_WIDGETS_REGISTERED_COUNT:{
      return {
        ...state,
        inventoryTopWidgetsRegisteredCount: action.payload,
        setLoading: false
      }
    }
    case INVENTORY_TOP_WIDGET_KAAS_COUNT:{
      return {
        ...state,
        inventoryTopWidgetsKaasCount: action.payload,
        setLoading: false
      }
    }
    case INVENTORY_TOP_WIDGETS_WAREHOUSE_COUNT:{
      return {
        ...state,
        inventoryTopWidgetsWarehouseCount: action.payload,
        setLoading: false
      }
    }
    case INVENTORY_DOWNLOAD_CONFIG: {
      return {
        ...state,
        inventoryDownloadConfig: action.payload,
        inventoryListingLoading: false
      }
    }
    case INVENTORY_CHANGE_GROUP: {
      return {
        ...state,
        inventoryChangeGroup: action.payload,
        inventoryListingLoading: false
      }
    }
    case GET_CONFIG_PRODUCTS: {
      return {
        ...state,
        getConfigProducts: action.payload,
        inventoryListingLoading: false
      }
    }
    case APPLY_GOLDEN_CONFIG: {
      return {
        ...state,
        applyGoldenConfig: action.payload,
        inventoryListingLoading: false
      }
    }
    case BACKUP_CONFIG_NOW: {
      return {
        ...state,
        backupConfigNow: action.payload,
        inventoryListingLoading: false
      }
    }
    case DEVICE_LATEST_EOS_VERSION: {
      return {
        ...state,
        deviceLatestEosVersion: action.payload,
        inventoryListingLoading: false
      }
    }
    case GET_DEVICE_LIST: {
      return {
        ...state,
        getDeviceList: action.payload,
        inventoryListingLoading: false
      }
    }
    case GET_DP_DEVICES: {
      return {
        ...state,
        getDpDevices: action.payload,
        inventoryListingLoading: false
      }
    }
    case CREATE_INVENTORY_GROUP: {
      return {
        ...state,
        createInventoryGroup: action.payload,
        inventoryListingLoading: false
      }
    }
    case UPDATE_INVENTORY_GROUP: {
      return {
        ...state,
        updateInventoryGroup: action.payload,
        inventoryListingLoading: false
      }
    }
    case DELETE_INVENTORY_GROUP: {
      return {
        ...state,
        deleteInventoryGroup: action.payload,
        inventoryListingLoading: false
      }
    }
    case CREATE_THREAT_KONTROL: {
      return {
        ...state,
        createThreatKontrol: action.payload,
        threatKontrolLoading: false
      }
    }
    case UPDATE_THREAT_KONTROL: {
      return {
        ...state,
        updateThreatKontrol: action.payload,
        threatKontrolLoading: false
      }
    } 
    case DELETE_THREAT_KONTROL: {
      return {
        ...state,
        deleteThreatkontrol: action.payload,
        threatKontrolLoading: false
      }
    }
    case DELETE_AGENT_CONFIG: {
      return {
        ...state, 
        deleteAgentConfig: action.payload,
        deleteAgentConfigLoading: false
      }
    }
    case DELETE_AGENT_CONFIG_LAODING: {
      return {
        ...state,
        deleteAgentConfigLoading: action.payload
      }
    }
    case COPY_AGENT_CONFIG: {
      return {
        ...state, 
        copyAgentConfig: action.payload,
        copyAgentConfigLoading: false
      }
    }
    case COPY_AGENT_CONFIG_LAODING: {
      return {
        ...state,
        copyAgentConfigLoading: action.payload
      }
    }
    case SAVE_AGENT_CONFIG: {
      return {
        ...state, 
        saveAgentConfig: action.payload,
        saveAgentConfigLoading: false
      }
    }
    case SAVE_AGENT_CONFIG_LAODING: {
      return {
        ...state,
        saveAgentConfigLoading: action.payload
      }
    }
    case GET_TRAFFIC_POLICY_LIST: {
      return {
        ...state,
        getTrafficPolicy: action.payload,
        inventoryListingLoading: false,
      }
    }
    case GET_POLICY_ROUTE_LIST: {
      return {
        ...state,
        getPolicyRoute: action.payload,
        policyRouteListingLoading: false
      }
    }
    case GET_TRAFFIC_POLICY_LIST_V3: {
      return {
        ...state,
        getTrafficPolicyV3: action.payload,
        inventoryListingLoading: false,
      }
    }
    case GET_TRAFFIC_POLICY_LIST_V4: {
      return {
        ...state,
        getTrafficPolicyV4: action.payload,
        inventoryListingLoading: false,
      }
    }
    case GET_TRAFFIC_POLICY_LIST_V5: {
      return {
        ...state,
        getTrafficPolicyV5: action.payload,
        inventoryListingLoading: false,
      }
    }
    case APPLY_TRAFFIC_POLICY: {
      return {
        ...state,
        applyTrafficPolicy: action.payload,
        inventoryListingLoading: false
      }
    }
    case APPLY_POLICY_ROUTE: {
      return {
        ...state,
        applyPolicyRouteData: action.payload,
        applyPolicyRouteLoading: false
      }
    }
    case APPLY_FIREWALL_RULE: {
      return {
        ...state,
        applyFirewallRule: action.payload,
        inventoryListingLoading: false
      }
    }
    case APPLY_WAN_PROFILE: {
      return {
        ...state,
        applyWanProfile: action.payload,
        inventoryListingLoading: false
      }
    }
    case APPLY_HUB_IP_CONFIG: {
      return {
        ...state,
        applyHubIPConfig: action.payload,
        inventoryListingLoading: false,
      }
    }
    case GET_TRAFFIC_POLICY_LOG_LIST: {
      return {
        ...state,
        getTraficPolicyApplyLogs: action.payload,
        inventoryListingLoading: false
      }
    }
    case GET_WAN_PROFILE_LIST: {
      return {
        ...state,
        getWANProfileList: action.payload,
        inventoryListingLoading: false
      }
    }
    case GET_POP_IPS_LIST: {
      return {
        ...state,
        getPopIpsList: action.payload,
        inventoryListingLoading: false
      }
    }
    case GET_INVENTORY_GROUP_LIST: {
      return {
        ...state,
        getInventoryGroupList: action.payload,
        inventoryListingLoading: false
      }
    }
    case GET_INVENTORY_GROUP_LIST_COUNT: {
      return {
        ...state,
        getInventoryGroupListCount: action.payload,
        inventoryListingLoading: false
      }
    }
    case GET_SITE_INFO_LIST: {
      return {
        ...state,
        getSiteInfoList: action.payload,
        inventoryListingLoading: false
      }
    }
    case GET_SITE_INFO_LIST_COUNT: {
      return {
        ...state,
        getSiteInfoListCount: action.payload,
        inventoryListingLoading: false
      }
    }
    case SET_BACKUP_CONFIG_DATA_LOADING: {
      return {
        ...state,
        setBackupConfigDataLoading: action.payload
      }
    }
    case GET_BACKUP_CONFIG_DATA: {
      return {
        ...state,
        backupConfigData: action.payload,
        setBackupConfigDataLoading: false
      }
    }
    case COPY_CONFIG_TO_MANUAL_BACKUP: {
      return {
        ...state,
        copyConfigToManualBackup: action.payload,
        inventoryListingLoading: false
      }
    }
    case DELETE_MANUAL_BACKUP_CONFIG: {
      return {
        ...state,
        deleteManualBackupConfig: action.payload,
        inventoryListingLoading: false
      }
    }
    case GET_DEFAULT_CONFIG_LISTING: {
      return {
        ...state,
        getDefaultConfigListing: action.payload,
        inventoryListingLoading: false
      }
    }
    case EDIT_DEFAULT_CONFIG: {
      return {
        ...state,
        editDefaultConfig: action.payload,
        inventoryListingLoading: false
      }
    }
    case CREATE_DEFAULT_CONFIG: {
      return {
        ...state,
        createDefaultConfig: action.payload,
        inventoryListingLoading: false
      }
    }
    case DELETE_DEFAULT_CONFIG: {
      return {
        ...state,
        deleteDefaultConfig: action.payload,
        inventoryListingLoading: false
      }
    }
    case GET_DEFAULT_PRODUCTS: {
      return {
        ...state,
        getDefaultProducts: action.payload,
        inventoryListingLoading: false
      }
    }
    case GET_CONFIG_SOFTWARE_VERSIONS: {
      return {
        ...state,
        getConfigSoftwareVersions: action.payload,
        inventoryListingLoading: false
      }
    }
    case GET_CONFIG_STATUS: {
      let [configStatus, totalCount] = action.payload?.data?.rows[0]
      return {
          ...state,
          getConfigStatus: configStatus || [],
          getConfigStatusTotalCount: totalCount ? totalCount : 0
      }
  }
    case GET_GROUP_TRANSCATION_CONFIG_STATUS: {
      let [configStatus, totalCount] = action.payload?.data?.rows[0]
      return {
          ...state,
          getGroupTranscationConfigStatus: configStatus || [],
          getGroupTranscationConfigStatusTotalCount: totalCount ? totalCount : 0
      }
  }
    case SET_CONFIG_STATUS_DOWNLOAD_LOADING:
      return {
        ...state,
        configStatusDownloadLoading: action.payload
      }
    case SET_DEVICE_STATUS_DOWNLOAD_LOADING:
      return {
        ...state,
        deviceStatusDownloadLoading: action.payload
      }
    case HIGH_AVAILABILITY:{
      return{
        ...state,
        highAvailability: action.payload,
        gettingHa: false
      }
    }
    case GETTING_HA: {
      return {
        ...state,
        gettingHa: action.payload
      }
    }
    case GET_HIGH_AVAILABILITY_DEVICE:{
      return {
        ...state,
        getHighAvailabilityDevice: action.payload
      }
    }
    case CREATE_HA:{
      return {
        ...state,
        createHighAvailability: action.payload,
        creatingHighAvailability: false
      }
    }
    case CREATING_HA: {
      return {
        ...state,
        creatingHighAvailability: action.payload
      }
    }
    case DELETE_HIGH_AVAILABILITY: {
      return {
        ...state,
        deleteHighAvailability: action.payload,
        deletingHA: false
      }
    }
    case DELETING_HA: {
      return {
        ...state,
        deletingHA: action.payload
      }
    }
    case SYNC_DEVICE:{
      return {
        ...state,
        syncDevice: action.payload,
        syncingDevice: false
      }
    }
    case SYNCING_DEVICE: {
      return {
        ...state,
        syncingDevice: action.payload
      }
    }
    case UPDATE_DEVICE:{
      return {
        ...state,
        updateDevice: action.payload,
        updatingDevice: false
      }
    }
    case UPDATING_DEVICE: {
      return {
        ...state,
        updatingDevice: action.payload
      }
    }
    case SET_ACTIVITY_REPORTS_LOADING:
      return {
        ...state,
        activityReportsLoading: action.payload
      }
    case SET_ACTIVITY_REPORTS_APPS_LOADING: {
      return {
        ...state,
        activityReportsAppsLoading: action.payload,
      }
    }
    case SET_ACTIVITY_REPORTS_VLANS_LOADING: {
      return {
        ...state,
        activityReportsVlansLoading: action.payload
      }
    }
    case SET_ACTIVITY_REPORTS_WIDGET_LOADING: {
      return {
        ...state,
        activityReportsWidgetLoading: action.payload
      }
    }
    case SET_ACTIVITY_REPORTS_CATEGORY_PIE_LOADING: {
      return {
        ...state,
        activityReportsCategoryPieLoading: action.payload
      }
    }
    case SET_ACTIVITY_REPORTS_APPLICATION_PIE_LOADING: {
      return {
        ...state,
        activityReportsApplicationPieLoading: action.payload
      }
    }
    case SET_ACTIVITY_REPORTS_USAGE_LINE_CHART_LOADING: {
      return {
        ...state,
        activityReportsUsageLineChartLoading: action.payload
      }
    }
    case SET_ACTIVITY_REPORTS_TOP_APP_LINE_CHART_LOADING: {
      return {
        ...state,
        activityReportsTopAppLineChartUsage: action.payload
      }
    }
    case SET_ACTIVITY_REPORTS_TOP_USERS_LOADING: {
      return {
        ...state,
        activityReportsTopUsersLoading: action.payload
      }
    }
    case SET_ACTIVITY_REPORTS_TOP_SITES_LOADING: {
      return {
        ...state,
        activityReportsTopSitesLoading: action.payload
      }
    }
    case SET_ACTIVITY_REPORTS_BOTTOM_TABLE_LOADING: {
      return {
        ...state,
        setActivityReportsBottomTableLoading: action.payload
      }
    }
    case SET_OPERATIONAL_USAGE_DATA_DUMP_TABLE_COUNT_LOADING: {
      return {
        ...state,
        setOperationalUsageDataTableLoading: action.payload
      }
    }
    case SET_OPERATIONAL_USAGE_DATA_DUMP_TABLE_LOADING: {
      return {
        ...state,
        setOperationalUsageDataTableCountLoading: action.payload
      }
    }
    case SET_OPERATIONAL_USAGE_TIMESERIES_TABLE_LOADING: {
      return {
        ...state,
        setOperationalUsageTimeseriesTableLoading: action.payload 
      }
    }
    case SET_OPERATIONAL_USAGE_TIMESERIES_TABLE_COUNT_LOADING: {
      return {
        ...state,
        setOperationalUsageTimeseriesTableCountLoading: action.payload
      }
    }
    case SET_OPERATIONAL_USAGE_DATA_SINGLE_SITE_PER_WAN_WISE_LOADING: {
      return {
        ...state,
        setOperationalUsageDataSingleSitePerWanWiseLoading: action.payload
      }
    }
    case SET_OPERATIONAL_USAGE_FILTER_DEVICE_LIST_LOADING: {
      return {
        ...state,
        setOperationalUsageFilterDeviceListLoading: action.payload
      }
    }
    case SET_OPERATIONAL_USAGE_FILTER_SW_LIST_LOADING: {
      return {
        ...state,
        setOperationalUsageFilterSWListLoading: action.payload
      }
    }
    case SET_OPERATIONAL_USAGE_DATA_DUMP_DOWNLOAD_TABLE_LOADING: {
      return {
        ...state,
        setOperationalUsageReportsDownloadLoading: action.payload
      }
    }
    case SET_ACTIVITY_REPORTS_BOTTOM_TABLE_DOMAIN_LOADING: {
      return {
        ...state,
        setActivityReportsBottomTableDomainLoading: action.payload
      }
    }
    case SET_ACTIVITY_REPORTS_BOTTOM_TABLE_IP_LOADING: {
      return {
        ...state,
        setActivityReportsBottomTableIPLoading: action.payload
      }
    }
    case SET_REPORTS__TOP_BLOCKED_APP_BOTTOM_TABLE_LOADING: {
      return {
        ...state,
        setActivityReportsTopBlockedAppBottomTableLoading: action.payload
      }
    }
    case SET_DPI_REPORTS_TOP_WIDGET_ALLSITE_RISK: {
      return {
        ...state,
        setTopWidgetRiskScore: action.payload
      }
    }
    case SET_DPI_REPORTS_PIE_CHART_ALLSITE_RISK: {
      return {
        ...state,
        setPieChartAllSiteRisk: action.payload
      }
    }
    case GET_ALL_USERNAMES:{
      return {
        ...state,
        getAllUsernames: action.payload,
        activityReportsLoading: false
      }
    }
    case GET_ALL_APPLICATIONS:{
      return {
        ...state,
        getAllApplications: action.payload,
        activityReportsAppsLoading: false
      }
    }
    case GET_ALL_VLANS:{
      return {
        ...state,
        getAllVlans: action.payload,
        activityReportsVlansLoading: false
      }
    }
    case GET_DPI_REPORTS_USER_MAX_RISK_TYPES: {
      return {
        ...state,
        riskList: action.payload,
        setLoading: false
      }
    }
    case GET_DPI_REPORTS_TOP_WIDGET_ALLSITE_RISK: {
      return {
        ...state,
        topWidgetAllSiteRiskScore: action.payload,
        setTopWidgetRiskScore: false
      }
    }
    case GET_DPI_REPORTS_TOP_WIDGET_SINGLESITE_RISK: {
      return {
        ...state,
        topWidgetSingleSiteRiskScore: action.payload,
        setTopWidgetRiskScore: false
      }
    }
    case GET_DPI_REPORTS_PIE_CHART_ALLSITE_RISK: {
      return {
        ...state,
        getPieChartAllSiteRisk: action.payload,
        setPieChartAllSiteRisk: false
      }
    }
    case GET_DPI_REPORTS_PIE_CHART_SINGLESITE_RISK: {
      return {
        ...state,
        getPieChartSingleSiteRisk: action.payload,
        setPieChartAllSiteRisk: false
      }
    }
    case GET_USAGE_WIDGETS:{
      return {
        ...state,
        UsageWidgetsData: action.payload,
        activityReportsWidgetLoading: false
      }
    }
    case GET_USAGE_TABLE_DATA:{
      return {
        ...state,
        UsageTableData: action.payload,
        activityReportsTopUsersLoading: false
      }
    }
    case GET_LINE_CHART_USAGE: {
      return {
        ...state,
        getLineChartUsage: action.payload,
        activityReportsUsageLineChartLoading: false
      }
    }
    case GET_CATEGORY_PIE_CHART_USAGE: {
      return {
        ...state,
        CategoryPieChartUsageData: action.payload,
        activityReportsCategoryPieLoading: false
      }
    }
    case GET_TOP_APPLICATION_LINE_CHART: {
      return {
        ...state,
        getTopApplicationLineChart: action.payload,
        activityReportsTopAppLineChartUsage: false
      }
    }
    case GET_TOP_SITES_TABLE_DATA: {
      return {
        ...state,
        TopSitesTableData: action.payload,
        activityReportsTopSitesLoading: false
      }
    }
    case GET_TOP_APP_TOP_BLOCKED_PIE_CHART: {
      return {
        ...state,
        TopAppTopBlockedPieChartData: action.payload,
        activityReportsApplicationPieLoading: false
      }
    }
    case GET_TOP_DOWNLOAD_UPLOAD_BLOCKED_APPLICATION: {
      return {
        ...state,
        getTopDownloadUploadBlockedApplication: action.payload,
        setActivityReportsBottomTableLoading: false
      }
    }
    case GET_TOP_DOWNLOAD_UPLOAD_BLOCKED_DOMAIN: {
      return {
        ...state,
        getTopDownloadUploadBlockedDomain: action.payload,
        setActivityReportsBottomTableDomainLoading: false
      }
    }
    case GET_TOP_DOWNLOAD_UPLOAD_BLOCKED_IP: {
      return {
        ...state,
        getTopDownloadUploadBlockedIp: action.payload,
        setActivityReportsBottomTableIPLoading: false
      }
    }
    case GET_ACTIVITY_REPORTS_CONTENT_FILTERS_TABLE: {
      return {
        ...state,
        getContentFiltersTable: action.payload,
        setActivityReportsBottomTableLoading: false
      }
    }
    case GET_OPERATIONAL_USAGE_DATA_DUMP_TABLE: {
      return {
        ...state,
        getOperationalUsageDataTable: action.payload,
        setOperationalUsageDataTableLoading: false
      }
    }
    case GET_OPERATIONAL_USAGE_DATA_DUMP_TABLE_COUNT: {
      return {
        ...state,
        getOperationalUsageDataTableCount: action.payload?.data?.rows[0],
        setOperationalUsageDataTableCountLoading: false
      }
    }
    case GET_OPERATIONAL_USAGE_TIMESERIES_TABLE: {
      return {
        ...state,
        getOperationalUsageTimeseriesTable: action.payload,
        setOperationalUsageTimeseriesTableLoading: false
      }
    }
    case GET_OPERATIONAL_USAGE_TIMESERIES_TABLE_COUNT: {
      return {
        ...state,
        getOperationalUsageTimeseriesTableCount: action.payload?.data?.rows[0],
        setOperationalUsageTimeseriesTableCountLoading: false
      }
    }
    case GET_OPERATIONAL_USAGE_DATA_SINGLE_SITE_PER_WAN_WISE: {
      return {
        ...state,
        getOperationalUsageDataSingleSitePerWanWise: action.payload,
        setOperationalUsageDataSingleSitePerWanWiseLoading: false
      }
    }
    case GET_OPERATIONAL_USAGE_FILTER_DEVICE_LIST: {
      return {
        ...state,
        getOperationalUsageFilterDeviceList: action.payload,
        setOperationalUsageFilterDeviceListLoading: false
      }
    }
    case GET_OPERATIONAL_USAGE_FILTER_SW_LIST: {
      return {
        ...state,
        getOperationalUsageFilterSWList: action.payload,
        setOperationalUsageFilterSWListLoading: false
      }
    }
    case GET_OPERATIONAL_USAGE_DATA_DUMP_DOWNLOAD_TABLE: {
      return {
        ...state,
        getOperationalUsageReportsDownload: action.payload,
        setOperationalUsageReportsDownloadLoading: false
      }
    }
    case CREATE_DOWNLOAD_SERVICE: {
      return {
        ...state,
        createDownloadService: action.payload,
        activityReportsLoading: false
      }
    }
    case CREATE_DOWNLOAD_SERVICE_FIREWALL: {
      return {
        ...state,
        createDownloadServiceFirewall: action.payload,
        setLoading: false
      }
    }
    case CREATE_DOWNLOAD_SERVICE_CONTENT_FILTER: {
      return {
        ...state,
        createDownloadServiceContentFilter: action.payload,
        setLoading: false
      }
    }
    case SET_GENERATED_REPORTS_TABLE_LOADING: {
        return {
          ...state,
          setGeneratedReportsTableLoading: action.payload
        }
    }
    case SET_GENERATED_REPORTS_TABLE_COUNT_LOADING: {
        return {
          ...state,
          setGeneratedReportsTableCountLoading: action.payload
        }
    }
    case GET_GENERATED_REPORTS_TABLE: {
        return {
          ...state,
          getGeneratedReportsTable: action.payload?.result,
          getGeneratedReportsTableCount: action.payload?.result_info?.total_count || 0,
          setGeneratedReportsTableLoading: false
        }
    }
    case SET_REPORTS_SUBSCRIPTION_TABLE_LOADING: {
          return {
            ...state,
            setSubscriptionReportsTableLoading: action.payload,
          };
        }
        case SET_REPORTS_SUBSCRIPTION_TABLE_COUNT_LOADING: {
          return {
            ...state,
            setSubscriptionReportsTableCountLoading: action.payload,
          };
        }
        case GET_REPORTS_SUBSCRIPTION_TABLE: {
          return {
            ...state,
            getSubscriptionReportsTable: action.payload?.result,
            getSubscriptionReportsTableCount:
              action.payload?.result_info?.total_count || 0,
            setSubscriptionReportsTableLoading: false,
          };
        }
    
        case SET_SCHEDULED_REPORTS_TABLE_LOADING: {
          return {
            ...state,
            setScheduledReportsTableLoading: action.payload,
          };
        }
        case SET_SCHEDULED_REPORTS_TABLE_COUNT_LOADING: {
          return {
            ...state,
            setScheduledReportsTableCountLoading: action.payload,
          };
        }
        case GET_SCHEDULED_REPORTS_TABLE: {
          return {
            ...state,
            getScheduledReportsTable: action.payload?.result,
            getScheduledReportsTableCount:
              action.payload?.result_info?.total_count || 0,
            setScheduledReportsTableLoading: false,
          };
        }
    case AUDIT_LOGS:
      return {
        ...state,
        auditLogs: action.payload
      }
    case DOMAIN_NAME: {
      return {
        ...state,
        hostName: action.payload
      }
    }
    case DOMAIN_CONFIG: {
      return {
        ...state,
        domainConfig: action.payload
      }
    }
    case GET_FIREALL_WIDGETS: {
      return {
        ...state,
        getFirewallWidgets: action.payload,
        setFirewallWidgetsLoading: false,
      }
    }
    case GET_FIREWALL_ACTIONS_TODAY_GRAPH:
      return {
        ...state,
        getFirewallActiveToday: action.payload,
        setFirewallActiveTodayLoading: false,
      }
    case GET_FIREWALL_RULE_NAME_GRAPH:
      return {
        ...state,
        getFirewallRuleName: action.payload,
        setFirewallRuleNameLoading: false,
      }
    case GET_FIREWALL_TABLE_DATA:
      return {
        ...state,
        getFirewallTableData: action.payload,
        setFirewallTableDataLoading: false,
      }
    case GET_FIREWALL_RULE_NAME_FILTER:
      return {
        ...state,
        getFirewallRuleNameFilter: action.payload,
        setFirewallRuleNameFilterLoading: false,
      }
    case GET_FIREWALL_TABLE_DATA_COUNT:
      return {
        ...state,
        getFirewallTableDataCount: action.payload,
        setFirewallTableDataCountLoading: false,
      }
    case GET_FIREWALL_LINE_CHART:
      return {
        ...state,
        getFirewallLineChart: action.payload,
        setFirewallLineChartLoading: false,
      } 

      case SET_LOADING_FIREWALL_WIDGETS: {
        return {
          ...state,
          setFirewallWidgetsLoading: action.payload
        }
      }
      
      case SET_LOADING_FIREWALL_RISTRICT_PIECHART: {
        return {
          ...state,
          setFirewallActiveTodayLoading: action.payload
        }
      }

      case SET_LOADING_FIREWALL_PIE_RULENAME: {
        return {
          ...state,
          setFirewallRuleNameLoading: action.payload
        }
      }

      case SET_LOADING_FIREWALL_RULE_FILTER: {
        return {
          ...state,
          setFirewallRuleNameFilterLoading: action.payload
        }
      }

      case SET_LOADING_FIREWALL_TABLE_DATA: {
        return {
          ...state,
          setFirewallTableDataLoading: action.payload
        }
      }

      case SET_LOADING_FIREWALL_COUNTS: {
        return {
          ...state,
          setFirewallTableDataCountLoading: action.payload
        }
      }

      case SET_LOADING_FIREWALL_LINECHART: {
        return {
          ...state,
          setFirewallLineChartLoading: action.payload
        }
      }
      case GET_TOP_WIDGET_AVAILABILITY: {
        return {
          ...state,
          setTopWidgetAvailability: action.payload
        }
      }
      case GET_TOP_WIDGET_DATA_NEW_SUMM: {
        return {
          ...state,
          setTopWidgetData: action.payload
        }
      }
      case SET_IAM_LOGIN_HISTORY_TABLE: {
        return {
          ...state,
          setIamLoginHistoryTable: action.payload
        }
      }
      case SET_IAM_LOGIN_HISTORY_TABLE_COUNT: {
        return {
          ...state,
          setIamLoginHistoryCountLoading: action.payload
        }
      }
      case SET_IAM_LOGIN_HISTORY_TOP_WIDGET: {
        return {
          ...state,
          setIamLoginHistoryTopWidget: action.payload
        }
      }
      case SET_IAM_LOGIN_HISTORY_TIMESERIES_CHART: {
        return {
          ...state,
          setIamLoginHistoryTimeseriesChart: action.payload
        }
      }
      case SET_IAM_LOGIN_HISTORY_FILTER_USER: {
        return {
          ...state,
          setIamLoginHistoryFilterUser: action.payload
        }
      }
      case SET_IAM_LOGIN_HISTORY_FILTER_APP: {
        return {
          ...state,
          setIamLoginHistoryFilterApp: action.payload
        }
      }
      case SET_IAM_LOGIN_HISTORY_FILTER_DESC_LIST: {
        return {
          ...state,
          setIamLoginHistoryFilterDescList: action.payload
        }
      }
      case GET_IAM_LOGIN_HISTORY_TABLE: {
        return {
          ...state,
          getIamLoginHistoryTable: action.payload,
          setIamLoginHistoryTable: false
        }
      }
      case GET_IAM_LOGIN_HISTORY_TABLE_COUNT: {
        return {
          ...state,
          getIamLoginHistortTableCount: action.payload,
          setIamLoginHistoryCountLoading: false
        }
      }
      case GET_IAM_LOGIN_HISTORY_TOP_WIDGET: {
        return {
          ...state,
          getIamLoginHistoryTopWidget: action.payload,
          setIamLoginHistoryTopWidget: false
        }
      }
      case GET_IAM_LOGIN_HISTORY_TIMESERIES_CHART: {
        return {
          ...state,
          getIamLoginHistoryTimeseriesChart: action.payload,
          setIamLoginHistoryTimeseriesChart: false
        }
      }
      case GET_IAM_LOGIN_HISTORY_FILTER_USER: {
        return {
          ...state,
          getIamLoginHistoryFilterUser: action.payload,
          setIamLoginHistoryFilterUser: false
        }
      }
      case GET_IAM_LOGIN_HISTORY_FILTER_APP: {
        return {
          ...state,
          getIamLoginHistoryFilterApp: action.payload,
          setIamLoginHistoryFilterApp: false
        }
      }
      case GET_IAM_LOGIN_HISTORY_FILTER_DESC_LIST: {
        return {
          ...state,
          getIamLoginHistoryFilterDescList: action.payload,
          setIamLoginHistoryFilterDescList: false
        }
      }
      case GET_MAINTENANCE_INFO: {
        return {
          ...state,
          getMaintenanceInfo: action.payload
        }
      }
      case GET_GROUP_SETTINGS_DATA: {
        return {
          ...state,
          getGroupSettingsData: action.payload,
          setLoading: false
        }
      }
      case UPDATE_GROUP_SETTINGS_DATA:{
        return {
          ...state,
          updateGroupSettingsData: action.payload,
          setLoading: false
        }
      }
      case GET_SENDGRID_TABLE_DATA: {
        return {
          ...state,
          getSendGridData: action.payload,
          sendGridDataLoading: false
        }
      }
      case SET_SENDGRID_DATA_LOADING: {
        return {
          ...state,
          sendGridDataLoading: action.payload
        }
      }
      case CREATE_SMTP_EMAIL_DATA: {
        return {
          ...state,
          createSmtpData: action.payload,
          setLoading: false
        }
      }
      case GET_SMTP_EMAIL_DATA: {
        return {
          ...state,
          getSmtpData: action.payload,
          setLoading: false
        }
      }
      case GET_MICROSOFT_GRAPH_EMAIL_DATA: {
        return {
          ...state,
          getMicrosoftEmailData: action.payload,
          setLoading: false
        }
      }
      case CREATE_MICROSOFT_GRAPH_EMAIL_DATA: {
        return {
          ...state,
          createMicrosoftGraphData: action.payload,
          setLoading: false
        }
      }
      case CREATE_DNS_DATA: {
        return {
          ...state,
          createDNS: action.payload,
          setLoading: false
        }
      }
      case VERIFY_DNS_DATA: {
        return {
          ...state,
          verifyDNS: action.payload,
          setLoading: false
        }
      }
      case SEND_TEST_EMAIL: {
        return {
          ...state,
          sendTestemail: action.payload,
          setLoading: false
        }
      }
      case SMTP_TEST_EMAIL: {
        return {
          ...state,
          smtpTestemail: action.payload,
          setLoading: false
        }
      }
      case MS_GRAPH_TEST_EMAIL: {
        return {
          ...state,
          msGraphTestemail: action.payload,
          setLoading: false
        }
      }
      case SMTP_DATA_DELETE: {
        return {
          ...state,
          deletesmtpData: action.payload,
          setLoading: false
        }
      }
      case MSGRAPH_DATA_DELETE: {
        return {
          ...state,
          deleteMsgraphData: action.payload,
          setLoading: false
        }
      }
      case SENDGRID_DATA_DELETE: {
        return {
          ...state,
          deleteSendgridData: action.payload,
          setLoading: false
        }
      }
      case ACTIVATE_SENDGRID: {
        return {
          ...state,
          activateSendGrid: action.payload,
          setLoading: false
        }
      }
      case ACTIVATE_SMTP: {
        return {
          ...state,
          activateSmtp: action.payload,
          setLoading: false
        }
      }
      case ACTIVATE_MSGRAPH: {
        return {
          ...state,
          activateMsgraph: action.payload,
          setLoading: false
        }
      }
      case SAVE_SSO_CONFIG: {
        return {
          ...state,
          saveSSOConfig: action.payload,
          setLoading: false
        }
      }
      case UPDATE_SSO_CONFIG: {
        return {
          ...state,
          updateSSOConfig: action.payload,
          setLoading: false
        }
      }
      case DELETE_SSO_CONFIG: {
        return {
          ...state,
          deleteSSOConfig: action.payload,
          setLoading: false
        }
      }
      case VERIFY_SSO_CONNECTION: {
        return {
          ...state,
          verifySSOConnection: action.payload,
          setLoading: false
        }
      }
      case FETCH_SSO_ORGANIZATIONS: {
        return {
          ...state,
          ssoOrganizations: action.payload,
        }
      }
      case SET_SSO_ORGANIZATIONS_LOADING: {
        return {
          ...state,
          ssoOrganizationsLoading: action.payload,
        }
      }
      case SET_DOMAIN_SSO_CHECK: {
        return {
          ...state,
          domainSSOCheck: action.payload,
        }
      }
      case SET_SSO_CODE: {
        return {
          ...state,
          setSSOCode: action.payload,
          setLoading: false,
        }
      }
      case SET_CF_TOP_USERS_TABLE_LOADING: {
        return {
          ...state,
          setContentFilterTopUsersTableLoading: action.payload
        }
      }
      case SET_CF_TOP_USERS_TABLE_COUNT_LOADING: {
        return {
          ...state,
          setContentFilterTopUsersTableCountLoading: action.payload
        }
      }
      case SET_CF_TOP_SITES_TABLE_LOADING: {
        return {
          ...state,
          setContentFilterTopSitesTableLoading: action.payload
        }
      }
      case SET_CF_TOP_SITES_TABLE_COUNT_LOADING: {
        return {
          ...state,
          setContentFilterTopSitesTableCountLoading: action.payload
        }
      }
      case SET_CF_CATEGORY_PIE_LOADING: {
        return {
          ...state,
          setContentFilterCategoryPieLoading: action.payload,
        }
      }
      case SET_CF_APPLICATION_PIE_LOADING: {
        return {
          ...state,
          setContentFilterApplicationPieLoading: action.payload,
        }
      }
      case SET_CF_SUBCAT_PIE_LOADING: {
        return {
          ...state,
          setContentFilterSubCategoryPieLoading: action.payload,
        }
      }
      case SET_CF_LINECHART_LOADING: {
        return {
          ...state,
          setContentFilterLinechartLoading: action.payload
        }
      }
      case SET_CF_TW_TOP_SITE_LOADING: {
        return {
          ...state,
          setContentFilterTopWidgetTopSiteLoading: action.payload,
        }
      }
      case SET_CF_TW_TOP_USER_LOADING: {
        return {
          ...state,
          setContentFilterTopWidgetTopUserLoading: action.payload,
        }
      }
      case SET_CF_TW_TOP_CATEGORY_LOADING: {
        return {
          ...state,
          setContentFilterTopWidgetTopCategoryLoading: action.payload,
        }
      }
      case SET_CF_TW_TOP_DOMAIN_LOADING: {
        return {
          ...state,
          setContentFilterTopWidgetTopDomainLoading: action.payload,
        }
      }
      case SET_CF_CATEGORY_LIST_LOADING: {
        return {
          ...state,
          setContentFilterCategoryListLoading: action.payload
        }
      }
      case SET_CF_APP_LIST_LOADING: {
        return {
          ...state,
          setContentFilterAppListLoading: action.payload
        }
      }
      case SET_CF_USER_LIST_LOADING: {
        return {
          ...state,
          setContentFilterUserListLoading: action.payload
        }
      }
      case SET_CF_VLAN_LIST_LOADING: {
        return {
          ...state,
          setContentFilterVlanListLoading: action.payload
        }
      }
      case SET_CF_DEVICE_LIST_LOADING: {
        return {
          ...state,
          setContentFilterDeviceListLoading: action.payload
        }
      }
      case SET_CF_SUb_CATEGORY_LIST_LOADING: {
        return {
          ...state,
          steContentFilterSubCategoryListLoading: action.payload
        }
      }
      case GET_CF_TOP_USERS_TABLE: {
        return {
          ...state,
          getContentFilterTopUsersTable: action.payload,
          setContentFilterTopUsersTableLoading: false
        }
      }
      case GET_CF_TOP_USERS_TABLE_COUNT: {
        return {
          ...state,
          getContentFilterTopUsersTableCount: action.payload,
          setContentFilterTopUsersTableCountLoading: false
        }
      }
      case GET_CF_TOP_SITES_TABLE: {
        return {
          ...state,
          getContentFilterTopSitesTable: action.payload,
          setContentFilterTopSitesTableLoading: false
        }
      }
      case GET_CF_TOP_SITES_TABLE_COUNT: {
        return {
          ...state,
          getContentFilterTopSitesTableCount: action.payload,
          setContentFilterTopSitesTableCountLoading: false
        }
      }
      case GET_CF_CATEGORY_PIE: {
        return {
          ...state,
          getContentFilterCategoryPie: action.payload,
          setContentFilterCategoryPieLoading: false
        }
      }
      case GET_CF_APPLICATION_PIE: {
        return {
          ...state,
          getContentFilterApplicationPie: action.payload,
          setContentFilterApplicationPieLoading: false
        }
      }
      case GET_CF_SUBCAT_PIE: {
        return {
          ...state,
          getContentFilterSubCategoryPie: action.payload,
          setContentFilterSubCategoryPieLoading: false
        }
      }
      case GET_CF_LINECHART: {
        return {
          ...state,
          getContentFilterLinechart: action.payload,
          setContentFilterLinechartLoading: false
        }
      }
      case GET_CF_TW_TOP_SITE: {
        return {
          ...state,
          getContentFilterTopWidgetTopSite: action.payload,
          setContentFilterTopWidgetTopSiteLoading: false
        }
      }
      case GET_CF_TW_TOP_USER: {
        return {
          ...state,
          getContentFilterTopWidgetTopUser: action.payload,
          setContentFilterTopWidgetTopUserLoading: false
        }
      }
      case GET_CF_TW_TOP_CATEGORY: {
        return {
          ...state,
          getContentFilterTopWidgetTopCategory: action.payload,
          setContentFilterTopWidgetTopCategoryLoading: false
        }
      }
      case GET_CF_TW_TOP_DOMAIN: {
        return {
          ...state,
          getContentFilterTopWidgetTopDomain: action.payload,
          setContentFilterTopWidgetTopDomainLoading: false
        }
      }
      case GET_CF_CATEGORY_LIST: {
        return {
            ...state,
            getContentFilterCategoryList: action.payload,
            setContentFilterCategoryListLoading: false
        }
      }
      case GET_CF_APP_LIST: {
        return {
            ...state,
            getContentFilterAppList: action.payload,
            setContentFilterAppListLoading: false
        }
      }
      case GET_CF_USER_LIST: {
        return {
            ...state,
            getContentFilterUserList: action.payload,
            setContentFilterUserListLoading: false
        }
      }
      case GET_CF_VLAN_LIST: {
        return {
            ...state,
            getContentFilterVlanList: action.payload,
            setContentFilterVlanListLoading: false
        }
      }
      case GET_CF_DEVICE_LIST: {
        return {
            ...state,
            getContentFilterDeviceList: action.payload,
            setContentFilterDeviceListLoading: false
        }
      }
      case GET_CF_SUB_CATEGORY_LIST: {
        return {
          ...state,
          getContentFilterSubCategoryList: action.payload,
          steContentFilterSubCategoryListLoading: false
        }
      }
      case UPDATE_NEW_SUMMARY_START_DATE:
        return {
            ...state,
            newSummaryStartDate: action.payload
        }
      case UPDATE_NEW_SUMMARY_END_DATE:
        return {
            ...state,
            newSummaryEndDate: action.payload
        }
      case UPDATE_NEW_SUMMARY_WAN_TYPE:
      return {
          ...state,
          newSummaryWanType: action.payload
      }
      case UPDATE_NEW_SEVERITY_TYPE:
        return {
          ...state,
          newSummarySeverityType: action.payload
        }
     case UPDATE_NEW_SUMMARY_SERVICE_LINE:
        return {
            ...state,
            newSummaryServiceLine: action.payload
        }
      case UPDATE_NEW_SUMMARY_SERVICE_LINE_SELECTED:
        return {
            ...state,
            newSummaryServiceLineTotal: action.payload
        }
      case SET_HAS_USER_CHANGED_SERVICE_LINE:
        return {
            ...state,
            hasUserChangedServiceLine: action.payload
        }
        case NEW_SUMMARY_SERVICE_ACCOUNTS:
          let credentials = action?.payload?.data;
          
          let serviceAccounts = [
            { accountNumber: "All", accountName: "All Accounts" }, 
            ...(credentials?.map((cr) => cr || []).flat() || [])
          ];
        
          return {
            ...state,
            newSummaryServiceAccount: serviceAccounts
          };
          case UPDATE_NEW_SUMMARY_SERVICE_ACCOUNTS:
            return {
                ...state,
                selectedServiceAccount: action?.payload
            }
      case GET_DRAWER_OPEN: {
        return {
          ...state,
          getDrawerOpen: action.payload
        }
      }
      case SET_DASHBOARD_PIE_USAGEPER_WANTYPE_LOADING: {
        return {
          ...state,
          setDashboardPieUsageperWantypeLoading: action.payload
        }
      }
      case SET_DASHBOARD_HISTORGRAM_USAGEPER_WANTYPE_LOADING: {
        return {
          ...state,
          setDashboardHistogramUsagePerWantypeLoading: action.payload
        }
      }
      case SET_DASHBOARD_HISTORGRAM_USAGEPER_SITE_LOADING: {
        return {
          ...state,
          setDashboardHistogramUsagePerSiteLoading: action.payload
        }
      }
      case SET_DASHBOARD_USAGE_PIE_TOP10_APPS_LOADING: {
        return {
          ...state,
          setDashboardUsagePieTop10AppsLoading: action.payload
        }
      }
      case SET_DASHBOARD_PIE_WAN_USAGE_BYSITE_LOADING: {
        return {
          ...state,
          setDashboardPieWanUsageBySiteLoading: action.payload
        }
      }
      case SET_DASHBOARD_USAGE_HISOGRAM_UPLINK_DLK_LOADING: {
        return {
          ...state,
          setDashboardUsageHistogramUpDownLinkLoading: action.payload
        }
      }
      case SET_DASHBOARD_USAGE_HISTOGRAM_BYSITE_LOADING: {
        return {
          ...state,
          setDashboardUsageHistogramBySiteLoading: action.payload
        }
      }
      case SET_DASHBOARD_UPTIME_SITESTATISTICS_TABLE_LOADING: {
        return {
          ...state,
          setDashboardUptimeSiteStatisticsTableLoading: action.payload
        }
      }
      case SET_DASHBOARD_UPTIME_LINECHART_BYWAN_LOADING: {
        return {
          ...state,
          setDashboardUptimeLinechartByWanLoading: action.payload
        }
      }
      case SET_DASHBOARD_UPTIME_PIECHART_BYSITE_LOADING: {
        return {
          ...state,
          setDashboardUptimePiechartBySiteLoading: action.payload
        }
      }
      case SET_DASHBOARD_UPTIME_LINECHART_BYSITE_LOADING: {
        return {
          ...state,
          setDashboardUptimeLinechartBySiteLoading: action.payload
        }
      }
      case SET_DASHBOARD_UPTIME_PIECHART_BYWAN_LOADING: {
        return {
          ...state,
          setDashboardUptimePiechartByWanLoading: action.payload
        }
      }
      case GET_DASHBOARD_PIE_USAGEPER_WANTYPE: {
        return {
          ...state,
          newUsageperWantype: action.payload,
          setDashboardPieUsageperWantypeLoading: false
        }
      }
      case GET_DASHBOARD_HISTORGRAM_USAGEPER_WANTYPE: {
        return {
          ...state,
          newHistogramUsageperWantype: action.payload,
          setDashboardHistogramUsagePerWantypeLoading: false
        }
      }
      case GET_DASHBOARD_HISTORGRAM_USAGEPER_SITE_COUNT: {
        return {
          ...state,
          newHistogramBySiteCount: action.payload,
          setDashboardHistogramUsagePerSiteLoading: false
        }
      }
      case GET_DASHBOARD_USAGE_PIE_TOP10_APPS: {
        return {
          ...state,
          newUsagePieTop10Apps: action.payload,
          setDashboardUsagePieTop10AppsLoading: false
        }
      }
      case GET_DASHBOARD_PIE_WAN_USAGE_BYSITE: {
        return {
          ...state,
          wanUsageBySites: action.payload,
          setDashboardPieWanUsageBySiteLoading: false
        }
      }
      case GET_DASHBOARD_USAGE_HISOGRAM_UPLINK_DLK: {
        return {
          ...state,
          newSummaryUploadDownload: action.payload,
          setDashboardUsageHistogramUpDownLinkLoading: false
        }
      }
      case GET_NEW_SUMMARY_UPTIME_ALL_LINK_AVAILABLITY_LOADING: {
        return {
          ...state,
          newSummaryUptimeAllLinksLoading: action.payload
        }
      }
      case GET_NEW_SUMMARY_UPTIME_ALL_LINK_AVAILABLITY:
        return {
          ...state,
          newSummaryUptimeAllLinks: action.payload,
          newSummaryUptimeAllLinksLoading: false
        }
      case GET_DASHBOARD_USAGE_HISTOGRAM_BYSITE: {
        return {
          ...state,
          newSummaryHistogramBySite: action.payload,
          setDashboardUsageHistogramBySiteLoading: false
        }
      }
      case GET_DASHBOARD_UPTIME_SITESTATISTICS_TABLE: {
        return {
          ...state,
          newSummaryUptimeTable: action.payload,
          setDashboardUptimeSiteStatisticsTableLoading: false
        }
      }
      case GET_DASHBOARD_UPTIME_LINECHART_BYWAN: {
        return {
          ...state,
          newSummaryUptimeLinechart: action.payload,
          setDashboardUptimeLinechartByWanLoading: false
        }
      }
      case GET_DASHBOARD_UPTIME_PIECHART_BYSITE: {
        return {
          ...state,
          newSummaryUptimePiechart: action.payload,
          setDashboardUptimePiechartBySiteLoading: false
        }
      }
      case GET_DASHBOARD_UPTIME_LINECHART_BYSITE: {
        return {
          ...state,
          newSummaryUptimeLineChartBySite: action.payload,
          setDashboardUptimeLinechartBySiteLoading: false
        }
      }
      case GET_DASHBOARD_UPTIME_PIECHART_BYWAN: {
        return {
          ...state,
          newSummaryUptimePiechartByWan: action.payload,
          setDashboardUptimePiechartByWanLoading: false
        }
      }
      case GET_CSV_DATA_TO_DOWNLOAD: {
        return {
          ...state,
          csvDownloadId: action.id,
          csvDataDownloded: action.payload,
          csvDownloadLoading: false
        }
      }
      case SET_DASHBOARD_ALERT_PIECHART_BYNAME_LOADING: {
        return {
          ...state,
          newSummaryAlertPieChartByNameLoading: action.payload
        }
      }
      case SET_DASHBOARD_ALERT_PIECHART_BYSITE_LOADING: {
        return {
          ...state,
          newSummaryAlertPieChartBySiteLoading: action.payload
        }
      }
      case SET_DASHBOARD_ALERT_LINECHART_BYNAME_LOADING: {
        return {
          ...state,
          newSummaryAlertLineChartByNameLoading: action.payload
        }
      }
      case SET_DASHBOARD_ALERT_LINECHART_BYSITE_LOADING: {
        return {
          ...state,
          newSummaryAlertLineChartBySiteLoading: action.payload
        }
      }
      case SET_DASHBOARD_ALERT_TOPWIDGET_LOADING: {
        return {
          ...state,
          newSummaryAlertTopWidgetLoading: action.payload
        }
      }
      case GET_DASHBOARD_ALERT_PIECHART_BYNAME: {
        return {
          ...state,
          alertPieChartByName: action.payload,
          newSummaryAlertPieChartByNameLoading: false
        }
      }
      case GET_DASHBOARD_ALERT_PIECHART_BYSITE: {
        return {
          ...state,
          alertPieChartBySite: action.payload,
          newSummaryAlertPieChartBySiteLoading: false
        }
      }
      case GET_DASHBOARD_ALERT_LINECHART_BYNAME: {
        return {
          ...state,
          alertLineChartByName: action.payload,
          newSummaryAlertLineChartByNameLoading: false
        }
      }
      case GET_DASHBOARD_ALERT_LINECHART_BYSITE: {
        return {
          ...state,
          alertLineChartBySite: action.payload,
          newSummaryAlertLineChartBySiteLoading: false
        }
      }
      case GET_DASHBOARD_ALERT_TOPWIDGET: {
        return {
          ...state,
          alertTopWidget: action.payload,
          newSummaryAlertTopWidgetLoading: false
        }
      }
      case SET_DASHBOARD_PER_DEVICE_WAN_PROFILES: {
        return {
          ...state,
          setWanProfilePerDeviceLoading: action.payload
        }
      }
      case GET_DASHBOARD_PER_DEVICE_WAN_PROFILES: {
        return {
          ...state,
          wanProfilesPerDevice: action.payload,
          setWanProfilePerDeviceLoading: false
        }
      }
      case SET_DASHBOARD_ADVANCED_BONDING_LOADING: {
        return {
          ...state,
          setAdvancedBondingLoading: action.payload
        }
      }
      case GET_DASHBOARD_ADVANCED_BONDING: {
        return {
          ...state,
          getAdvancedBonding: action.payload,
          setAdvancedBondingLoading: false
        }
      }
      case SET_DASHBOARD_LAN_STATUS_LOADING: {
        return {
          ...state,
          setLANStatusLoading: action.payload
        }
      }
      case GET_DASHBOARD_LAN_STATUS: {
        return {
          ...state,
          getLANStatus: action.payload,
          setLANStatusLoading: false
        }
      }
      case SET_HUB_INTERNET_DROPOFF_LIST_LOADING: {
        return {
          ...state,
          hubInternetDropoffListLoading: action.payload
        }
      }
      case GET_HUB_INTERNET_DROPOFF_LIST: {
        return {
          ...state,
          hubInternetDropoffListLoading: false,
          hubInternetDropoffList: action.payload
        }
      }
      case SET_DASHBOARD_CONNECTED_HUB_LOADING: {
        return {
          ...state,
          setConnectedHubLoading: action.payload
        }
      }
      case GET_DASHBOARD_CONNECTED_HUB: {
        return {
          ...state,
          getConnectedHub: action.payload,
          setConnectedHubLoading: false
        }
      }
      case SET_SYSTEM_HEALTH_DEVICES_LOADING: {
        return {
          ...state,
          setSystemHealthDevicesLoading: action.payload
        }
      }
      case GET_SYSTEM_HEALTH_DEVICES: {
        return {
          ...state,
          systemHealthDevices: action.payload,
          setSystemHealthDevicesLoading: false
        }
      }
      case SET_SYSTEM_HEALTH_METRICS_LINE_CHART_CPU_LOADING: {
        return {
          ...state,
          setSystemHealthCpuChartLoading: action.payload
        }
      }
      case GET_SYSTEM_HEALTH_METRICS_LINE_CHART_CPU: {
        return {
          ...state,
          systemHealthCpuChart: action.payload,
          setSystemHealthCpuChartLoading: false
        }
      }
      case SET_SYSTEM_HEALTH_METRICS_LINE_CHART_MEMORY_LOADING: {
        return {
          ...state,
          setSystemHealthMemoryChartLoading: action.payload
        }
      }
      case GET_SYSTEM_HEALTH_METRICS_LINE_CHART_MEMORY: {
        return {
          ...state,
          systemHealthMemoryChart: action.payload,
          setSystemHealthMemoryChartLoading: false
        }
      }
      case SET_SYSTEM_HEALTH_METRICS_LINE_CHART_CONTRACK_LOADING: {
        return {
          ...state,
          setSystemHealthContrackChartLoading: action.payload
        }
      }
      case GET_SYSTEM_HEALTH_METRICS_LINE_CHART_CONTRACK: {
        return {
          ...state,
          systemHealthContrackChart: action.payload,
          setSystemHealthContrackChartLoading: false
        }
      }
      case SET_SYSTEM_HEALTH_METRICS_LINE_CHART_LO_RX_DROPS_LOADING: {
        return {
          ...state,
          setSystemHealthRxDropsChartLoading: action.payload
        }
      }
      case GET_SYSTEM_HEALTH_METRICS_LINE_CHART_LO_RX_DROPS: {
        return {
          ...state,
          systemHealthRxDropsChart: action.payload,
          setSystemHealthRxDropsChartLoading: false
        }
      }
      case SET_SYSTEM_HEALTH_METRICS_LINE_CHART_SWAP_LOADING: {
        return {
          ...state,
          setSystemHealthSwapChartLoading: action.payload
        }
      }
      case GET_SYSTEM_HEALTH_METRICS_LINE_CHART_SWAP: {
        return {
          ...state,
          systemHealthSwapChart: action.payload,
          setSystemHealthSwapChartLoading: false
        }
      }
      case SET_SYSTEM_HEALTH_METRICS_LINE_CHART_TEMPERATURE_LOADING: {
        return {
          ...state,
          setSystemHealthTemperatureChartLoading: action.payload
        }
      }
      case GET_SYSTEM_HEALTH_METRICS_LINE_CHART_TEMPERATURE: {
        return {
          ...state,
          systemHealthTemperatureChart: action.payload,
          setSystemHealthTemperatureChartLoading: false
        }
      }
      case SET_SYSTEM_HEALTH_DISK_STORAGE_LINE_CHART_LOADING: {
        return {
          ...state,
          setSystemHealthDiskStorageChartLoading: action.payload
        }
      }
      case GET_SYSTEM_HEALTH_DISK_STORAGE_LINE_CHART: {
        return {
          ...state,
          systemHealthDiskStorageChart: action.payload,
          setSystemHealthDiskStorageChartLoading: false
        }
      }
      case SET_SYSTEM_HEALTH_FLOW_COUNT_TABLE_LOADING: {
        return {
          ...state,
          setSystemHealthFlowCountChartLoading: action.payload
        }
      }
      case GET_SYSTEM_HEALTH_FLOW_COUNT_TABLE_LOADING: {
        return {
          ...state,
          systemHealthFlowCountTable: action.payload,
          setSystemHealthFlowCountChartLoading: false
        }
      }
      case SET_FLIGHT_SCHEDULE_DATA_LOADING: {
        return {
          ...state,
          flightSchedulingDataLoading: action.payload
        }
      }
      case GET_FLIGHT_SCHEDULE_DATA: {
        return {
          ...state,
          flightSchedulingDataLoading: false,
          flightSchedulingdata: action.payload
        }
      }
      case SET_FLIGHT_TAILID_UPDATE_TABLE_LOADING: {
        return {
          ...state,
          flightTailIdUpdateTableLoading: action.payload
        }
      }
      case GET_FLIGHT_TAILID_UPDATE_TABLE: {
        return {
          ...state,
          flightTailIdUpdateTableLoading: false,
          flightTailIdUpdateTable: action.payload
        }
      }
      case SET_FLIGHT_TAILID_UPDATE_TABLE_COUNT_LOADING: {
        return {
          ...state,
          flightTailIdUpdateTableCountLoading: action.payload
        }
      }
      case GET_FLIGHT_TAILID_UPDATE_TABLE_COUNT: {
        return {
          ...state,
          flightTailIdUpdateTableCountLoading: false,
          flightTailIdUpdateTableCount: action.payload
        }
      }
      case SET_FLIGHT_SCHEDULE_TABLE_LOADING: {
        return {
          ...state,
          flightScheduleTableLoading: action.payload
        }
      }
      case GET_FLIGHT_SCHEDULE_TABLE: {
        return {
          ...state,
          flightScheduleTableLoading: false,
          flightScheduleTable: action.payload
        }
      }
      case SET_FLIGHT_SCHEDULE_TABLE_COUNT_LOADING: {
        return {
          ...state,
          flightScheduleTableCountLoading: action.payload
        }
      }
      case GET_FLIGHT_SCHEDULE_TABLE_COUNT: {
        return {
          ...state,
          flightScheduleTableCountLoading: false,
          flightScheduleTableCount: action.payload
        }
      }
      case SET_DEVICE_HISTORY_LOADING: {
        return {
          ...state,
          setDeviceHistoryLoading: action.payload
        }
      }
      case GET_DEVICE_HISTORY: {
        return {
          ...state,
          deviceHistory: action.payload,
          setDeviceHistoryLoading: false
        }
      }
      case SET_DEVICE_CONFIG_ACTION_LOGS_LOADING: {
        return {
          ...state,
          deviceConfigActionLogsLoading: action.payload
        }
      }
      case GET_DEVICE_CONFIG_ACTION_LOGS: {
        return {
          ...state,
          deviceConfigActionLogs: action.payload,
          deviceConfigActionLogsLoading: false
        }
      }
      case SET_DEVICE_EOS_HISTORY_EVENTS_LOADING: {
        return {
          ...state,
          deviceEosHistoryEventsLoading: action.payload
        }
      }
      case GET_DEVICE_EOS_HISTORY_EVENTS: {
        return {
          ...state,
          deviceEosHistoryEvents: action.payload,
          deviceEosHistoryEventsLoading: false
        }
      }
      case SET_DEVICE_LICENSE_HISTORY_LOADING: {
        return {
          ...state,
          deviceLicenseHistoryLoading: action.payload
        }
      }
      case GET_DEVICE_LICENSE_HISTORY: {
        return {
          ...state,
          deviceLicenseHistory: action.payload,
          deviceLicenseHistoryLoading: false
        }
      }
      case SET_UPGRADE_INVENTORY_LICENSE_LOADING: {
        return {
          ...state,
          setUpgradeInventoryLicenseLoading: action.payload
        }
      }
      case GET_UPGRADE_INVENTORY_LICENSE: {
        return {
          ...state,
          inventoryUpgradeLicense: action.payload,
          setUpgradeInventoryLicenseLoading: false
        }
      }
      case IS_INVENTORY_PREVIOUS_PAGE: {
        return {
          ...state,
          isInventoryPreviousPage: action.payload,
        }
      }
      case SET_UPGRADE_WAREHOUSE_DEVICE_TO_LATEST_EOS_VERSION_LOADING: {
        return {
          ...state,
          upgradeWarehouseDeviceToLatestEosVersionLoading: action.payload
        }
      }
      case UPGRADE_WAREHOUSE_DEVICE_TO_LATEST_EOS_VERSION: {
        return {
          ...state,
          upgradeWarehouseDeviceToLatestEosVersion: action.payload,
          upgradeWarehouseDeviceToLatestEosVersionLoading: false
        }
      }
      case SET_WIFI_INTERFACES_LOADING: {
        return {
          ...state,
          getWifiInterfacesLoading: action.payload
        }
      }
      case GET_WIFI_INTERFACES: {
        return {
          ...state,
          getWifiInterfaces: action.payload,
          getWifiInterfacesLoading: false
        }
      }
      case SET_ALL_INTERFACES_LOADING: {
        return {
          ...state,
          getAllInterfacesLoading: action.payload
        }
      }
      case GET_ALL_INTERFACES: {
        return {
          ...state,
          getAllInterfaces: action.payload,
          getAllInterfacesLoading: false
        }
      }
      case SET_WAN_PROFILES_LOADING: {
        return {
          ...state,
          getWanProfilesLoading: action.payload
        };
      }
      case GET_ALL_NETWORKS: {
        return {
          ...state,
          getAllNetworks: action.payload,
          getAllNetworksLoading: false
        }
      }
      case SET_ALL_NETWORKS_LOADING: {
        return {
          ...state,
          getAllNetworksLoading: action.payload
        };
      }
      
      case GET_WAN_PROFILES: {
        return {
          ...state,
          getWanProfiles: action.payload,
          getWanProfilesLoading: false
        };
      }
      case DELETE_INTERFACE_LOADING: {
        return {
          ...state,
          deleteInterfaceLoading: action.payload
        }
      }
      case DELETE_INTERFACE: {
        return {
          ...state,
          deleteInterface: action.payload,
          deleteInterfaceLoading: false
        }
      }
      case DELETE_LAN_LOADING: {
        return {
          ...state,
          deleteLANLoading: action.payload
        }
      }
      case DELETE_LAN: {
        return {
          ...state,
          deleteLan: action.payload,
          deleteLANLoading: false
        }
      }
      case DELETE_WIFI_LOADING: {
        return {
          ...state,
          deleteWIFILoading: action.payload
        }
      }
      case DELETE_WIFI: {
        return {
          ...state,
          deleteWifi: action.payload,
          deleteWIFILoading: false
        }
      }
      case GET_PHYSICAL_INTERFACES_LOADING: {
        return {
          ...state,
          getPhysicalInterfacesLoading: action.payload
        }
      }
      case GET_PHYSICAL_INTERFACES: {
        return {
          ...state,
          getPhysicalInterfaces: action.payload,
          getPhysicalInterfacesLoading: false
        }
      }
      case ADD_WAN_INTERFACE_LOADING: {
        return {
          ...state,
          addWanInterfaceLoading: action.payload
        }
      }
      case ADD_WAN_INTERFACE: {
        return {
          ...state,
          addWanInterface: action.payload,
          addWanInterfaceLoading: false
        }
      }
      case UPDATE_WAN_INTERFACE_LOADING: {
        return {
          ...state,
          updateWanInterfaceLoading: action.payload
        }
      }
      case UPDATE_WAN_INTERFACE: {
        return {
          ...state,
          updateWanInterface: action.payload,
          updateWanInterfaceLoading: false
        }
      }
      case ENABLE_DISABLE_INTERFACE_LOADING: {
        return {
          ...state,
          enableDisableInterfaceLoading: action.payload
        }
      }
      case ENABLE_DISABLE_INTERFACE: {
        return {
          ...state,
          enableDisableInterface: action.payload,
          enableDisableInterfaceLoading: false
        }
      }
      case ENABLE_DISABLE_DHCP_LOADING: {
        return {
          ...state,
          enableDisableDHCPLoading: action.payload
        }
      }
      case ENABLE_DISABLE_DHCP: {
        return {
          ...state,
          enableDisableDHCP: action.payload,
          enableDisableDHCPLoading: false
        }
      }
      case GET_FILTERED_NETWORKS_LOADING: {
        return {
          ...state,
          getFilteredNetworksLoading: action.payload
        }
      }
      case GET_FILTERED_NETWORKS: {
        return {
          ...state,
          getFilteredNetworks: action.payload,
          getFilteredNetworksLoading: false
        }
      }
      case GET_FREE_LAN_ACCESS_INTERFACES_LOADING: {
        return {
          ...state,
          getFreeLanAccessInterfacesLoading: action.payload
        }
      }
      case GET_FREE_LAN_ACCESS_INTERFACES: {
        return {
          ...state,
          getFreeLanAccessInterfaces: action.payload,
          getFreeLanAccessInterfacesLoading: false
        }
      }
      case GET_ROUTER_DIDS_LOADING: {
        return {
          ...state,
          getRouterDidsLoading: action.payload
        }
      }
      case GET_ROUTER_DIDS: {
        return {
          ...state,
          getRouterDids: action.payload,
          getRouterDidsLoading: false
        }
      }
      case GET_REGISTER_DEVICE_LOADING: {
        return {
          ...state,
          getRegisterDeviceLoading: action.payload
        }
      }
      case GET_REGISTER_DEVICE: {
        return {
          ...state,
          getRegisterDevice: action.payload,
          getRegisterDeviceLoading: false
        }
      }
      case GET_DEREGISTER_DEVICE_LOADING: {
        return {
          ...state,
          getDeRegisterDeviceLoading: action.payload
        }
      }
      case GET_DEREGISTER_DEVICE: {
        return {
          ...state,
          getDeRegisterDevice: action.payload,
          getDeRegisterDeviceLoading: false
        }
      }
      case GET_DEVICE_DETAILS_LOADING: {
        return {
          ...state,
          getDeviceDetailsLoading: action.payload
        }
      }
      case GET_DEVICE_DETAILS: {
        return {
          ...state,
          getDeviceDeatils: action.payload,
          getDeviceDetailsLoading: false
        }
      }
      case GET_SEARCH_DIDS_LOADING: {
        return {
          ...state,
          getSearchDidsLoading: action.payload
        }
      }
      case GET_SEARCH_DIDS: {
        return {
          ...state,
          getSearchDids: action.payload,
          getSearchDidsLoading: false
        }
      }
      case GET_SWAP_MODE_LOADING: {
        return {
          ...state,
          getSwapModeLoading: action.payload
        }
      }
      case GET_SWAP_MODE: {
        return {
          ...state,
          getSwapMode: action.payload,
          getSwapModeLoading: false
        }
      }
      case GET_DEVICE_TRANSFER_LOADING: {
        return {
          ...state,
          getDeviceTransferLoading: action.payload
        }
      }
      case GET_DEVICE_TRANSFER: {
        return {
          ...state,
          getDeviceTransfer: action.payload,
          getDeviceTransferLoading: false
        }
      }
      case GET_DEVICE_LINK_STATUS_LOADING: {
        return {
          ...state,
          getDeviceLinkStatusLoading: action.payload
        }
      }
      case GET_DEVICE_LINK_STATUS: {
        return {
          ...state,
          getDeviceLinkStatus: action.payload,
          getDeviceLinkStatusLoading: false
        }
      }
      case GET_LAN_TRUNK_FILTERED_NETWORKS_LOADING: {
        return {
          ...state,
          getLANTrunkFilteredNetworksLoading: action.payload
        }
      }
      case GET_LAN_TRUNK_FILTERED_NETWORKS: {
        return {
          ...state,
          getLANTrunkFilteredNetworks: action.payload,
          getLANTrunkFilteredNetworksLoading: false
        }
      }
      case GET_SAVED_WAN_PROFILE_DATA: {
        return {
          ...state,
          getSavedWanProfileData: action.payload,
        }
      }
      case UPDATE_SYNC_CHECK_STATUS: {
        return {
          ...state,
          getOESyncStatus: action.payload,
        }
      }
      case SET_CANCEL_DE_REGISTER: {
        return {
          ...state,
          setCancelDeRegister: action.payload
        }
      }
      case GET_CANCEL_DE_REGISTER: {
        return {
          ...state,
          getCancelDeRegister: action.payload,
          setCancelDeRegister: false
        }
      }
      case GET_STATIC_ROUTES_LOADING: {
        return {
          ...state,
          getStaticRoutesLoading: action.payload,
        }
      }
      case GET_STATIC_ROUTES: {
        return {
          ...state,
          getStaticRoutes: action.payload,
          getStaticRoutesLoading: false,
        }
      }
      case DELETE_STATIC_ROUTE_LOADING: {
        return {
          ...state,
          deleteStaticRouteLoading: action.payload,
        }
      }
      case DELETE_STATIC_ROUTE: {
        return {
          ...state,
          deleteStaticRoute: action.payload,
          deleteStaticRouteLoading: false,
        }
      }
      case GET_ALL_WAN_INTERFACES_FOR_ADV_SETTINGS_LOADING: {
        return {
          ...state,
          geteAllWanInterfacesForAdvSettingsLoading: action.payload,
        }
      }
      case GET_ALL_WAN_INTERFACES_FOR_ADV_SETTINGS: {
        return {
          ...state,
          geteAllWanInterfacesForAdvSettings: action.payload,
          geteAllWanInterfacesForAdvSettingsLoading: false,
        }
      }
      case GET_ENABLE_DISABLE_NO_NAT_LOADING: {
        return {
          ...state,
          getEnableDisableNoNatLoading: action.payload,
        }
      }
      case GET_ENABLE_DISABLE_NO_NAT: {
        return {
          ...state,
          getEnableDisableNoNat: action.payload,
          getEnableDisableNoNatLoading: false,
        }
      }
      case GET_LAN_IP_RANGES_LOADING: {
        return {
          ...state,
          getLanIpRangesLoading: action.payload,
        }
      }
      case GET_LAN_IP_RANGES: {
        return {
          ...state,
          getLanIpRanges: action.payload,
          getLanIpRangesLoading: false,
        }
      }
      case GET_ALL_PORT_CONFIGS_LOADING: {
        return {
          ...state,
          getAllPortConfigsLoading: action.payload,
        }
      }
      case GET_ALL_PORT_CONFIGS: {
        return {
          ...state,
          getAllPortConfigs: action.payload,
          getAllPortConfigsLoading: false,
        }
      }
      case GET_ADD_EDIT_PORT_CONFIG_LOADING: {
        return {
          ...state,
          getAddEditPortConfigLoading: action.payload,
        }
      }
      case GET_ADD_EDIT_PORT_CONFIG: {
        return {
          ...state,
          getAddEditPortConfig: action.payload,
          getAddEditPortConfigLoading: false,
        }
      }
      case GET_DELETE_PORT_CONFIG_LOADING: {
        return {
          ...state,
          getDeletePortConfigLoading: action.payload,
        }
      }
      case GET_DELETE_PORT_CONFIG: {
        return {
          ...state,
          getDeletePortConfig: action.payload,
          getDeletePortConfigLoading: false,
        }
      }
      case GET_DHCP_RESERVATIONS_LOADING: {
        return {
          ...state,
          getDhcpReservationsLoading: action.payload,
        }
      }
      case GET_DHCP_RESERVATIONS: {
        return {
          ...state,
          getDhcpReservations: action.payload,
          getDhcpReservationsLoading: false,
        }
      }
      case GET_DELETE_DHCP_RESERVATION_LOADING: {
        return {
          ...state,
          getDeleteDhcpReservationLoading: action.payload,
        }
      }
      case GET_DELETE_DHCP_RESERVATION: {
        return {
          ...state,
          getDeleteDhcpReservation: action.payload,
          getDeleteDhcpReservationLoading: false,
        }
      }
      case GET_ALL_FIREWALL_RULES_LOADING: {
        return {
          ...state,
          getAllFirewallRulesLoading: action.payload,
        }
      }
      case GET_ALL_FIREWALL_RULES: {
        return {
          ...state,
          getAllFirewallRules: action.payload,
          getAllFirewallRulesLoading: false,
        }
      }
      case GET_IDENTITY_RULES: {
        return {
          ...state,
          getIdentityRules: action.payload,
          getIdentityRulesLoading: false,
        }
      }
      case GET_IDENTITY_RULES_LOADING: {
        return {
          ...state,
          getIdentityRulesLoading: action.payload,
        }
      }
      case GET_IDENTITY_RULE_BY_ID: {
        return {
          ...state,
          getIdentityRuleDetails: action.payload,
          getIdentityRulesByIdLoading: false,
        }
      }
      case GET_IDENTITY_RULES_BY_ID_LOADING: {
        return {
          ...state,
          getIdentityRulesByIdLoading: action.payload,
        }
      }
      case CREATE_UPDATE_IDENTITY_RULE: {
        return {
          ...state,
          createUpdateIdentityRule: action.payload,
          createUpdateIdentityRuleLoading: false,
        }
      }
      case CREATE_UPDATE_IDENTITY_RULE_LOADING: {
        return {
          ...state,
          createUpdateIdentityRuleLoading: action.payload,
        }
      }
      case DELETE_IDENTITY_RULE: {
        return {
          ...state,
          deletedIdentityRule: action.payload,
          deleteIdentityRuleLoading: false,
        }
      }
      case DELETE_IDENTITY_RULE_LOADING: {
        return {
          ...state,
          deleteIdentityRuleLoading: action.payload,
        }
      }
      case GET_INTERFACES_FIREWALL_RULES_LOADING: {
        return {
          ...state,
          getInterfacesFirewallRulesLoading: action.payload,
        }
      }
      case GET_INTERFACES_FIREWALL_RULES: {
        return {
          ...state,
          getInterfacesFirewallRules: action.payload,
          getInterfacesFirewallRulesLoading: false,
        }
      }
      case GET_ADD_EDIT_FIREWALL_RULE_LOADING: {
        return {
          ...state,
          getAddEditFirewallRuleLoading: action.payload,
        }
      }
      case GET_ADD_EDIT_FIREWALL_RULE: {
        return {
          ...state,
          getAddEditFirewallRule: action.payload,
          getAddEditFirewallRuleLoading: false,
        }
      }
      case GET_ENABLE_DISABLE_FIREWALL_RULE_LOADING: {
        return {
          ...state,
          getEnableDisableFirewallRuleLoading: action.payload,
        }
      }
      case GET_ENABLE_DISABLE_FIREWALL_RULE: {
        return {
          ...state,
          getEnableDisableFirewallRule: action.payload,
          getEnableDisableFirewallRuleLoading: false,
        }
      }
      case GET_ENABLE_DISABLE_PORT_FORWARD_LOADING: {
        return {
          ...state,
          getEnableDisablePortForwardLoading: action.payload,
        }
      }
      case GET_ENABLE_DISABLE_PORT_FORWARD: {
        return {
          ...state,
          getEnableDisablePortForward: action.payload,
          getEnableDisablePortForwardLoading: false,
        }
      }
      case GET_DELETE_FIREWALL_RULE_LOADING: {
        return {
          ...state,
          getDeleteFirewallRuleLoading: action.payload,
        }
      }
      case GET_DELETE_FIREWALL_RULE: {
        return {
          ...state,
          getDeleteFirewallRule: action.payload,
          getDeleteFirewallRuleLoading: false,
        }
      }
      case GET_ENABLE_DISABLE_DNS_CASHE_LOADING: {
        return {
          ...state,
          getEnableDisableDnsProxyLoading: action.payload,
        }
      }
      case GET_ENABLE_DISABLE_DNS_CASHE: {
        return {
          ...state,
          getEnableDisableDnsProxy: action.payload,
          getEnableDisableDnsProxyLoading: false,
        }
      }
      case GET_LAN_MULTICAST_LOADING: {
        return {
          ...state,
          getLanMulticastLoading: action.payload,
        }
      }
      case GET_LAN_MULTICAST: {
        return {
          ...state,
          getLanMulticast: action.payload,
          getLanMulticastLoading: false,
        }
      }
      case GET_SET_LAN_MULTICAST_LOADING: {
        return {
          ...state,
          getSetLanMulticastLoading: action.payload,
        }
      }
      case GET_SET_LAN_MULTICAST: {
        return {
          ...state,
          getSetLanMulticast: action.payload,
          getSetLanMulticastLoading: false,
        }
      }
      case GET_DNS_PROXY_CONFIG_LOADING: {
        return {
          ...state,
          getDnsProxyConfigLoading: action.payload,
        }
      }
      case GET_DNS_PROXY_CONFIG: {
        return {
          ...state,
          getDnsProxyConfig: action.payload,
          getDnsProxyConfigLoading: false,
        }
      }
      case GET_DELETE_DNS_PROXY_CONFIG_LOADING: {
        return {
          ...state,
          getDeleteDnsProxyConfigLoading: action.payload,
        }
      }
      case GET_DELETE_DNS_PROXY_CONFIG: {
        return {
          ...state,
          getDeleteDnsProxyConfig: action.payload,
          getDeleteDnsProxyConfigLoading: false,
        }
      }
      case GET_IP_CONFIG_UPDATE_LOADING: {
        return {
          ...state,
          getIpConfigUpdateLoading: action.payload,
        }
      }
      case GET_IP_CONFIG_UPDATE: {
        return {
          ...state,
          getIpConfigUpdate: action.payload,
          getIpConfigUpdateLoading: false,
        }
      }
      case SET_FIREWALL_RULE_PRIORITY_LOADING: {
        return {
          ...state,
          setFirewallRulePriorityLoading: action.payload
        }
      }
      case SET_PAUSE_LICENSE: {
        return {
          ...state,
          setPauseLicense: action.payload
        }
      }
      case GET_PAUSE_LICENSE: {
        return {
          ...state,
          getPauseLicense: action.payload,
          setPauseLicense: false
        }
      }
      case SET_RESUME_LICENSE: {
        return {
          ...state,
          setResumeLicense: action.payload
        }
      }
      case GET_RESUME_LICENSE: {
        return {
          ...state,
          getResumeLicense: action.payload,
          setResumeLicense: false
        }
      }
      case SET_WH_ProdGP_DEVICE_LIST: {
        return {
          ...state,
          setWHProdGPDeviceListLoading: action.payload,
        };
      }
      case GET_WH_ProdGP_DEVICE_LIST: {
        return {
          ...state,
          getWHProdGPDeviceList: action.payload,
          setWHProdGPDeviceListLoading: false
        };
      }
      case SET_TRANSFER_LICENSE_LOADING: {
        return {
          ...state,
          setTransferLicenseLoading: action.payload,
        };
      }
      case GET_TRANSFER_LICENSE: {
        return {
          ...state,
          getTransferLicense: action.payload,
          setTransferLicenseLoading: false
        };
      }
      case SET_CANCEL_PAUSE_LICENSE_LOADING: {
        return {
          ...state,
          setCancelPauseLicenseLoading: action.payload,
        };
      }
      case GET_CANCEL_PAUSE_LICENSE: {
        return {
          ...state,
          getCancelPauseLicense: action.payload,
          setCancelPauseLicenseLoading: false
        };
      }
      case SET_INVENTORY_SYNC_DATA: {
        return {
          ...state,
          setInventorySyncData: action.payload
        }
      }
      case GET_INVENTORY_SYNC_DATA: {
        return {
          ...state,
          getInventorySyncData: action.payload,
          setInventorySyncData: false
        }
      }
      case TRACK_INVENTORY_SYNC_DATA: {
        return {
          ...state,
          trackInventoryStatusData: action.payload
        }
      }
      case SET_ATTACH_DEVICE_TO_SITE_LOADING: {
        return {
          ...state,
          setAttachDeviceToSiteLoading: action.payload
        }
      }
      case GET_ATTACH_DEVICE_TO_SITE: {
        return {
          ...state,
          getAttachDeviceToSite: action.payload,
          setAttachDeviceToSiteLoading: false
        }
      }
      case SET_CREATE_SHARE_CONFIG_LOADING: {
        return {
          ...state,
          setCreateShareConfigLoading: action.payload,
        };
      }
      case CREATE_SHARE_CONFIG: {
        return {
          ...state,
          createShareConfig: action.payload,
          setCreateShareConfigLoading: false
        };
      }
      case SET_SHARED_CONFIG_PER_CONFIG_LOADING: {
        return {
          ...state,
          setSharedConfigPerConfigLoading: action.payload,
        };
      }
      case GET_SHARED_CONFIG_PER_CONFIG: {
        return {
          ...state,
          getSharedConfigPerConfig: action.payload,
          setSharedConfigPerConfigLoading: false
        };
      }
      case SET_UPDATE_SHARED_CONFIG_LOADING: {
        return {
          ...state,
          setUpdateSharedConfigLoading: action.payload,
        };
      }
      case UPDATE_SHARED_CONFIG: {
        return {
          ...state,
          getUpdateSharedConfig: action.payload,
          setUpdateSharedConfigLoading: false
        };
      }
      case SET_DELETE_SHARED_CONFIG_LOADING: {
        return {
          ...state,
          setDeleteSharedConfigLoading: action.payload,
        };
      }
      case DELETE_SHARED_CONFIG: {
        return {
          ...state,
          getDeleteSharedConfig: action.payload,
          setDeleteSharedConfigLoading: false
        };
      }

      case SET_WAN_PROFILE_DETAILS_LOADING: {
        return {
          ...state,
          getWanProfileDetailsLoading: action.payload,
        };
      }
      
      case GET_WAN_PROFILE_DETAILS: {
        return {
          ...state,
          getWanProfileDetails: action.payload,
          getWanProfileDetailsLoading: false,
        };
      }
      
      
      
      case SET_HUB_DASHBOARD_HUB_DATA_LOADING: {
        return {
          ...state,
          setHubDataLoading: action.payload
        }
      }
      case GET_HUB_DASHBOARD_HUB_DATA: {
        return {
          ...state,
          hubDataTableRow: action.payload,
          setHubDataLoading: false
        }
      }
      case SET_HUB_DASHBOARD_HUB_DATA_COUNT_LOADING: {
        return {
          ...state,
          setHubDataCountLoading: action.payload
        }
      }
      case GET_HUB_DASHBOARD_HUB_DATA_COUNT: {
        return {
          ...state,
          hubDataTableRowCount: action.payload,
          setHubDataCountLoading: false
        }
      }
      case SET_HUB_DASHBOARD_CLIENT_TABLE_LOADING: {
        return {
          ...state,
          setHubDataClientTableLoading: action.payload
        }
      }
      case GET_HUB_DASHBOARD_CLIENT_TABLE: {
        return {
          ...state,
          hubDataClientTable: action.payload,
          setHubDataClientTableLoading: false
        }
      }
      case SET_HUB_DASHBOARD_SITES_DROPDOWN_LOADING: {
        return {
          ...state,
          hubDataSitesDropdownLoading: action.payload
        }
      }
      case GET_HUB_DASHBOARD_SITES_DROPDOWN:
        if (!_.isEqual(state.getHubVesselListing, action.payload)) {
          return {
            ...state,
            getHubVesselListing: action.payload,
            hubDataSitesDropdownLoading: false
          }
      } else {
        return {
          ...state
        }
      }
      case SET_HUB_DASHBOARD_CLIENT_WISE_LOADING: {
        return {
          ...state,
          setHubDashboardClientWiseLoading: action.payload
        }
      }
      case GET_HUB_DASHBOARD_CLIENT_WISE: {
        return {
          ...state,
          hubDashboardClientWiseData: action.payload,
          setHubDashboardClientWiseLoading: false
        }
      }
      case SET_HUB_DASHBOARD_CLIENT_WISE_COUNT_LOADING: {
        return {
          ...state,
          setHubDashboardClientWiseCountLoading: action.payload
        }
      }
      case GET_HUB_DASHBOARD_CLIENT_WISE_COUNT: {
        return {
          ...state,
          hubDashboardClientWiseDataCount: action.payload,
          setHubDashboardClientWiseCountLoading: false
        }
      }
      case SET_TOPOLOGY_HUB_TABLE: {
        return {
          ...state,
          setTopologyHubTableLoading: action.payload
        }
      }
      case GET_TOPOLOGY_HUB_TABLE: {
        return {
          ...state,
          getTopologyHubTable: action.payload,
          setTopologyHubTableLoading: false
        }
      }
      case SET_HUB_DASHBOARD_CARRIER_CLIENT_TABLE: {
        return {
          ...state,
          setHubDashboardCarrierClientTableLoading: action.payload
        }
      }
      case GET_HUB_DASHBOARD_CARRIER_CLIENT_TABLE: {
        return {
          ...state,
          carrierHubDataClientTable: action.payload,
          setHubDashboardCarrierClientTableLoading: false
        }
      }
      case SET_HUB_DASHBOARD_CARRIER_SERVICE_VRF_TABLE: {
        return {
          ...state,
          setHubDashboardCarrierServiceTableLoading: action.payload
        }
      }
      case GET_HUB_DASHBOARD_CARRIER_SERVICE_VRF_TABLE: {
        return {
          ...state,
          getHubDashboardServiceTable: action.payload,
          setHubDashboardCarrierServiceTableLoading: false
        }
      }
      case SET_CARRIER_HUB_SDWAN_STATUS: {
        return {
          ...state,
          setCarrierHubSDWAnStatusLoading: action.payload
        }
      }
      case GET_CARRIER_HUB_SDWAN_STATUS: {
        return {
          ...state,
          getCarrierHubSDWANStatus: action.payload,
          setCarrierHubSDWAnStatusLoading: false
        }
      }
      case SET_CARRIER_HUB_SDWAN_LATENCY: {
        return {
          ...state,
          setCarrierHubSDWAnLatencyLoading: action.payload
        }
      }
      case GET_CARRIER_HUB_SDWAN_LATENCY: {
        return {
          ...state,
          getCarrierHubSDWANLatency: action.payload,
          setCarrierHubSDWAnLatencyLoading: false
        }
      }
      case SET_CARRIER_HUB_SDWAN_DATA_RATES: {
        return {
          ...state,
          setCarrierHubSDWANDataRatesLoading: action.payload
        }
      }
      case GET_CARRIER_HUB_SDWAN_DATA_RATES: {
        return {
          ...state,
          getCarrierHubSDWANDataRates: action.payload,
          setCarrierHubSDWANDataRatesLoading: false
        }
      }
      case SET_CARRIER_HUB_SDWAN_USAGE: {
        return {
          ...state,
          setCarrierHubSDWANUsageLoading: action.payload
        }
      }
      case GET_CARRIER_HUB_SDWAN_USAGE: {
        return {
          ...state,
          getCarrierHubSDWANUsage: action.payload,
          setCarrierHubSDWANUsageLoading: false
        }
      }
      case SET_CARRIER_HUB_SDWAN_BASE_RTT: {
        return {
          ...state,
          setCarrierHubSDWANBaseRttLoading: action.payload
        }
      }
      case GET_CARRIER_HUB_SDWAN_BASE_RTT: {
        return {
          ...state,
          getCarrierHubSDWANBaseRtt: action.payload,
          setCarrierHubSDWANBaseRttLoading: false
        }
      }
      case SET_CARRIER_HUB_SDWAN_CURRENT_RTT: {
        return {
          ...state,
          setCarrierHubSDWANCurrentRttLoading: action.payload
        }
      }
      case GET_CARRIER_HUB_SDWAN_CURRENT_RTT: {
        return {
          ...state,
          getCarrierHubSDWANCurrentRtt: action.payload,
          setCarrierHubSDWANCurrentRttLoading: false
        }
      }
      case SET_CARRIER_HUB_SDWAN_PACKET_DROP: {
        return {
          ...state,
          setCarrierHubSDWANPacketDropLoading: action.payload
        }
      }
      case GET_CARRIER_HUB_SDWAN_PACKET_DROP: {
        return {
          ...state,
          getCarrierHubSDWANPacketDrop: action.payload,
          setCarrierHubSDWANPacketDropLoading: false
        }
      }
      case SET_CARRIER_HUB_SDWAN_TUNNEL_MIGRATION: {
        return {
          ...state,
          setCarrierHubSDWANTunnelMigrationLoading: action.payload
        }
      }
      case GET_CARRIER_HUB_SDWAN_TUNNEL_MIGRATION: {
        return {
          ...state,
          getCarrierHubSDWANTunnelMigration: action.payload,
          setCarrierHubSDWANTunnelMigrationLoading: false
        }
      }
      case SET_CARRIER_HUB_SDWAN_PACING_RATE: {
        return {
          ...state,
          setCarrierHubSDWANPacingRateLoading: action.payload
        }
      }
      case GET_CARRIER_HUB_SDWAN_PACING_RATE: {
        return {
          ...state,
          getCarrierHubSDWANPacingRate: action.payload,
          setCarrierHubSDWANPacingRateLoading: false
        }
      }
      case SET_CARRIER_HUB_SDWAN_BTLBW: {
        return {
          ...state,
          setCarrierHubSDWANBtlbwLoading: action.payload
        }
      }
      case GET_CARRIER_HUB_SDWAN_BTLBW: {
        return {
          ...state,
          getCarrierHubSDWANBtlbw: action.payload,
          setCarrierHubSDWANBtlbwLoading: false
        }
      }
      case SET_CARRIER_HUB_SDWAN_BYTES_IN_FLIGHT: {
        return {
          ...state,
          setCarrierHubSDWANBytesInFlightLoading: action.payload
        }
      }
      case GET_CARRIER_HUB_SDWAN_BYTES_IN_FLIGHT: {
        return {
          ...state,
          getCarrierHubSDWANBytesInFlight: action.payload,
          setCarrierHubSDWANBytesInFlightLoading: false
        }
      }
      case SET_CARRIER_HUB_SDWAN_CONGESTION_WINDOW: {
        return {
          ...state,
          setCarrierHubSDWANCongestionWindowLoading: action.payload
        }
      }
      case GET_CARRIER_HUB_SDWAN_CONGESTION_WINDOW: {
        return {
          ...state,
          getCarrierHubSDWANCongestionWindow: action.payload,
          setCarrierHubSDWANCongestionWindowLoading: false
        }
      }
      case SET_CARRIER_HUB_SDWAN_DROPPED_DATAGRAMS: {
        return {
          ...state,
          setCarrierHubSDWANDroppedDataGramsLoading: action.payload
        }
      }
      case GET_CARRIER_HUB_SDWAN_DROPPED_DATAGRAMS: {
        return {
          ...state,
          getCarrierHubSDWANDroppedDataGrams: action.payload,
          setCarrierHubSDWANDroppedDataGramsLoading: false
        }
      }
      case SET_CARRIER_HUB_SDWAN_ONE_WAY_DELAY_OWD: {
        return {
          ...state,
          setCarrierHubSDWANOneWayDelayOwdLoading: action.payload
        }
      }
      case GET_CARRIER_HUB_SDWAN_ONE_WAY_DELAY_OWD: {
        return {
          ...state,
          getCarrierHubSDWANOneWayDelayOwd: action.payload,
          setCarrierHubSDWANOneWayDelayOwdLoading: false
        }
      }
      case SET_CARRIER_HUB_SDWAN_ACK_COUNT: {
        return {
          ...state,
          setCarrierHubSDWANAckCountLoading: action.payload
        }
      }
      case GET_CARRIER_HUB_SDWAN_ACK_COUNT: {
        return {
          ...state,
          getCarrierHubSDWANAckCount: action.payload,
          setCarrierHubSDWANAckCountLoading: false
        }
      }
      case SET_CARRIER_HUB_SDWAN_PACING_LIMITED: {
        return {
          ...state,
          setCarrierHubSDWANPacingLimitedLoading: action.payload
        }
      }
      case GET_CARRIER_HUB_SDWAN_PACING_LIMITED: {
        return {
          ...state,
          getCarrierHubSDWANPacingLimited: action.payload,
          setCarrierHubSDWANPacingLimitedLoading: false
        }
      }
      case SET_CARRIER_HUB_SDWAN_SENT_DATAGRAMS: {
        return {
          ...state,
          setCarrierHubSDWANSentDataGramsLoading: action.payload
        }
      }
      case GET_CARRIER_HUB_SDWAN_SENT_DATAGRAMS: {
        return {
          ...state,
          getCarrierHubSDWANSentDataGrams: action.payload,
          setCarrierHubSDWANSentDataGramsLoading: false
        }
      }
      case SET_CARRIER_HUB_SDWAN_BLOCK_COUNT: {
        return {
          ...state,
          setCarrierHubSDWANBlockCountLoading: action.payload
        }
      }
      case GET_CARRIER_HUB_SDWAN_BLOCK_COUNT: {
        return {
          ...state,
          getCarrierHubSDWANBlockCount: action.payload,
          setCarrierHubSDWANBlockCountLoading: false
        }
      }
      case SET_CARRIER_HUB_SDWAN_AGENTS_LIST: {
        return {
          ...state,
          setCarrierHubSDWANAgentsListLoading: action.payload
        }
      }
      case GET_CARRIER_HUB_SDWAN_AGENTS_LIST: {
        return {
          ...state,
          getCarrierHubSDWANAgentsList: action.payload,
          setCarrierHubSDWANAgentsListLoading: false
        }
      }
      case SET_CARRIER_HUB_SDWAN_HUBS: {
        return {
          ...state,
          setCarrierHubSDWANHubsLoading: action.payload
        }
      }
      case GET_CARRIER_HUB_SDWAN_HUBS: {
        return {
          ...state,
          getCarrierHubSDWANHubs: action.payload,
          setCarrierHubSDWANHubsLoading: false
        }
      }
      case SET_CARRIER_HUB_AGENT_DROPDOWN: {
        return {
          ...state,
          setCarrierHubAgentDropdownLoading: action.payload
        }
      }
      case GET_CARRIER_HUB_AGENT_DROPDOWN: {
        return {
          ...state,
          getCarrierHubAgentDropdown: action.payload,
          setCarrierHubAgentDropdownLoading: false
        }
      }
      case SET_CARRIER_HUB_WAN_DROPDOWN: {
        return {
          ...state,
          setCarrierHubWanDropdownLoading: action.payload
        }
      }
      case GET_CARRIER_HUB_WAN_DROPDOWN: {
        return {
          ...state,
          getCarrierHubWanDropdown: action.payload,
          setCarrierHubWanDropdownLoading: false
        }
      }
      case SET_CARRIER_HUB_SDWAN_HUB_DROPDOWN: {
        return {
          ...state,
          setCarrierHubListDropdownLoading: action.payload
        }
      }
      case GET_CARRIER_HUB_SDWAN_HUB_DROPDOWN: {
        return {
          ...state,
          getCarrierHubListDropdown: action.payload,
          setCarrierHubListDropdownLoading: false
        }
      }
      case CREATE_AGENT_WAN:{
        return {
          ...state,
          createAgentWan: action.payload,
          createAgentWanLoading: false
        }
      }
      case CREATE_AGENT_WAN_LOADING:
        return {
          ...state,
          createAgentWanLoading: action.payload
        }
      case UPDATE_AGENT_WAN:{
        return {
          ...state,
          updateAgentWan: action.payload,
          updateAgentWanLoading: false
        }
      }
      case UPDATE_AGENT_WAN_LOADING:
        return {
          ...state,
          updateAgentWanLoading: action.payload
        }
      case DELETE_AGENT_WAN:{
        return {
          ...state,
          deleteAgentWan: action.payload,
          deleteAgentWanLoading: false
        }
      }
      case DELETE_AGENT_WAN_LOADING:
        return {
          ...state,
          deleteAgentWanLoading: action.payload
        }
      case GET_AGENT_WANS:{
        return {
          ...state,
          getAgentWans: action.payload,
          getAgentWansLoading: false
        }
      }
      case GET_AGENT_WANS_LOADING:
        return {
          ...state,
          getAgentWansLoading: action.payload
        }
      case CREATE_AGENT_WAN_PROFILE:{
        return {
          ...state,
          createAgentWanProfile: action.payload,
          createAgentWanProfileLoading: false
        }
      }
      case CREATE_AGENT_WAN_PROFILE_LOADING:
        return {
          ...state,
          createAgentWanProfileLoading: action.payload
        }
      case UPDATE_AGENT_WAN_PROFILE:{
        return {
          ...state,
          updateAgentWanProfile: action.payload,
          updateAgentWanProfileLoading: false
        }
      }
      case UPDATE_AGENT_WAN_PROFILE_LOADING:
        return {
          ...state,
          updateAgentWanProfileLoading: action.payload
        }
      case DELETE_AGENT_WAN_PROFILE:{
        return {
          ...state,
          deleteAgentWanProfile: action.payload,
          deleteAgentWanProfileLoading: false
        }
      }
      case DELETE_AGENT_WAN_PROFILE_LOADING:
        return {
          ...state,
          deleteAgentWanProfileLoading: action.payload
        }
      case GET_AGENT_WAN_PROFILES:{
        return {
          ...state,
          getAgentWanProfiles: action.payload,
          getAgentWanProfilesLoading: false
        }
      }
      case GET_AGENT_WAN_PROFILES_LOADING:
        return {
          ...state,
          getAgentWanProfilesLoading: action.payload
        }
        case CREATE_AGENT_HUB:{
          return {
            ...state,
            createAgentHub: action.payload,
            createAgentHubLoading: false
          }
        }
        case CREATE_AGENT_HUB_LOADING:
          return {
            ...state,
            createAgentHubLoading: action.payload
          }
        case GET_AGENT_HUBS:{
          return {
            ...state,
            getAgentHubs: action.payload,
            getAgentHubsLoading: false
          }
        }
      case GET_AGENT_HUBS_LOADING:
          return {
            ...state,
            getAgentHubsLoading: action.payload
          }
          case GET_AGENT_HUBS_PER_SERVICE:{
            return {
              ...state,
              getAgentHubsPerService: action.payload,
              getAgentHubsPerServiceLoading: false
            }
          }
        case GET_AGENT_HUBS_PER_SERVICE_LOADING:
            return {
              ...state,
              getAgentHubsPerServiceLoading: action.payload
            }

      case CREATE_AGENT_SERVICE_VLAN:{
          return {
            ...state,
            createAgentServiceVlan: action.payload,
            createAgentServiceVlanLoading: false
          }
        }
      case CREATE_AGENT_SERVICE_VLAN_LOADING:
        return {
          ...state,
          createAgentServiceVlanLoading: action.payload
        }
      case GET_AGENT_SERVICE_VLANS:{
        return {
          ...state,
          getAgentServiceVlans: action.payload,
          getAgentServiceVlansLoading: false
        }
      }
      case GET_AGENT_SERVICE_VLANS_LOADING:
        return {
          ...state,
          getAgentServiceVlansLoading: action.payload
      }

      case CREATE_AGENT_ROUTE:{
        return {
          ...state,
          createAgentRoute: action.payload,
          createAgentRouteLoading: false
        }
      }
      case CREATE_AGENT_ROUTE_LOADING:
        return {
          ...state,
          createAgentRouteLoading: action.payload
        }
      case GET_AGENT_ROUTES:{
        return {
          ...state,
          getAgentRoutes: action.payload,
          getAgentRoutesLoading: false
        }
      }
      case GET_AGENT_ROUTES_LOADING:
        return {
          ...state,
          getAgentRoutesLoading: action.payload
        }

      case CREATE_AGENT_SERVICE:{
        return {
          ...state,
          createAgentService: action.payload,
          createAgentServiceLoading: false
        }
      }
      case CREATE_AGENT_SERVICE_LOADING:
        return {
          ...state,
          createAgentServiceLoading: action.payload
        }
      case UPDATE_AGENT_SERVICE:{
        return {
          ...state,
          updateAgentService: action.payload,
          updateAgentServiceLoading: false
        }
      }
      case UPDATE_AGENT_SERVICE_LOADING:
        return {
          ...state,
          updateAgentServiceLoading: action.payload
        }
      case GET_AGENT_SERVICES:{
        return {
          ...state,
          getAgentServices: action.payload,
          getAgentServicesLoading: false
        }
      }
        case GET_AGENT_SERVICES_LOADING:
          return {
            ...state,
            getAgentServicesLoading: action.payload
          }
        case CREATE_AGENT_PROFILE:{
          return {
            ...state,
            createAgentProfile: action.payload,
            createAgentProfileLoading: false
          }
        }
        case CREATE_AGENT_PROFILE_LOADING:
          return {
            ...state,
            createAgentProfileLoading: action.payload
          }
          case GET_AGENT_PROFILES:{
            return {
              ...state,
              getAgentProfiles: action.payload,
              getAgentProfilesLoading: false
            }
          }
          case GET_AGENT_PROFILES_LOADING:
            return {
              ...state,
              getAgentProfilesLoading: action.payload
            }
        case CREATE_AGENT_CONFIG:{
          return {
            ...state,
            createAgentConfig: action.payload,
            createAgentConfigLoading: false
          }
        }
        case CREATE_AGENT_CONFIG_LOADING:
          return {
            ...state,
            createAgentConfigLoading: action.payload
          }
        case GET_AGENT_CONFIGS:{
          return {
            ...state,
            getAgentConfigs: action.payload,
            getAgentConfigsLoading: false
            }
          }
        case GET_AGENT_CONFIGS_LOADING:
          return {
            ...state,
            getAgentConfigsLoading: action.payload
          }
        case CREATE_AGENT:{
          return {
            ...state,
            createAgent: action.payload,
            createAgentLoading: false
          }
          }
          case CREATE_AGENT_LOADING:
            return {
              ...state,
              createAgentLoading: action.payload
            }
        case GET_AGENTS:{
          return {
            ...state,
            getAgents: action.payload,
            getAgentsLoading: false
          }
        }
      case GET_AGENT_CONFIG_SUMMARY_LOADING:
        return {
          ...state,
          getAgentConfigSummaryLoading: action.payload
        }
        case GET_AGENT_CONFIG_SUMMARY:{
          return {
            ...state,
            getAgentConfigSummary: action.payload,
            getAgentConfigSummaryLoading: false
          }
        }
      case GET_HUB4_AGENT_CONFIG_SUMMARY: {
        return {
          ...state,
          getHub4AgentConfigSummary: action.payload,
          getHub4AgentConfigSummaryLoading: false
        }
      }
      case GET_HUB4_AGENT_CONFIG_SUMMARY_LOADING: {
        return {
          ...state,
          getHub4AgentConfigSummaryLoading: action.payload
        }
      }
      case GET_AGENTS_LOADING:
        return {
          ...state,
          getAgentsLoading: action.payload
        }
      case CREATE_AGENT_ACCESS_NETWORK:{
        return {
          ...state,
          createAgentAccessNetwork: action.payload,
          createAgentAccessNetworkLoading: false
        }
      }
      case CREATE_AGENT_ACCESS_NETWORK_LOADING:
        return {
          ...state,
          createAgentAccessNetworkLoading: action.payload
        }
      case UPDATE_AGENT_ACCESS_NETWORK:{
        return {
          ...state,
          updateAgentAccessNetwork: action.payload,
          updateAgentAccessNetworkLoading: false
        }
      }
      case UPDATE_AGENT_ACCESS_NETWORK_LOADING:
        return {
          ...state,
          updateAgentAccessNetworkLoading: action.payload
        }
      case UPLOAD_AGENT_CONFIG_LOADING: {
        return {
          ...state,
          uploadAgentConfigLoading: action.payload
        }
      }
      case UPLOAD_AGENT_CONFIG: {
        return {
          ...state,
          uploadAgentConfig: action.payload,
          uploadAgentConfigLoading: false
        }
      }
      case VERIFY_AGENT_CONFIG: {
        return {
          ...state,
          verifyAgentConfig: action.payload,
          verifyAgentConfigLoading: false
        }
      }
      case VERIFY_AGENT_CONFIG_LOADING: {
        return {
          ...state,
          verifyAgentConfigLoading: action.payload
        }
      }
      case UPDATE_UPLOAD_AGENT_CONFIG_LOADING: {
        return {
          ...state,
          updateUploadAgentConfigLoading: action.payload
        }
      }
      case UPDATE_UPLOAD_AGENT_CONFIG: {
        return {
          ...state,
          updateUploadAgentConfig: action.payload,
          updateUploadAgentConfigLoading: false
        }
      }
      case AGENT_CONFIG_ROW_DOWNLOAD: {
        return {
          ...state,
          agentConfigRowDownload: action.payload,
          agentConfigRowDownloadLoading: false
        }
      }
      case AGENT_CONFIG_ROW_DOWNLOAD_LOADING: {
        return {
          ...state,
          agentConfigRowDownloadLoading: action.payload
        }
      }
      case AGENT_CONFIG_SUMMARY: {
        return {
          ...state,
          agentConfigSummary: action.payload,
          agentConfigSummaryDownload: false
        }
      }
      case AGENT_CONFIG_SUMMARY_LOADING: {
        return {
          ...state,
          agentConfigSummaryDownload: action.payload
        }
      }
      case GET_AGENT_HUB_EVENTS:{
        return {
          ...state,
          getAgentHubEvents: action.payload,
          getAgentHubEventsLoading: false
        }
      }
      case GET_AGENT_HUB_EVENTS_LOADING:
      return {
        ...state,
        getAgentHubEventsLoading: action.payload
      }
      case GET_AGENT_HUB_EVENT_FILTERS:{
        return {
          ...state,
          getAgentHubEventFilters: action.payload,
          getAgentHubEventFiltersLoading: false
        }
      }
      case GET_AGENT_HUB_EVENT_FILTERS_LOADING:
      return {
        ...state,
        getAgentHubEventFiltersLoading: action.payload
      }
      case SET_CAPTIVE_DASHBOARD_SITES_SUBSCRIBERS_SESSIONS_TOP_WIDGET: {
        return {
          ...state,
          setCaptiveDashSitesSubscribersSesTopWidgetLoading: action.payload
        }
      }
      case GET_CAPTIVE_DASHBOARD_SITES_SUBSCRIBERS_SESSIONS_TOP_WIDGET: {
        return {
          ...state,
          getCDSitesSubscribersSesTopWidget: action.payload,
          setCaptiveDashSitesSubscribersSesTopWidgetLoading: false
        }
      }
      case SET_CAPTIVE_DASHBOARD_PLANS_TOP_WIDGET: {
        return {
          ...state,
          setCaptiveDashPlansTopWidgetLoading: action.payload
        }
      }
      case GET_CAPTIVE_DASHBOARD_PLANS_TOP_WIDGET: {
        return {
          ...state,
          getCDPlansTopWidget: action.payload,
          setCaptiveDashPlansTopWidgetLoading: false
        }
      }
      case SET_CAPTIVE_DASHBOARD_USAGE_TOP_WIDGET: {
        return {
          ...state,
          setCaptiveDashUsageTopWidgetLoading: action.payload
        }
      }
      case GET_CAPTIVE_DASHBOARD_USAGE_TOP_WIDGET: {
        return {
          ...state,
          getCDUsageTopWidget: action.payload,
          setCaptiveDashUsageTopWidgetLoading: false
        }
      }
      case SET_CAPTIVE_DASHBOARD_TOP_SITES_USAGE_BAR: {
        return {
          ...state,
          setCaptiveDashSitesUsageBarLoading: action.payload
        }
      }
      case GET_CAPTIVE_DASHBOARD_TOP_SITES_USAGE_BAR: {
        return {
          ...state,
          getCDSitesUsageBar: action.payload,
          setCaptiveDashSitesUsageBarLoading: false
        }
      }
      case SET_CAPTIVE_DASHBOARD_TOP_SITES_OVERAGE_USAGE_BAR: {
        return {
          ...state,
          captiveSitesOverageUsagebarLoading: action.payload
        }
      }
      case GET_CAPTIVE_DASHBOARD_TOP_SITES_OVERAGE_USAGE_BAR: {
        return {
          ...state,
            captiveSitesOverageUsagebar: action.payload,
            captiveSitesOverageUsagebarLoading: false,
        }
      }
      case SET_CAPTIVE_DASHBOARD_SUBSCRIBERS_LINE_CHART: {
        return {
          ...state,
          setCaptiveDashSubscribersLineChartLoading: action.payload
        }
      }
      case GET_CAPTIVE_DASHBOARD_SUBSCRIBERS_LINE_CHART: {
        return {
          ...state,
          getCDSitesSubscribersLineChart: action.payload,
          setCaptiveDashSubscribersLineChartLoading: false
        }
      }
      case SET_CAPTIVE_DASHBOARD_SESSIONS_LINE_CHART: {
        return {
          ...state,
          setCaptiveDashSessionsLineChartLoading: action.payload
        }
      }
      case GET_CAPTIVE_DASHBOARD_SESSIONS_LINE_CHART: {
        return {
          ...state,
          getCDSitesSessionsLineChart: action.payload,
          setCaptiveDashSessionsLineChartLoading: false
        }
      }
      case SET_CAPTIVE_DASHBOARD_OVERAGE_USAGE_LINE_CHART: {
        return {
          ...state,
          captiveSitesOverageUsagelinechartLoading: action.payload,
        }
      }
      case GET_CAPTIVE_DASHBOARD_OVERAGE_USAGE_LINE_CHART: {
        return {
          ...state,
          captiveSitesOverageUsagelinechart: action.payload,
          captiveSitesOverageUsagelinechartLoading: false,
        }
      }
      case SET_CAPTIVE_DASHBOARD_USAGE_LINE_CHART: {
        return {
          ...state,
          setCaptiveDashUsageLineChartLoading: action.payload
        }
      }
      case GET_CAPTIVE_DASHBOARD_USAGE_LINE_CHART: {
        return {
          ...state,
          getCDSitesUsageLineChart: action.payload,
          setCaptiveDashUsageLineChartLoading: false
        }
      }
      case SET_CAPTIVE_DASHBOARD_SITES_TABLE: {
        return {
          ...state,
          setCaptiveDashSitesTableLoading: action.payload
        }
      }
      case GET_CAPTIVE_DASHBOARD_SITES_TABLE: {
        return {
          ...state,
          getCDSitesTable: action.payload,
          setCaptiveDashSitesTableLoading: false
        }
      }
      case SET_CAPTIVE_DASHBOARD_TOP_SITES_SUBSCRIBERS_BAR: {
        return {
          ...state,
          setCaptiveDashTopSitesSubscribersBarLoading: action.payload
        }
      }
      case GET_CAPTIVE_DASHBOARD_TOP_SITES_SUBSCRIBERS_BAR: {
        return {
          ...state,
          getCDTopSitesSubscribersBar: action.payload,
          setCaptiveDashTopSitesSubscribersBarLoading: false
        }
      }
      case SET_CAPTIVE_DASHBOARD_TOP_SITES_SESSIONS_BAR: {
        return {
          ...state,
          setCaptiveDashTopSitesSessionsBarLoading: action.payload
        }
      }
      case GET_CAPTIVE_DASHBOARD_TOP_SITES_SESSIONS_BAR: {
        return {
          ...state,
          getCDTopSitesSessionsBar: action.payload,
          setCaptiveDashTopSitesSessionsBarLoading: false
        }
      }
      case SET_CAPTIVE_DASHBOARD_SUBSCRIBERS_SESSIONS_TABLE: {
        return {
          ...state,
          setCaptiveDashSubscribersSessionsTableLoading: action.payload
        }
      }
      case GET_CAPTIVE_DASHBOARD_SUBSCRIBERS_SESSIONS_TABLE: {
        return {
          ...state,
          getCDSubscribersSessionsTable: action.payload,
          setCaptiveDashSubscribersSessionsTableLoading: false
        }
      }
      case SET_CAPTIVE_DASHBOARD_TOP_PLANS_USERS_BAR: {
        return {
          ...state,
          setCaptiveDashTopPlansUsersBarLoading: action.payload
        }
      }
      case GET_CAPTIVE_DASHBOARD_TOP_PLANS_USERS_BAR: {
        return {
          ...state,
          getCDTopPlansUsersBar: action.payload,
          setCaptiveDashTopPlansUsersBarLoading: false
        }
      }
      case SET_CAPTIVE_DASHBOARD_TOP_PLANS_USAGE_BAR: {
        return {
          ...state,
          setCaptiveDashTopPlansUsageBarLoading: action.payload
        }
      }
      case GET_CAPTIVE_DASHBOARD_TOP_PLANS_USAGE_BAR: {
        return {
          ...state,
          getCDTopPlansUsageBar: action.payload,
          setCaptiveDashTopPlansUsageBarLoading: false
        }
      }
      case SET_CAPTIVE_DASHBOARD_TOP_PLANS_OVERAGE_USAGE_BAR: {
        return {
          ...state,
          captiveTopPlansOverageUsagebarLoading: action.payload,
        }
      }
      case GET_CAPTIVE_DASHBOARD_TOP_PLANS_OVERAGE_USAGE_BAR: {
        return {
          ...state,
          captiveTopPlansOverageUsagebar: action.payload,
          captiveTopPlansOverageUsagebarLoading: false,
        }
      }
      case SET_CAPTIVE_DASHBOARD_EVENTS_SUBSCRIBERS_PLAN_USAGE: {
        return {
          ...state,
          setCaptiveDashEventsSubscribersPlanUsageTableLoading: action.payload
        }
      }
      case GET_CAPTIVE_DASHBOARD_EVENTS_SUBSCRIBERS_PLAN_USAGE: {
        return {
          ...state,
          getCDEventsSubscribersPlanUsageTable: action.payload,
          setCaptiveDashEventsSubscribersPlanUsageTableLoading: false
        }
      }
      case SET_CAPTIVE_DASHBOARD_TOP_SUBSCRIBERS_USAGE_BAR: {
        return {
          ...state,
          setCaptiveDashTopSubscribersUsageBarLoading: action.payload
        }
      }
      case GET_CAPTIVE_DASHBOARD_TOP_SUBSCRIBERS_USAGE_BAR: {
        return {
          ...state,
          getCDTopSubscribersUsageBar: action.payload,
          setCaptiveDashTopSubscribersUsageBarLoading: false
        }
      }
      case SET_CAPTIVE_DASHBOARD_TOP_SUBSCRIBERS_OVERAGE_USAGE_BAR: {
        return {
          ...state,
          captiveSubscribersOverageUsagebarLoading: action.payload,
        }
      }
      case GET_CAPTIVE_DASHBOARD_TOP_SUBSCRIBERS_OVERAGE_USAGE_BAR: {
        return {
          ...state,
          captiveSubscribersOverageUsagebar: action.payload,
          captiveSubscribersOverageUsagebarLoading: false,
        }
      }
      case SET_CAPTIVE_DASHBOARD_TOP_SUBSCRIBERS_SESSIONS_BAR: {
        return {
          ...state,
          setCaptiveDashTopSubscribersSessionsBarLoading: action.payload
        }
      }
      case GET_CAPTIVE_DASHBOARD_TOP_SUBSCRIBERS_SESSIONS_BAR: {
        return {
          ...state,
          getCDTopSubscribersSessionsBar: action.payload,
          setCaptiveDashTopSubscribersSessionsBarLoading: false
        }
      }
      case SET_CAPTIVE_DASHBOARD_PLANS_SUBSCRIBERS_HISTOGRAM: {
        return {
          ...state,
          setCaptiveDashPlansSubscribersHistogramLoading: action.payload
        }
      }
      case GET_CAPTIVE_DASHBOARD_PLANS_SUBSCRIBERS_HISTOGRAM: {
        return {
          ...state,
          getCDPlansSubscribersHistogram: action.payload,
          setCaptiveDashPlansSubscribersHistogramLoading: false
        }
      }
      case SET_CAPTIVE_DASHBOARD_PLANS_SUBSCRIBERS_OVERAGE_HISTOGRAM: {
        return {
          ...state,
          captivePlanSubscribersOverageHistogramLoading: action.payload,
        }
      }
      case GET_CAPTIVE_DASHBOARD_PLANS_SUBSCRIBERS_OVERAGE_HISTOGRAM: {
        return {
          ...state,
          captivePlanSubscribersOverageHistogram: action.payload,
          captivePlanSubscribersOverageHistogramLoading: false,
        }
      }
      case SET_CAPTIVE_DASHBOARD_PLANS_USAGE_LINE_CHART: {
        return {
          ...state,
          setCaptiveDashPlansUsageLineChartLoading: action.payload
        }
      }
      case GET_CAPTIVE_DASHBOARD_PLANS_USAGE_LINE_CHART: {
        return {
          ...state,
          getCDPlansUsageLineChart: action.payload,
          setCaptiveDashPlansUsageLineChartLoading: false
        }
      }
      case SET_CAPTIVE_DASHBOARD_PLANS_OVERAGE_USAGE_LINE_CHART: {
        return {
          ...state,
          captiveTopPlanOverageUsagelinechartLoading: action.payload
        }
      }
      case GET_CAPTIVE_DASHBOARD_PLANS_OVERAGE_USAGE_LINE_CHART: {
        return {
          ...state,
          captiveTopPlanOverageUsagelinechart: action.payload,
          captiveTopPlanOverageUsagelinechartLoading: false,
        }
      }
      case SET_CAPTIVE_DASHBOARD_SUBSCRIBERS_LIST: {
        return {
          ...state,
          setCaptiveDashSubscribersListLoading: action.payload
        }
      }
      case GET_CAPTIVE_DASHBOARD_SUBSCRIBERS_LIST: {
        return {
          ...state,
          getCDSubscribersList: action.payload,
          setCaptiveDashSubscribersListLoading: false
        }
      }
      case SET_CAPTIVE_DASHBOARD_PLANS_LIST: {
        return {
          ...state,
          setCaptiveDashPlansListLoading: action.payload
        }
      }
      case GET_CAPTIVE_DASHBOARD_PLANS_LIST: {
        return {
          ...state,
          getCDPlansList: action.payload,
          setCaptiveDashPlansListLoading: false
        }
      }
      case SET_CAPTIVE_DASHBOARD_SUBSCRIBER_SESSIONS_TABLE: {
        return {
          ...state,
          setCaptiveDashUserSessionsTableLoading: action.payload
        }
      }
      case GET_CAPTIVE_DASHBOARD_SUBSCRIBER_SESSIONS_TABLE: {
        return {
          ...state,
          getCDUserSessionsTable: action.payload,
          setCaptiveDashUserSessionsTableLoading: false
        }
      }
      case SET_CAPTIVE_DASHBOARD_EVENTS_TABLE: {
        return {
          ...state,
          setCaptiveDashEventsTableLoading: action.payload
        }
      }
      case GET_CAPTIVE_DASHBOARD_EVENTS_TABLE: {
        return {
          ...state,
          getCDEventsTable: action.payload,
          setCaptiveDashEventsTableLoading: false
        }
      }
      case SET_CAPTIVE_DASHBOARD_EVENTS_IP_MAC_LIST: {
        return {
          ...state,
          setCaptiveDashIpMacListLoading: action.payload
        }
      }
      case GET_CAPTIVE_DASHBOARD_EVENTS_IP_MAC_LIST: {
        return {
          ...state,
          getCDIpMacList: action.payload,
          setCaptiveDashIpMacListLoading: false
        }
      }
      case SET_CAPTIVE_DASHBOARD_PLANS_SUBSCRIBERS_LINE_CHART: {
        return {
          ...state,
          setCaptiveDashPlansSubscribersLineChartLoading: action.payload
        }
      }
      case GET_CAPTIVE_DASHBOARD_PLANS_SUBSCRIBERS_LINE_CHART: {
        return {
          ...state,
          getCDPlansSubscribersLineChart: action.payload,
          setCaptiveDashPlansSubscribersLineChartLoading: false
        }
      }
      case SET_CAPTIVE_DASHBOARD_SITES_HISTOGRAM: {
        return {
          ...state,
          setCaptiveDashSitesHistogramLoading: action.payload
        }
      }
      case GET_CAPTIVE_DASHBOARD_SITES_HISTOGRAM: {
        return {
          ...state,
          getCDSitesHistogram: action.payload,
          setCaptiveDashSitesHistogramLoading: false
      }
    }
    case SET_CAPTIVE_DASHBOARD_SITES_OVERAGE_HISTOGRAM: {
      return {
        ...state,
        captiveSitesOverageHistogramLoading: action.payload,
      }
    }
    case GET_CAPTIVE_DASHBOARD_SITES_OVERAGE_HISTOGRAM: {
      return {
        ...state,
        captiveSitesOverageHistogram: action.payload,
        captiveSitesOverageHistogramLoading: false,
      }
    }
    case GET_ORG_HIRARCHY: {
      return {
        ...state,
        orgHirarchy: action.payload,
      }
    }
    case GET_NETWORK_TOPOLOGY_SITE_DETAILS: {
      return {
        ... state,
        networkTopologySiteSetails: action?.payload,
        networkTopologySiteSetailsLoading: false
      }
    }
    case GET_NETWORK_TOPOLOGY_SITE_DETAILS_LOADING: {
      return {
        ...state,
        networkTopologySiteSetailsLoading: action?.payload
      }
    }
    case GET_NETWORK_TOPOLOGY_DEVICE_INFO: {
      return {
        ...state,
        networkTopologyDeviceInfo : action?.payload,
        networkTopologyDeviceInfoLoading: false
      }
    }
    case SET_NETWORK_TOPOLOGY_DEVICE_INFO_LOADING: {
      return {
        ...state,
        networkTopologyDeviceInfoLoading: action?.payload
      }
    }
    case SET_TOPOLOGY_TREE_TOP_WIDGET_LOADING: {
      return {
        ...state,
        networkTopologyTopcardsLoading: action?.payload
      }
    }
    case GET_TOPOLOGY_TREE_TOP_WIDGET: {
      return {
        ...state,
        netoworkTopologyTopcards: action?.payload,
        networkTopologyTopcardsLoading: false
      }
    }
    case RESET_NETWORK_TOPOLOGY_DEVICE_INFO: {
      return {
        ...state,
        networkTopologyDeviceInfo: {},
        networkTopologyDeviceInfoLoading: false
      }
    }
    case NETWORK_TOPOLOGY_DEVICE_DETAILS: {
      return {
        ...state,
        networkTopologyPerDeviceDetails: action?.payload
      }
    }
    case SET_TRENDS_LAN_USAGE_TOPWIDGET_USAGE_LOADING: {
      return {
        ...state,
        setTrendsLanUsageTopWidgetUsageLoading: action?.payload
      }
    }
    case GET_TRENDS_LAN_USAGE_TOPWIDGET_USAGE: {
      return {
        ...state,
        getTrendsLanUsageTopWidgetUsage: action?.payload,
        setTrendsLanUsageTopWidgetUsageLoading: false
      }
    }
    case SET_TRENDS_LAN_USAGE_WIFI_TOPWIDGET_USAGE_LOADING: {
      return {
        ...state,
        setTrendsLanUsageWifiTopWidgetUsageLoading: action?.payload
      }
    }
    case GET_TRENDS_LAN_USAGE_WIFI_TOPWIDGET_USAGE: {
      return {
        ...state,
        getTrendsLanUsageWifiTopWidgetUsage: action?.payload,
        setTrendsLanUsageWifiTopWidgetUsageLoading: false
      }
    }

    case SET_TRENDS_LAN_NETWORK_TABLE_LOADING: {
      return {
        ...state,
        isLanNetworkTableLoading: action.payload,
      }
    }
    case SET_TRENDS_LAN_CLIENT_TABLE_LOADING: {
      return {
        ...state,
        isLanClientTableLoading: action.payload,
      }
    }
    case SET_TRENDS_LAN_WIFI_CLIENT_TABLE_LOADING: {
      return {
        ...state,
        isLanWifiClientTableLoading: action.payload,
      }
    }
    case SET_TRENDS_LAN_WIFI_CLIENT_AP_TABLE_LOADING: {
      return {
        ...state,
        isLanWifiApClientTableLoading: action.payload,
      }
    }
    case GET_TRENDS_LAN_WIFI_AP_CLIENT_TABLE_COUNT: {
      return {
        ...state,
        lanWifiApClientTableCount: action.payload,
        setLanWifiApClientTableCountLoading: false,
      }
    }

    case SET_LAN_CLIENT_TABLE_COUNT:
      return {
        ...state,
        lanClientTableCount: action.payload,
      };
    case SET_LAN_WIFI_CLIENT_TABLE_COUNT:
      return {
        ...state,
        lanWifiClientTableCount: action.payload,
      };
    case SET_LAN_NETWORK_TABLE_COUNT:
      return {
        ...state,
        lanNetworkTableCount: action.payload,
      };
    case SET_OPEN_EDGE_SOFTWARE_UPDATE_LOADING:
      return {
        ...state,
        setOpenEdgeSoftwareUpdateLoading: action.payload,
      };
    case GET_OPEN_EDGE_SOFTWARE_UPDATE:
      return {
        ...state,
        getOpenEdgeSoftwareUpdate: action.payload,
        setOpenEdgeSoftwareUpdateLoading: false
      };
    case SET_OPEN_EDGE_SOFTWARE_UPDATE_STATUS_LOADING:
      return {
        ...state,
        setOpenEdgeSoftwareUpdateStatusLoading: action.payload,
      };
    case GET_OPEN_EDGE_SOFTWARE_UPDATE_STATUS:
      return {
        ...state,
        getOpenEdgeSoftwareUpdateStatus: action.payload,
        setOpenEdgeSoftwareUpdateStatusLoading: false
      };


    case SET_LAN_TABLE_DATA: {
      const { topic, data } = action.payload;
      return {
        ...state,
        trendsLanTableData: {
          ...(state.trendsLanTableData || {}),
          [topic]: data,
        },
      };
    }

    case SET_ANALYTICS_TOP_CARDS_LOADING: {
        return {
          ...state,
          setAnalyticsTopCardsLoading: action.payload
        }
      }
      case GET_ANALYTICS_TOP_CARDS: {
        return {
            ...state,
            getAnalyticsTopCards: {
                ...state.getAnalyticsTopCards,
                ...action.payload
            },
            setAnalyticsTopCardsLoading: false
        };
      }
    case SET_ANALYTICS_BAR_CHART_LOADING: {
      return {
        ...state,
        setAnalyticsBarChartLoading: action.payload
      }
    }
    case GET_ANALYTICS_BAR_CHART: {
      return {
        ...state,
        getAnalyticsLeftChart: action.payload,
        setAnalyticsBarChartLoading: false
      }
    }
    case SET_ANALYTICS_LINE_CHART_LOADING: {
      return {
        ...state,
        setAnalyticsLineChartLoading: action.payload
      }
    }
    case GET_ANALYTICS_LINE_CHART: {
      return {
        ...state,
        getAnalyticsRightChart: action.payload,
        setAnalyticsLineChartLoading: false
      }
    }
    case SET_ANALYTICS_TABLE_LOADING: {
      return {
        ...state,
        setAnalyticsTableLoading: action.payload
      }
    }
    case GET_ANALYTICS_TABLE: {
      return {
        ...state,
        getAnalyticsTable: action.payload,
        setAnalyticsTableLoading: false
      }
    }
    case UPGRADE_DEVICE_TO_LATEST_EOS_VERSION: {
      return {
        ...state,
        upgradeToLatestDevice: action.payload,
        upgradeToLatestDeviceLoading: false
      }
    }
    case UPGRADE_DEVICE_TO_LATEST_EOS_VERSION_LOADING: {
      return {
        ...state,
        upgradeToLatestDeviceLoading: action.payload
      }
    }
     case GET_IS_AM_AVAILABLE: {
        return {
          ...state,
          isAMavailable: action.payload,
        }
      }
      case SET_FECTH_MODEM_DETAILS_LOADING: {
        return {
          ...state,
          fetchModemDetailsLoader: action.payload,
        }
      }
       case GET_MODEM_DETAILS: {
        return {
          ...state,
          modemDetails: action.payload,
          fetchModemDetailsLoader: false
        }
      }
       case GET_SIM_DETAILS: {
        return {
          ...state,
          simDetails : action.payload,
        }
      }
       case TRIGGER_TOWER_SCAN: {
        return {
          ...state,
          towerScan: action.payload,
        }
      }
       case GET_TOWER_SCAN_RESULTS: {
        return {
          ...state,
          towerScanResults: action.payload,
        }
      }
       case GET_SIM_PRIORITY_DETAILS: {
        return {
          ...state,
          getSimPriorityStatus: action.payload,
        }
      }
       case UPDATE_SIM_PRIORITY_DETAILS: {
        return {
          ...state,
          simPriorityDetails: action.payload,
        }
      }
       case RELOAD_SIM_DETAILS: {
        return {
          ...state,
          reloadSim: action.payload,
        }
      }
       case RESET_MODEM: {
        return {
          ...state,
          resetModemState: action.payload,
        }
      }
       case UPDATE_SIM_SETTINGS: {
        return {
          ...state,
          updatedSimSettings: action.payload,
        }
      }
    case UPDATE_AM_CONTROLLER_ACTION_STATUS: {
        return {
          ...state,
          amControllerActionStatus: action.payload,
        }
      }
    case FETCH_FIREWALL_PROTOCOLS_LOADING: {
        return {
          ...state,
          fetchFwProtoLoading: action.payload,
        }
      }
    case FETCH_FIREWALL_PROTOCOLS: {
        return {
          ...state,
          fetchFwProtocols: action.payload,
          fetchFwProtoLoading: false,
        }
      }
    case GET_ALL_HUB_CLIENTS_LOADING: {
        return {
          ...state,
          getAllHubClientsLoading: action.payload,
        }
      }
    case GET_ALL_HUB_CLIENTS: {
        return {
          ...state,
          getAllHubClients: action.payload,
          getAllHubClientsLoading: false,
        }
      }
    case SELECT_HUB_CLIENT_LOADING: {
        return {
          ...state,
          selectHubClientLoading: action.payload,
        }
      }
    case SELECT_HUB_CLIENT: {
        return {
          ...state,
          selectHubClient: action.payload,
          selectHubClientLoading: false,
        }
      }
    case GET_HUB_MTD_USAGE_LOADING: {
        return { ...state, hubMtdUsageLoading: action.payload }
      }
    case GET_HUB_MTD_USAGE: {
        return { ...state, hubMtdUsage: action.payload, hubMtdUsageLoading: false }
      }
    case GET_HUB_SERVER_STATUS_LOADING: {
        return { ...state, hubServerStatusLoading: action.payload }
      }
    case GET_HUB_SERVER_STATUS: {
        return { ...state, hubServerStatus: action.payload, hubServerStatusLoading: false }
      }
    case GET_ACTIVE_HUB_CLIENT_LOADING: {
        return { ...state, activeHubClientLoading: action.payload }
      }
    case GET_ACTIVE_HUB_CLIENT: {
        return { ...state, activeHubClient: action.payload, activeHubClientLoading: false }
      }
    case CREATE_PRIVATE_HUB_SERVER_LOADING: {
        return { ...state, createPrivateHubServerLoading: action.payload }
      }
    case CREATE_PRIVATE_HUB_SERVER: {
        return { ...state, createPrivateHubServer: action.payload, createPrivateHubServerLoading: false }
      }
    case GET_PRIVATE_HUB_SERVERS_LOADING: {
        return { ...state, getPrivateHubServersLoading: action.payload }
      }
    case GET_PRIVATE_HUB_SERVERS: {
        return { ...state, getPrivateHubServers: action.payload, getPrivateHubServersLoading: false }
      }
    case DELETE_PRIVATE_HUB_SERVER_LOADING: {
        return { ...state, deletePrivateHubServerLoading: action.payload }
      }
    case DELETE_PRIVATE_HUB_SERVER: {
        return { ...state, deletePrivateHubServer: action.payload, deletePrivateHubServerLoading: false }
      }
    case UPDATE_PRIVATE_HUB_SERVER_LOADING: {
        return { ...state, updatePrivateHubServerLoading: action.payload }
      }
    case UPDATE_PRIVATE_HUB_SERVER: {
        return { ...state, updatePrivateHubServer: action.payload, updatePrivateHubServerLoading: false }
      }

    default:
      return state;
  }
}